import { type SVGProps } from "react";

export const LogoIcon = (props?: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    {...props}
  >
    <path
      d="M27.5394 15.5391C27.6998 15.5391 27.8303 15.6692 27.8304 15.8301V22.2363C27.8303 22.3905 27.7478 22.5323 27.6146 22.6094L15.9584 29.3613C15.7645 29.4737 15.5219 29.3326 15.5219 29.1084V27.2744L19.6595 23.123L19.2797 22.7412L15.5219 26.5107V21.1309C15.5219 18.043 18.0174 15.5391 21.0961 15.5391H27.5394ZM23.0385 19.0771C22.1637 19.4126 21.1882 19.4126 20.3129 19.0771C20.1621 19.0192 20.0122 19.1711 20.0697 19.3223C20.4039 20.2002 20.4045 21.1777 20.0697 22.0557C20.0116 22.2069 20.1615 22.3581 20.3129 22.3008C21.1882 21.9647 22.1631 21.9653 23.0385 22.3008C23.1893 22.3591 23.3401 22.207 23.2826 22.0557C22.9483 21.1782 22.9483 20.2003 23.2826 19.3223C23.3407 19.1709 23.1893 19.0194 23.0385 19.0771Z"
      fill="url(#paint0_linear_6493_13900)"
    />
    <path
      d="M14.225 0.639136C14.4187 0.526761 14.6613 0.6674 14.6615 0.892066V8.87058C14.6612 11.9589 12.1652 14.4614 9.08728 14.4614H5.45642L9.40564 10.4995L9.02576 10.1177L4.6947 14.4614H2.64392C2.48363 14.4612 2.35402 14.3312 2.35388 14.1704V7.76511C2.35388 7.61136 2.43545 7.46827 2.56873 7.39109L14.225 0.639136ZM10.9301 7.60105C10.2494 7.60126 9.69763 8.15545 9.69763 8.83836C9.69788 9.52105 10.2495 10.0745 10.9301 10.0747C11.6108 10.0747 12.1632 9.52117 12.1635 8.83836C12.1635 8.15532 11.6109 7.60105 10.9301 7.60105Z"
      fill="url(#paint1_linear_6493_13900)"
    />
    <path
      d="M13.4144 17.6113C14.194 18.5739 14.6605 19.7976 14.6605 21.1309V27.375L13.2445 28.7949L13.7279 29.0742L14.6605 28.1387V29.1094C14.6605 29.3318 14.4185 29.4725 14.224 29.3613L13.7269 29.0742L12.9105 28.6016L12.4877 28.3555L6.28357 24.7646L13.4144 17.6113ZM14.6615 28.1377L14.6605 28.1387V27.375L14.6615 27.374V28.1377ZM5.80212 24.4844L5.88513 24.5332L6.28357 24.7646L5.88416 24.5332L5.80115 24.4844V24.4834L5.80212 24.4844ZM9.08728 15.5391C10.5 15.5391 11.7904 16.0685 12.7748 16.9424C12.8717 17.0262 12.9664 17.1156 13.056 17.208L13.1674 17.3262C13.1311 17.2861 13.0931 17.2468 13.0551 17.208L5.80115 24.4834L5.52283 24.3232L2.56775 22.6113C2.4364 22.5336 2.35304 22.3893 2.35291 22.2363V17.5752L4.3822 15.5391H9.08728ZM2.35291 16.8115V15.8301C2.35311 15.6686 2.48441 15.5391 2.64294 15.5391H3.62146L2.35291 16.8115Z"
      fill="url(#paint2_linear_6493_13900)"
    />
    <path
      d="M15.5219 0.892041C15.5221 0.667376 15.7646 0.526796 15.9584 0.639111L27.6146 7.39106C27.7478 7.46817 27.8303 7.61053 27.8304 7.76411V14.1704C27.8303 14.3312 27.6998 14.4613 27.5394 14.4614H21.0961C19.8196 14.4614 18.6441 14.0315 17.7045 13.3071L20.5043 10.4985L20.1234 10.1166L17.2924 12.9575C16.2025 11.9377 15.5219 10.4831 15.5219 8.86958V0.892041ZM21.6869 5.57563C21.5252 5.56713 21.5078 5.70357 21.5023 5.83052C21.4854 6.20063 21.4854 6.57198 21.4291 6.94087C21.2697 7.98588 20.7419 8.50187 19.6976 8.60395C19.376 8.63494 19.0527 8.64738 18.7299 8.66743C18.604 8.67533 18.4349 8.64397 18.431 8.82759C18.4268 9.03179 18.6089 9.00448 18.7416 9.0063C19.1855 9.01177 19.6292 9.03376 20.0629 9.14009C20.8726 9.33883 21.2855 9.80529 21.4164 10.6352C21.4788 11.0308 21.4898 11.429 21.5013 11.8276C21.505 11.9533 21.5171 12.0716 21.6683 12.0991C21.8396 12.073 21.8394 11.9479 21.8412 11.8247C21.8472 11.3877 21.8723 10.9523 21.9613 10.5239C22.137 9.67816 22.5936 9.24447 23.4506 9.10102C23.8346 9.03661 24.2212 9.00813 24.6107 9.0063C24.7464 9.00569 24.9263 9.02376 24.9203 8.82563C24.9148 8.65017 24.7469 8.67271 24.6185 8.66548C24.3047 8.64846 23.9903 8.63447 23.6771 8.60591C22.5942 8.50619 22.0201 7.94083 21.9086 6.85688C21.8734 6.51669 21.8618 6.17254 21.8412 5.83052C21.8339 5.71571 21.8309 5.58304 21.6869 5.57563Z"
      fill="url(#paint3_linear_6493_13900)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_6493_13900"
        x1="15.5219"
        y1="22.4699"
        x2="27.8304"
        y2="22.4699"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#1A6DFF" />
        <stop offset="1" stopColor="#2F4AD1" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_6493_13900"
        x1="2.35388"
        y1="7.5305"
        x2="14.6615"
        y2="7.5305"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#2F4AD1" />
        <stop offset="1" stopColor="#1A6DFF" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_6493_13900"
        x1="2.35291"
        y1="22.4696"
        x2="14.6615"
        y2="22.4696"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#2F4AD1" />
        <stop offset="1" stopColor="#1A6DFF" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_6493_13900"
        x1="15.5219"
        y1="7.53049"
        x2="27.8304"
        y2="7.53049"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#1A6DFF" />
        <stop offset="1" stopColor="#2F4AD1" />
      </linearGradient>
    </defs>
  </svg>
);

export const LogoTextIcon = (props?: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="61"
    height="23"
    viewBox="0 0 61 23"
    fill="none"
    {...props}
  >
    <path
      d="M53.2737 18.6889C52.1342 18.6889 51.1068 18.4041 50.1917 17.8343C49.2766 17.2645 48.5601 16.4875 48.0421 15.5033C47.5241 14.5192 47.2651 13.4141 47.2651 12.1882C47.2651 10.9451 47.5241 9.83139 48.0421 8.84722C48.5601 7.86305 49.2766 7.08607 50.1917 6.51628C51.1068 5.9465 52.1342 5.66161 53.2737 5.66161C54.1716 5.66161 54.9744 5.8429 55.6824 6.20549C56.3903 6.56808 56.9514 7.07743 57.3658 7.73355C57.7975 8.3724 58.0306 9.09758 58.0651 9.90909V14.4156C58.0306 15.2443 57.7975 15.9782 57.3658 16.617C56.9514 17.2558 56.3903 17.7652 55.6824 18.1451C54.9744 18.5077 54.1716 18.6889 53.2737 18.6889ZM53.8953 15.5551C54.8449 15.5551 55.6133 15.2443 56.2003 14.6228C56.7874 13.9839 57.0809 13.1638 57.0809 12.1623C57.0809 11.5062 56.9428 10.9278 56.6665 10.4271C56.4075 9.90909 56.0363 9.51197 55.5529 9.23571C55.0867 8.94218 54.5341 8.79542 53.8953 8.79542C53.2737 8.79542 52.7212 8.94218 52.2377 9.23571C51.7716 9.51197 51.4003 9.90909 51.1241 10.4271C50.8651 10.9278 50.7356 11.5062 50.7356 12.1623C50.7356 12.8357 50.8651 13.4314 51.1241 13.9494C51.4003 14.4501 51.7716 14.8472 52.2377 15.1407C52.7212 15.417 53.2737 15.5551 53.8953 15.5551ZM56.8996 18.43V15.063L57.4435 12.0069L56.8996 9.00261V5.9206H60.2665V18.43H56.8996Z"
      fill="url(#paint0_linear_6493_13897)"
    />
    <path
      d="M37.6217 18.43V5.9206H41.0145V18.43H37.6217ZM41.0145 11.5148L39.6936 10.6343C39.849 9.09758 40.298 7.88894 41.0404 7.00837C41.7829 6.11053 42.8534 5.66161 44.2519 5.66161C44.8562 5.66161 45.4001 5.7652 45.8836 5.9724C46.367 6.16232 46.8073 6.48175 47.2044 6.93067L45.0807 9.3652C44.8908 9.15801 44.6577 9.00261 44.3814 8.89902C44.1224 8.79542 43.8203 8.74362 43.4749 8.74362C42.7498 8.74362 42.1541 8.97671 41.6879 9.4429C41.239 9.89182 41.0145 10.5825 41.0145 11.5148Z"
      fill="url(#paint1_linear_6493_13897)"
    />
    <path
      d="M29.3942 18.4299V0.714844H32.787V18.4299H29.3942ZM26.4675 8.89901V5.9206H35.7136V8.89901H26.4675Z"
      fill="url(#paint2_linear_6493_13897)"
    />
    <path
      d="M20.3466 18.7148C19.6386 18.7148 18.9394 18.6199 18.2487 18.43C17.5753 18.24 16.9538 17.981 16.384 17.653C15.8142 17.3077 15.3221 16.8933 14.9077 16.4098L16.9279 14.3638C17.3595 14.8472 17.8602 15.2098 18.43 15.4515C18.9998 15.6933 19.63 15.8141 20.3207 15.8141C20.8732 15.8141 21.2876 15.7364 21.5638 15.581C21.8574 15.4256 22.0041 15.1925 22.0041 14.8818C22.0041 14.5364 21.8487 14.2688 21.5379 14.0789C21.2444 13.8889 20.8559 13.7335 20.3725 13.6127C19.889 13.4746 19.3797 13.3278 18.8444 13.1724C18.3264 12.9997 17.8257 12.7839 17.3422 12.5249C16.8588 12.2487 16.4617 11.8774 16.1509 11.4112C15.8574 10.9278 15.7106 10.3062 15.7106 9.5465C15.7106 8.75226 15.9005 8.06161 16.2804 7.47456C16.6775 6.88751 17.2386 6.42995 17.9638 6.1019C18.689 5.77384 19.5437 5.60981 20.5279 5.60981C21.5638 5.60981 22.4962 5.7911 23.325 6.15369C24.171 6.51628 24.8703 7.06017 25.4228 7.78535L23.3768 9.83139C22.9969 9.3652 22.5653 9.02851 22.0818 8.82132C21.6156 8.61413 21.1063 8.51053 20.5538 8.51053C20.053 8.51053 19.6645 8.58823 19.3883 8.74362C19.1293 8.89902 18.9998 9.11485 18.9998 9.3911C18.9998 9.7019 19.1466 9.94362 19.4401 10.1163C19.7509 10.2889 20.148 10.4443 20.6315 10.5825C21.1149 10.7033 21.6156 10.8501 22.1336 11.0228C22.6689 11.1782 23.1696 11.4026 23.6358 11.6961C24.1192 11.9897 24.5077 12.3782 24.8012 12.8616C25.112 13.3451 25.2674 13.9666 25.2674 14.7264C25.2674 15.9523 24.8271 16.9278 23.9466 17.653C23.066 18.3609 21.866 18.7148 20.3466 18.7148Z"
      fill="url(#paint3_linear_6493_13897)"
    />
    <path
      d="M6.05307 18.6889C4.9135 18.6889 3.88616 18.4041 2.97105 17.8343C2.05594 17.2645 1.3394 16.4875 0.821412 15.5033C0.303426 14.5192 0.0444336 13.4141 0.0444336 12.1882C0.0444336 10.9451 0.303426 9.83139 0.821412 8.84722C1.3394 7.86305 2.05594 7.08607 2.97105 6.51628C3.88616 5.9465 4.9135 5.66161 6.05307 5.66161C6.95091 5.66161 7.75378 5.8429 8.4617 6.20549C9.16961 6.56808 9.73076 7.07743 10.1452 7.73355C10.5768 8.3724 10.8099 9.09758 10.8444 9.90909V14.4156C10.8099 15.2443 10.5768 15.9782 10.1452 16.617C9.73076 17.2558 9.16961 17.7652 8.4617 18.1451C7.75378 18.5077 6.95091 18.6889 6.05307 18.6889ZM6.67465 15.5551C7.62429 15.5551 8.39263 15.2443 8.97968 14.6228C9.56673 13.9839 9.86026 13.1638 9.86026 12.1623C9.86026 11.5062 9.72213 10.9278 9.44587 10.4271C9.18688 9.90909 8.81565 9.51197 8.3322 9.23571C7.86601 8.94218 7.3135 8.79542 6.67465 8.79542C6.05307 8.79542 5.50055 8.94218 5.01709 9.23571C4.55091 9.51197 4.17968 9.90909 3.90343 10.4271C3.64443 10.9278 3.51494 11.5062 3.51494 12.1623C3.51494 12.8357 3.64443 13.4314 3.90343 13.9494C4.17968 14.4501 4.55091 14.8472 5.01709 15.1407C5.50055 15.417 6.05307 15.5551 6.67465 15.5551ZM9.67896 18.43V15.063L10.2228 12.0069L9.67896 9.00261V5.9206H13.0459V18.43H9.67896Z"
      fill="url(#paint4_linear_6493_13897)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_6493_13897"
        x1="0.0444336"
        y1="9.71484"
        x2="60.2665"
        y2="9.71484"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#1A6DFF" />
        <stop offset="1" stopColor="#2F4AD1" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_6493_13897"
        x1="0.0444336"
        y1="9.71484"
        x2="60.2665"
        y2="9.71484"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#1A6DFF" />
        <stop offset="1" stopColor="#2F4AD1" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_6493_13897"
        x1="0.0444336"
        y1="9.71484"
        x2="60.2665"
        y2="9.71484"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#1A6DFF" />
        <stop offset="1" stopColor="#2F4AD1" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_6493_13897"
        x1="0.0444336"
        y1="9.71484"
        x2="60.2665"
        y2="9.71484"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#1A6DFF" />
        <stop offset="1" stopColor="#2F4AD1" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_6493_13897"
        x1="0.0444336"
        y1="9.71484"
        x2="60.2665"
        y2="9.71484"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#1A6DFF" />
        <stop offset="1" stopColor="#2F4AD1" />
      </linearGradient>
    </defs>
  </svg>
);

export const ExpandIcon = (props?: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      d="M6.41421 5H10V3H3V10H5V6.41421L9.29289 10.7071L10.7071 9.29289L6.41421 5ZM21 14H19V17.5858L14.7071 13.2929L13.2929 14.7071L17.5858 19H14V21H21V14Z"
      fill="currentColor"
    />
  </svg>
);

export const DashboardIcon = (props?: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="13"
    height="14"
    viewBox="0 0 13 14"
    fill="none"
    {...props}
  >
    <path
      d="M0 3.66602C0 5.32287 1.34315 6.66602 3 6.66602C4.65685 6.66602 6 5.32287 6 3.66602C6 2.00916 4.65685 0.666017 3 0.666017C1.34315 0.666017 0 2.00916 0 3.66602ZM0 10.3327C0 11.9896 1.34315 13.3327 3 13.3327C4.65685 13.3327 6 11.9896 6 10.3327C6 8.67582 4.65685 7.33268 3 7.33268C1.34315 7.33268 0 8.67582 0 10.3327ZM6.66667 10.3327C6.66667 11.9896 8.0098 13.3327 9.66667 13.3327C11.3235 13.3327 12.6667 11.9896 12.6667 10.3327C12.6667 8.67582 11.3235 7.33268 9.66667 7.33268C8.0098 7.33268 6.66667 8.67582 6.66667 10.3327ZM4.66667 3.66602C4.66667 4.58649 3.92047 5.33268 3 5.33268C2.07953 5.33268 1.33333 4.58649 1.33333 3.66602C1.33333 2.74554 2.07953 1.99935 3 1.99935C3.92047 1.99935 4.66667 2.74554 4.66667 3.66602ZM4.66667 10.3327C4.66667 11.2532 3.92047 11.9994 3 11.9994C2.07953 11.9994 1.33333 11.2532 1.33333 10.3327C1.33333 9.41222 2.07953 8.66602 3 8.66602C3.92047 8.66602 4.66667 9.41222 4.66667 10.3327ZM11.3333 10.3327C11.3333 11.2532 10.5871 11.9994 9.66667 11.9994C8.7462 11.9994 8 11.2532 8 10.3327C8 9.41222 8.7462 8.66602 9.66667 8.66602C10.5871 8.66602 11.3333 9.41222 11.3333 10.3327ZM10.0168 6.43602L10.2017 6.01175C10.5313 5.25534 11.1251 4.65308 11.8659 4.3236L12.4356 4.07022C12.7437 3.93322 12.7437 3.48495 12.4356 3.34794L11.8978 3.10872C11.1379 2.77077 10.5335 2.14622 10.2095 1.3641L10.0197 0.905651C9.88727 0.586137 9.446 0.586137 9.31367 0.905651L9.12373 1.3641C8.7998 2.14622 8.19547 2.77077 7.4356 3.10872L6.89773 3.34794C6.58967 3.48495 6.58967 3.93322 6.89773 4.07022L7.4674 4.3236C8.20827 4.65308 8.80193 5.25534 9.1316 6.01175L9.31653 6.43602C9.45187 6.74662 9.88147 6.74662 10.0168 6.43602Z"
      fill="currentColor"
    />
  </svg>
);

export const AgentIcon = (props?: SVGProps<SVGSVGElement>) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M13.1422 6.08533L12.9778 6.46245C12.8576 6.73852 12.4757 6.73852 12.3554 6.46245L12.191 6.08533C11.898 5.4129 11.3703 4.87753 10.7118 4.58464L10.2053 4.3594C9.93151 4.23761 9.93151 3.83913 10.2053 3.71733L10.6834 3.50468C11.3589 3.20426 11.8961 2.64907 12.184 1.95381L12.3528 1.54627C12.4705 1.26225 12.8628 1.26225 12.9804 1.54627L13.1492 1.95381C13.4372 2.64907 13.9744 3.20426 14.6498 3.50468L15.1279 3.71733C15.4018 3.83913 15.4018 4.23761 15.1279 4.3594L14.6215 4.58464C13.963 4.87753 13.4352 5.4129 13.1422 6.08533ZM3.99998 3.33325C3.2636 3.33325 2.66665 3.93021 2.66665 4.66659V11.3333C2.66665 12.0697 3.2636 12.6666 3.99998 12.6666H12C12.7364 12.6666 13.3333 12.0697 13.3333 11.3333V7.99992H14.6666V11.3333C14.6666 12.806 13.4727 13.9999 12 13.9999H3.99998C2.52722 13.9999 1.33331 12.806 1.33331 11.3333V4.66659C1.33331 3.19383 2.52722 1.99992 3.99998 1.99992H8.66665V3.33325H3.99998Z"
      fill="currentColor"
    />
  </svg>
);

export const Agent2Icon = (props?: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    {...props}
  >
    <path
      d="M7.875 1.16602C7.875 1.42516 7.76236 1.65799 7.58333 1.81821V2.91602H10.5C11.4665 2.91602 12.25 3.69952 12.25 4.66602V10.4993C12.25 11.4659 11.4665 12.2493 10.5 12.2493H3.5C2.5335 12.2493 1.75 11.4659 1.75 10.4993V4.66602C1.75 3.69952 2.5335 2.91602 3.5 2.91602H6.41667V1.81821C6.23764 1.65799 6.125 1.42516 6.125 1.16602C6.125 0.682765 6.51677 0.291016 7 0.291016C7.48323 0.291016 7.875 0.682765 7.875 1.16602ZM3.5 4.08268C3.17784 4.08268 2.91667 4.34385 2.91667 4.66602V10.4993C2.91667 10.8215 3.17784 11.0827 3.5 11.0827H10.5C10.8222 11.0827 11.0833 10.8215 11.0833 10.4993V4.66602C11.0833 4.34385 10.8222 4.08268 10.5 4.08268H7.58333H6.41667H3.5ZM1.16667 5.83268H0V9.33268H1.16667V5.83268ZM12.8333 5.83268H14V9.33268H12.8333V5.83268ZM5.25 8.45768C5.73325 8.45768 6.125 8.06592 6.125 7.58268C6.125 7.09945 5.73325 6.70768 5.25 6.70768C4.76675 6.70768 4.375 7.09945 4.375 7.58268C4.375 8.06592 4.76675 8.45768 5.25 8.45768ZM8.75 8.45768C9.23323 8.45768 9.625 8.06592 9.625 7.58268C9.625 7.09945 9.23323 6.70768 8.75 6.70768C8.26677 6.70768 7.875 7.09945 7.875 7.58268C7.875 8.06592 8.26677 8.45768 8.75 8.45768Z"
      fill="currentColor"
    />
  </svg>
);

export const IntegrationIcon = (props?: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <path
      d="M12.2425 10.3566L11.2997 9.41375L12.2425 8.47095C13.5442 7.16922 13.5442 5.05866 12.2425 3.75691C10.9407 2.45516 8.83012 2.45516 7.52838 3.75691L6.58558 4.69972L5.64277 3.75691L6.58558 2.8141C8.40805 0.991654 11.3628 0.991654 13.1853 2.8141C15.0077 4.63655 15.0077 7.59129 13.1853 9.41375L12.2425 10.3566ZM10.3568 12.2422L9.41399 13.185C7.59159 15.0074 4.63679 15.0074 2.81434 13.185C0.991898 11.3626 0.991898 8.40775 2.81434 6.58534L3.75715 5.64253L4.69996 6.58534L3.75715 7.52815C2.4554 8.82989 2.4554 10.9404 3.75715 12.2422C5.0589 13.544 7.16945 13.544 8.47118 12.2422L9.41399 11.2994L10.3568 12.2422ZM9.88539 5.17113L10.8283 6.11393L6.11418 10.828L5.17136 9.88515L9.88539 5.17113Z"
      fill="currentColor"
    />
  </svg>
);
export const BillingIcon = (props?: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <path
      d="M2.00334 2H14.0033C14.3715 2 14.67 2.29847 14.67 2.66667V13.3333C14.67 13.7015 14.3715 14 14.0033 14H2.00334C1.63515 14 1.33667 13.7015 1.33667 13.3333V2.66667C1.33667 2.29847 1.63515 2 2.00334 2ZM13.3367 7.33334H2.67V12.6667H13.3367V7.33334ZM13.3367 6V3.33333H2.67V6H13.3367ZM9.33668 10H12.0033V11.3333H9.33668V10Z"
      fill="currentColor"
    />
  </svg>
);

export const AccountIcon = (props?: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <path
      d="M7.99992 1.33398C11.6818 1.33398 14.6666 4.31875 14.6666 8.00065C14.6666 11.6825 11.6818 14.6673 7.99992 14.6673C4.31802 14.6673 1.33325 11.6825 1.33325 8.00065C1.33325 4.31875 4.31802 1.33398 7.99992 1.33398ZM8.10639 10.6673C6.74945 10.6673 5.5278 11.2465 4.67509 12.1711C5.58684 12.8989 6.74258 13.334 7.99992 13.334C9.31292 13.334 10.5151 12.8595 11.4443 12.0727C10.597 11.2056 9.41452 10.6673 8.10639 10.6673ZM7.99992 2.66732C5.0544 2.66732 2.66659 5.05513 2.66659 8.00065C2.66659 9.20772 3.06759 10.3211 3.74363 11.2149C4.83751 10.0567 6.38755 9.33398 8.10639 9.33398C9.76265 9.33398 11.2621 10.005 12.3478 11.0901C12.9683 10.2184 13.3333 9.15218 13.3333 8.00065C13.3333 5.05513 10.9455 2.66732 7.99992 2.66732ZM7.99992 3.33398C9.47265 3.33398 10.6666 4.52789 10.6666 6.00065C10.6666 7.47338 9.47265 8.66732 7.99992 8.66732C6.52716 8.66732 5.33325 7.47338 5.33325 6.00065C5.33325 4.52789 6.52716 3.33398 7.99992 3.33398ZM7.99992 4.66732C7.26352 4.66732 6.66658 5.26427 6.66658 6.00065C6.66658 6.73705 7.26352 7.33398 7.99992 7.33398C8.73632 7.33398 9.33325 6.73705 9.33325 6.00065C9.33325 5.26427 8.73632 4.66732 7.99992 4.66732Z"
      fill="currentColor"
    />
  </svg>
);

export const SkillIcon = (props?: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    {...props}
  >
    <path
      d="M5.25 3.75C5.25 2.09314 6.59314 0.75 8.25 0.75C9.90683 0.75 11.25 2.09314 11.25 3.75H15C15.4142 3.75 15.75 4.08579 15.75 4.5V7.62803C15.75 7.87148 15.6318 8.09977 15.4331 8.2404C15.2342 8.38095 14.9796 8.41627 14.7501 8.33512C14.5946 8.28022 14.4266 8.25 14.25 8.25C13.4215 8.25 12.75 8.92155 12.75 9.75C12.75 10.5785 13.4215 11.25 14.25 11.25C14.4266 11.25 14.5946 11.2198 14.7501 11.1649C14.9796 11.0837 15.2342 11.1191 15.4331 11.2596C15.6318 11.4002 15.75 11.6285 15.75 11.872V15C15.75 15.4142 15.4142 15.75 15 15.75H3C2.58579 15.75 2.25 15.4142 2.25 15V4.5C2.25 4.08579 2.58579 3.75 3 3.75H5.25ZM8.25 2.25C7.42157 2.25 6.75 2.92157 6.75 3.75C6.75 3.92666 6.78023 4.09464 6.83516 4.25006C6.91629 4.47961 6.88096 4.73426 6.74039 4.93304C6.5998 5.13182 6.37149 5.25 6.12803 5.25H3.75V14.25H14.25V12.75C12.5932 12.75 11.25 11.4068 11.25 9.75C11.25 8.09317 12.5932 6.75 14.25 6.75V5.25H10.372C10.1285 5.25 9.90023 5.13182 9.7596 4.93304C9.61905 4.73426 9.58373 4.47961 9.66488 4.25006C9.71978 4.09464 9.75 3.92666 9.75 3.75C9.75 2.92157 9.07845 2.25 8.25 2.25Z"
      fill="currentColor"
    />
  </svg>
);

export const TrainingIcon = (props?: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    {...props}
  >
    <path
      d="M14.25 16.5H3.75C2.50736 16.5 1.5 15.4927 1.5 14.25V2.25C1.5 1.83579 1.83579 1.5 2.25 1.5H12.75C13.1642 1.5 13.5 1.83579 13.5 2.25V11.25H16.5V14.25C16.5 15.4927 15.4927 16.5 14.25 16.5ZM13.5 12.75V14.25C13.5 14.6642 13.8358 15 14.25 15C14.6642 15 15 14.6642 15 14.25V12.75H13.5ZM12 15V3H3V14.25C3 14.6642 3.33579 15 3.75 15H12ZM4.5 5.25H10.5V6.75H4.5V5.25ZM4.5 8.25H10.5V9.75H4.5V8.25ZM4.5 11.25H8.25V12.75H4.5V11.25Z"
      fill="currentColor"
    />
  </svg>
);

export const LeadIcon = (props?: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <g clipPath="url(#clip0_1025_947)">
      <path
        d="M12.6666 4.66602H16V5.99935H12.6666V4.66602ZM11.3333 7.99935H16V9.33268H11.3333V7.99935ZM13.3333 11.3327H16V12.666H13.3333V11.3327ZM1.33331 14.666C1.33331 11.7205 3.72113 9.33268 6.66665 9.33268C9.61218 9.33268 12 11.7205 12 14.666H10.6666C10.6666 12.4569 8.87578 10.666 6.66665 10.666C4.45751 10.666 2.66665 12.4569 2.66665 14.666H1.33331ZM6.66665 8.66602C4.45665 8.66602 2.66665 6.87602 2.66665 4.66602C2.66665 2.45602 4.45665 0.666016 6.66665 0.666016C8.87665 0.666016 10.6666 2.45602 10.6666 4.66602C10.6666 6.87602 8.87665 8.66602 6.66665 8.66602ZM6.66665 7.33268C8.13998 7.33268 9.33331 6.13935 9.33331 4.66602C9.33331 3.19268 8.13998 1.99935 6.66665 1.99935C5.19331 1.99935 3.99998 3.19268 3.99998 4.66602C3.99998 6.13935 5.19331 7.33268 6.66665 7.33268Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_1025_947">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const ConversationIcon = (props?: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    {...props}
  >
    <path
      d="M4.84091 14.25L1.5 16.875V3C1.5 2.58579 1.83579 2.25 2.25 2.25H15.75C16.1642 2.25 16.5 2.58579 16.5 3V13.5C16.5 13.9142 16.1642 14.25 15.75 14.25H4.84091ZM4.32211 12.75H15V3.75H3V13.7888L4.32211 12.75ZM8.25 7.5H9.75V9H8.25V7.5ZM5.25 7.5H6.75V9H5.25V7.5ZM11.25 7.5H12.75V9H11.25V7.5Z"
      fill="currentColor"
    />
  </svg>
);

export const TemplateIcon = (props?: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
    {...props}
  >
    <path
      d="M3.16675 0.666016V2.66602H1.16675V3.99935H3.16675V5.99935H4.50008V3.99935H6.50008V2.66602H4.50008V0.666016H3.16675ZM7.83341 3.33268C7.83341 5.54182 6.04255 7.33268 3.83341 7.33268C3.3659 7.33268 2.91712 7.25248 2.50008 7.10508V13.3371C2.50008 13.7027 2.79804 13.9993 3.16559 13.9993H9.83341V9.99935C9.83341 9.63268 10.1334 9.33268 10.5001 9.33268H14.5001V2.66502C14.5001 2.29768 14.2035 1.99935 13.8378 1.99935H7.60581C7.75321 2.41639 7.83341 2.86517 7.83341 3.33268ZM14.5001 10.666L11.1667 13.9973V10.666H14.5001Z"
      fill="currentColor"
    />
  </svg>
);

export const CreateIcon = (props?: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <path
      d="M2.66663 0.666016V2.66602H0.666626V3.99935H2.66663V5.99935H3.99996V3.99935H5.99996V2.66602H3.99996V0.666016H2.66663ZM1.99996 13.3371V7.33268H3.33329V12.666H8.66663V9.33268C8.66663 8.96601 8.96663 8.66602 9.33329 8.66602L12.6666 8.66535V3.33268H7.33329V1.99935H13.3377C13.7034 1.99935 14 2.30319 14 2.66766V9.99935L9.99996 13.9967L2.6681 13.9993C2.29909 13.9993 1.99996 13.7027 1.99996 13.3371ZM12.114 9.99868L9.99996 9.99935V12.112L12.114 9.99868Z"
      fill="currentColor"
    />
  </svg>
);

export const CreateBlockIcon = (props?: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <path
      d="M2.66663 0.667969V2.66797H0.666626V4.0013H2.66663V6.0013H3.99996V4.0013H5.99996V2.66797H3.99996V0.667969H2.66663ZM7.33329 3.33464C7.33329 5.54378 5.54243 7.33463 3.33329 7.33463C2.86578 7.33463 2.417 7.25444 1.99996 7.10704V13.339C1.99996 13.7047 2.29792 14.0013 2.66547 14.0013H9.33329V10.0013C9.33329 9.63463 9.63329 9.33463 9.99996 9.33463H14V2.66697C14 2.29963 13.7034 2.0013 13.3377 2.0013H7.10569C7.25309 2.41834 7.33329 2.86712 7.33329 3.33464ZM14 10.668L10.6666 13.9993V10.668H14Z"
      fill="currentColor"
    />
  </svg>
);

export const SearchIcon = (props?: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    {...props}
  >
    <path
      d="M13.5233 12.4626L16.7353 15.6746L15.6746 16.7353L12.4626 13.5233C11.3077 14.4473 9.843 15 8.25 15C4.524 15 1.5 11.976 1.5 8.25C1.5 4.524 4.524 1.5 8.25 1.5C11.976 1.5 15 4.524 15 8.25C15 9.843 14.4473 11.3077 13.5233 12.4626ZM12.0185 11.9061C12.9356 10.9609 13.5 9.6717 13.5 8.25C13.5 5.34938 11.1506 3 8.25 3C5.34938 3 3 5.34938 3 8.25C3 11.1506 5.34938 13.5 8.25 13.5C9.6717 13.5 10.9609 12.9356 11.9061 12.0185L12.0185 11.9061Z"
      fill="currentColor"
    />
  </svg>
);
export const ArrowDownIcon = (props?: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      d="M11.9999 13.1724L16.9497 8.22266L18.3639 9.63687L11.9999 16.0009L5.63599 9.63687L7.0502 8.22266L11.9999 13.1724Z"
      fill="currentColor"
    />
  </svg>
);

export const ArrowUpIcon = (props?: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      d="M12 10.8273L7.05001 15.7773L5.63601 14.3633L12 7.99934L18.364 14.3633L16.95 15.7773L12 10.8273Z"
      fill="currentColor"
    />
  </svg>
);

export const CloseIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <path
      d="M7.99984 7.05767L11.2997 3.75781L12.2425 4.70062L8.94264 8.00047L12.2425 11.3003L11.2997 12.2431L7.99984 8.94327L4.70002 12.2431L3.7572 11.3003L7.05704 8.00047L3.7572 4.70062L4.70002 3.75781L7.99984 7.05767Z"
      fill="currentColor"
    />
  </svg>
);

export const AddIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <path
      d="M7.33337 7.33203V3.33203H8.66671V7.33203H12.6667V8.66536H8.66671V12.6654H7.33337V8.66536H3.33337V7.33203H7.33337Z"
      fill="currentColor"
    />
  </svg>
);

export const AddSkillIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <path
      d="M7.33337 7.33398V4.66732H8.66671V7.33398H11.3334V8.66732H8.66671V11.334H7.33337V8.66732H4.66671V7.33398H7.33337ZM8.00004 14.6673C4.31814 14.6673 1.33337 11.6825 1.33337 8.00065C1.33337 4.31875 4.31814 1.33398 8.00004 1.33398C11.6819 1.33398 14.6667 4.31875 14.6667 8.00065C14.6667 11.6825 11.6819 14.6673 8.00004 14.6673ZM8.00004 13.334C10.9456 13.334 13.3334 10.9462 13.3334 8.00065C13.3334 5.05513 10.9456 2.66732 8.00004 2.66732C5.05452 2.66732 2.66671 5.05513 2.66671 8.00065C2.66671 10.9462 5.05452 13.334 8.00004 13.334Z"
      fill="currentColor"
    />
  </svg>
);

export const InfoIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    {...props}
  >
    <g clipPath="url(#clip0_6807_15549)">
      <path
        d="M7.00033 4.66663V6.99996M7.00033 9.33329H7.00616M12.8337 6.99996C12.8337 10.2216 10.222 12.8333 7.00033 12.8333C3.77866 12.8333 1.16699 10.2216 1.16699 6.99996C1.16699 3.7783 3.77866 1.16663 7.00033 1.16663C10.222 1.16663 12.8337 3.7783 12.8337 6.99996Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_6807_15549">
        <rect width="14" height="14" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const Info2Icon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    {...props}
  >
    <path
      d="M8.00016 15.1668C4.31826 15.1668 1.3335 12.182 1.3335 8.50016C1.3335 4.81826 4.31826 1.8335 8.00016 1.8335C11.682 1.8335 14.6668 4.81826 14.6668 8.50016C14.6668 12.182 11.682 15.1668 8.00016 15.1668ZM8.00016 13.8335C10.9457 13.8335 13.3335 11.4457 13.3335 8.50016C13.3335 5.55464 10.9457 3.16683 8.00016 3.16683C5.05464 3.16683 2.66683 5.55464 2.66683 8.50016C2.66683 11.4457 5.05464 13.8335 8.00016 13.8335ZM7.3335 5.16683H8.66683V6.50016H7.3335V5.16683ZM7.3335 7.8335H8.66683V11.8335H7.3335V7.8335Z"
      fill="currentColor"
    />
  </svg>
);

export const DelIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <path
      d="M11.75 3.5H15.5V5H14V14.75C14 15.1642 13.6642 15.5 13.25 15.5H2.75C2.33579 15.5 2 15.1642 2 14.75V5H0.5V3.5H4.25V1.25C4.25 0.83579 4.58579 0.5 5 0.5H11C11.4142 0.5 11.75 0.83579 11.75 1.25V3.5ZM12.5 5H3.5V14H12.5V5ZM5.75 7.25H7.25V11.75H5.75V7.25ZM8.75 7.25H10.25V11.75H8.75V7.25ZM5.75 2V3.5H10.25V2H5.75Z"
      fill="currentColor"
    />
  </svg>
);

export const EditIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <path
      d="M4.27614 10.595L11.0375 3.83354L10.0947 2.89072L3.33333 9.65217V10.595H4.27614ZM4.82843 11.9283H2V9.09984L9.62333 1.47651C9.88373 1.21616 10.3058 1.21616 10.5661 1.47651L12.4518 3.36213C12.7121 3.62248 12.7121 4.04459 12.4518 4.30494L4.82843 11.9283ZM2 13.2616H14V14.595H2V13.2616Z"
      fill="currentColor"
    />
  </svg>
);

export const RefreshIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      d="M5.46257 4.43262C7.21556 2.91688 9.5007 2 12 2C17.5228 2 22 6.47715 22 12C22 14.1361 21.3302 16.1158 20.1892 17.7406L17 12H20C20 7.58172 16.4183 4 12 4C9.84982 4 7.89777 4.84827 6.46023 6.22842L5.46257 4.43262ZM18.5374 19.5674C16.7844 21.0831 14.4993 22 12 22C6.47715 22 2 17.5228 2 12C2 9.86386 2.66979 7.88416 3.8108 6.25944L7 12H4C4 16.4183 7.58172 20 12 20C14.1502 20 16.1022 19.1517 17.5398 17.7716L18.5374 19.5674Z"
      fill="currentColor"
    />
  </svg>
);
export const AgentSolidIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="29"
    height="29"
    viewBox="0 0 29 29"
    fill="none"
    {...props}
  >
    <path
      d="M16.3125 2.41797C16.3125 2.95477 16.0792 3.43707 15.7083 3.76895V6.04297H21.75C23.7521 6.04297 25.375 7.66594 25.375 9.66797V21.7513C25.375 23.7534 23.7521 25.3763 21.75 25.3763H7.25C5.24797 25.3763 3.625 23.7534 3.625 21.7513V9.66797C3.625 7.66594 5.24797 6.04297 7.25 6.04297H13.2917V3.76895C12.9208 3.43707 12.6875 2.95477 12.6875 2.41797C12.6875 1.41695 13.499 0.605469 14.5 0.605469C15.501 0.605469 16.3125 1.41695 16.3125 2.41797ZM0 12.0846H2.41667V19.3346H0V12.0846ZM29 12.0846H26.5833V19.3346H29V12.0846ZM10.875 17.5221C11.876 17.5221 12.6875 16.7106 12.6875 15.7096C12.6875 14.7087 11.876 13.8971 10.875 13.8971C9.87398 13.8971 9.0625 14.7087 9.0625 15.7096C9.0625 16.7106 9.87398 17.5221 10.875 17.5221ZM19.9375 15.7096C19.9375 14.7087 19.126 13.8971 18.125 13.8971C17.124 13.8971 16.3125 14.7087 16.3125 15.7096C16.3125 16.7106 17.124 17.5221 18.125 17.5221C19.126 17.5221 19.9375 16.7106 19.9375 15.7096Z"
      fill="currentColor"
    />
  </svg>
);

export const AddPicIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <g clipPath="url(#clip0_1030_8198)">
      <path
        d="M14 10V12H16V13.3333H14V15.3333H12.6667V13.3333H10.6667V12H12.6667V10H14ZM14.0055 2C14.3707 2 14.6667 2.29663 14.6667 2.66227V8.66667H13.3334V3.33333H2.66671V12.666L9.33337 6L11.3334 8V9.886L9.33337 7.8856L4.55137 12.6667H9.33337V14H1.99457C1.62941 14 1.33337 13.7034 1.33337 13.3377V2.66227C1.33337 2.29651 1.63691 2 1.99457 2H14.0055ZM5.33337 4.66667C6.06975 4.66667 6.66671 5.26362 6.66671 6C6.66671 6.7364 6.06975 7.33333 5.33337 7.33333C4.59699 7.33333 4.00004 6.7364 4.00004 6C4.00004 5.26362 4.59699 4.66667 5.33337 4.66667Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_1030_8198">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const SendIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      d="M1.94607 9.31702C1.42353 9.14284 1.4194 8.86181 1.95682 8.68267L21.043 2.3206C21.5715 2.14444 21.8746 2.44025 21.7265 2.95853L16.2733 22.0448C16.1223 22.5732 15.8177 22.5916 15.5944 22.0892L11.9999 14.0016L17.9999 6.00164L9.99992 12.0016L1.94607 9.31702Z"
      fill="currentColor"
    />
  </svg>
);

export const SendUpIcon = (
  props: SVGProps<SVGSVGElement> & { disabled: boolean }
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    {...props}
  >
    <rect width="28" height="28" rx="6" fill="currentColor" />
    <path
      d="M14.8748 10.3499V21H13.1248V10.3499L8.43129 15.0434L7.19385 13.8059L13.9998 7L20.8057 13.8059L19.5683 15.0434L14.8748 10.3499Z"
      fill={props.disabled ? "#b0b0b0" : "white"}
    />
  </svg>
);

export const VoiceIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      d="M5 7H7V17H5V7ZM1 10H3V14H1V10ZM9 2H11V20H9V2ZM13 4H15V22H13V4ZM17 7H19V17H17V7ZM21 10H23V14H21V10Z"
      fill="currentColor"
    />
  </svg>
);

export const VoiceStopIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      d="M21 16.42V19.9561C21 20.4811 20.5941 20.9167 20.0705 20.9537C19.6331 20.9846 19.2763 21 19 21C10.1634 21 3 13.8366 3 5C3 4.72371 3.01545 4.36687 3.04635 3.9295C3.08337 3.40588 3.51894 3 4.04386 3H7.5801C7.83678 3 8.05176 3.19442 8.07753 3.4498C8.10067 3.67907 8.12218 3.86314 8.14207 4.00202C8.34435 5.41472 8.75753 6.75936 9.3487 8.00303C9.44359 8.20265 9.38171 8.44159 9.20185 8.57006L7.04355 10.1118C8.35752 13.1811 10.8189 15.6425 13.8882 16.9565L15.4271 14.8019C15.5572 14.6199 15.799 14.5573 16.001 14.6532C17.2446 15.2439 18.5891 15.6566 20.0016 15.8584C20.1396 15.8782 20.3225 15.8995 20.5502 15.9225C20.8056 15.9483 21 16.1633 21 16.42Z"
      fill="currentColor"
    />
    <path
      d="M17 5.33336L19.3333 3L20 3.66667L17.6666 6.00002L20 8.33334L19.3333 9L17 6.66668L14.6667 9L14 8.33334L16.3333 6.00002L14 3.66667L14.6667 3L17 5.33336Z"
      fill="currentColor"
    />
  </svg>
);

export const MicIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    {...props}
  >
    <path
      d="M9.99984 0.833984C12.301 0.833984 14.1665 2.69947 14.1665 5.00065V8.33398C14.1665 10.6352 12.301 12.5007 9.99984 12.5007C7.69861 12.5007 5.83314 10.6352 5.83314 8.33398V5.00065C5.83314 2.69947 7.69861 0.833984 9.99984 0.833984ZM2.54558 9.16732H4.22554C4.6299 11.9942 7.06108 14.1673 9.99984 14.1673C12.9385 14.1673 15.3697 11.9942 15.7741 9.16732H17.454C17.0698 12.6437 14.3095 15.4039 10.8332 15.7882V19.1673H9.1665V15.7882C5.69012 15.4039 2.92987 12.6437 2.54558 9.16732Z"
      fill="currentColor"
    />
  </svg>
);

export const MicStopIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    {...props}
  >
    <path
      d="M13.6874 14.8665C12.8274 15.353 11.8617 15.6746 10.8335 15.7882V19.1673H9.16683V15.7882C5.69044 15.4039 2.93019 12.6437 2.5459 9.16732H4.22587C4.63022 11.9942 7.06139 14.1673 10.0002 14.1673C10.8752 14.1673 11.7053 13.9747 12.4503 13.6293L11.1585 12.3375C10.7907 12.4437 10.4021 12.5007 10.0002 12.5007C7.69894 12.5007 5.83346 10.6352 5.83346 8.33398V7.01249L1.16129 2.34033L2.3398 1.16182L18.839 17.661L17.6604 18.8395L13.6874 14.8665ZM16.1456 12.6343L14.9436 11.4322C15.3672 10.7577 15.6567 9.99015 15.7744 9.16732H17.4543C17.3128 10.4478 16.8489 11.6311 16.1456 12.6343ZM13.7215 10.2102L6.40479 2.89348C7.12855 1.66122 8.46774 0.833984 10.0002 0.833984C12.3013 0.833984 14.1668 2.69947 14.1668 5.00065V8.33398C14.1668 9.0089 14.0063 9.64632 13.7215 10.2102Z"
      fill="currentColor"
    />
  </svg>
);

export const DragIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      d="M9.5 3C8.675 3 8 3.675 8 4.5C8 5.325 8.675 6 9.5 6C10.325 6 11 5.325 11 4.5C11 3.675 10.325 3 9.5 3ZM9.5 18C8.675 18 8 18.675 8 19.5C8 20.325 8.675 21 9.5 21C10.325 21 11 20.325 11 19.5C11 18.675 10.325 18 9.5 18ZM9.5 10.5C8.675 10.5 8 11.175 8 12C8 12.825 8.675 13.5 9.5 13.5C10.325 13.5 11 12.825 11 12C11 11.175 10.325 10.5 9.5 10.5Z"
      fill="currentColor"
    />
    <path
      d="M14.5 3C13.675 3 13 3.675 13 4.5C13 5.325 13.675 6 14.5 6C15.325 6 16 5.325 16 4.5C16 3.675 15.325 3 14.5 3ZM14.5 18C13.675 18 13 18.675 13 19.5C13 20.325 13.675 21 14.5 21C15.325 21 16 20.325 16 19.5C16 18.675 15.325 18 14.5 18ZM14.5 10.5C13.675 10.5 13 11.175 13 12C13 12.825 13.675 13.5 14.5 13.5C15.325 13.5 16 12.825 16 12C16 11.175 15.325 10.5 14.5 10.5Z"
      fill="currentColor"
    />
  </svg>
);

export const PenIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      d="M19.7782 4.2225C20.5592 5.00355 20.5592 6.26988 19.7782 7.05093L16.9498 9.87935L14.1213 7.05093L16.9498 4.2225C17.7308 3.44145 18.9971 3.44145 19.7782 4.2225ZM21.1924 2.80829C19.6303 1.24619 17.0976 1.24619 15.5355 2.80829L12.7071 5.63671L12.3535 5.2835C11.963 4.89297 11.3299 4.89297 10.9393 5.2835C10.5488 5.67402 10.5488 6.30718 10.9393 6.69771L11.2929 7.05129L5.07821 13.266C4.51981 13.8244 4.13919 14.5356 3.98431 15.31L3.63348 17.0642C3.55605 17.4513 3.36574 17.8069 3.08653 18.0861L2.10051 19.0722C1.70999 19.4627 1.70999 20.0959 2.10051 20.4864L3.51472 21.9006C3.90525 22.2911 4.53841 22.2911 4.92894 21.9006L5.91496 20.9146C6.19416 20.6354 6.54976 20.4451 6.93694 20.3676L8.6911 20.0168C9.46547 19.8619 10.1767 19.4813 10.7351 18.9229L16.9498 12.7082L17.3033 13.0617C17.6938 13.4522 18.327 13.4522 18.7175 13.0617C19.108 12.6712 19.108 12.038 18.7175 11.6475L18.364 11.294L21.1924 8.46514C22.7545 6.90304 22.7545 4.37038 21.1924 2.80829ZM12.7071 8.46551L15.5355 11.294L9.32085 17.5087C9.04165 17.7879 8.68605 17.9782 8.29887 18.0556L6.54471 18.4065C5.77035 18.5613 5.05915 18.942 4.50075 19.5004C5.05915 18.942 5.43977 18.2308 5.59464 17.4564L5.94548 15.7022C6.02291 15.3151 6.21322 14.9595 6.49242 14.6803L12.7071 8.46551Z"
      fill="currentColor"
    />
  </svg>
);

export const RetryIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    {...props}
  >
    <path
      d="M4.09693 3.32447C5.41167 2.18766 7.12552 1.5 9 1.5C13.1421 1.5 16.5 4.85786 16.5 9C16.5 10.6021 15.9976 12.0869 15.1419 13.3055L12.75 9H15C15 5.68629 12.3137 3 9 3C7.38736 3 5.92333 3.6362 4.84517 4.67131L4.09693 3.32447ZM13.903 14.6756C12.5883 15.8123 10.8745 16.5 9 16.5C4.85786 16.5 1.5 13.1421 1.5 9C1.5 7.39789 2.00234 5.91312 2.8581 4.69458L5.25 9H3C3 12.3137 5.68629 15 9 15C10.6126 15 12.0767 14.3638 13.1549 13.3287L13.903 14.6756Z"
      fill="currentColor"
    />
  </svg>
);
export const FileIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      d="M21 8V20.9932C21 21.5501 20.5552 22 20.0066 22H3.9934C3.44495 22 3 21.556 3 21.0082V2.9918C3 2.45531 3.4487 2 4.00221 2H14.9968L21 8ZM19 9H14V4H5V20H19V9ZM8 7H11V9H8V7ZM8 11H16V13H8V11ZM8 15H16V17H8V15Z"
      fill="currentColor"
    />
  </svg>
);

export const WebIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      d="M6.23509 6.45329C4.85101 7.89148 4 9.84636 4 12C4 16.4183 7.58172 20 12 20C13.0808 20 14.1116 19.7857 15.0521 19.3972C15.1671 18.6467 14.9148 17.9266 14.8116 17.6746C14.582 17.115 13.8241 16.1582 12.5589 14.8308C12.2212 14.4758 12.2429 14.2035 12.3636 13.3943L12.3775 13.3029C12.4595 12.7486 12.5971 12.4209 14.4622 12.1248C15.4097 11.9746 15.6589 12.3533 16.0043 12.8777C16.0425 12.9358 16.0807 12.9928 16.1198 13.0499C16.4479 13.5297 16.691 13.6394 17.0582 13.8064C17.2227 13.881 17.428 13.9751 17.7031 14.1314C18.3551 14.504 18.3551 14.9247 18.3551 15.8472V15.9518C18.3551 16.3434 18.3168 16.6872 18.2566 16.9859C19.3478 15.6185 20 13.8854 20 12C20 8.70089 18.003 5.8682 15.1519 4.64482C14.5987 5.01813 13.8398 5.54726 13.575 5.91C13.4396 6.09538 13.2482 7.04166 12.6257 7.11976C12.4626 7.14023 12.2438 7.12589 12.012 7.11097C11.3905 7.07058 10.5402 7.01606 10.268 7.75495C10.0952 8.2232 10.0648 9.49445 10.6239 10.1543C10.7134 10.2597 10.7307 10.4547 10.6699 10.6735C10.59 10.9608 10.4286 11.1356 10.3783 11.1717C10.2819 11.1163 10.0896 10.8931 9.95938 10.7412C9.64554 10.3765 9.25405 9.92233 8.74797 9.78176C8.56395 9.73083 8.36166 9.68867 8.16548 9.64736C7.6164 9.53227 6.99443 9.40134 6.84992 9.09302C6.74442 8.8672 6.74488 8.55621 6.74529 8.22764C6.74529 7.8112 6.74529 7.34029 6.54129 6.88256C6.46246 6.70541 6.35689 6.56446 6.23509 6.45329ZM12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22Z"
      fill="currentColor"
    />
  </svg>
);

export const QaIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      d="M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM11 15H13V17H11V15ZM13 13.3551V14H11V12.5C11 11.9477 11.4477 11.5 12 11.5C12.8284 11.5 13.5 10.8284 13.5 10C13.5 9.17157 12.8284 8.5 12 8.5C11.2723 8.5 10.6656 9.01823 10.5288 9.70577L8.56731 9.31346C8.88637 7.70919 10.302 6.5 12 6.5C13.933 6.5 15.5 8.067 15.5 10C15.5 11.5855 14.4457 12.9248 13 13.3551Z"
      fill="currentColor"
    />
  </svg>
);

export const AddCircleIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    {...props}
  >
    <path
      d="M8.25 8.25V5.25H9.75V8.25H12.75V9.75H9.75V12.75H8.25V9.75H5.25V8.25H8.25ZM9 16.5C4.85786 16.5 1.5 13.1421 1.5 9C1.5 4.85786 4.85786 1.5 9 1.5C13.1421 1.5 16.5 4.85786 16.5 9C16.5 13.1421 13.1421 16.5 9 16.5ZM9 15C12.3137 15 15 12.3137 15 9C15 5.68629 12.3137 3 9 3C5.68629 3 3 5.68629 3 9C3 12.3137 5.68629 15 9 15Z"
      fill="#A0AEC0"
    />
  </svg>
);

export const ExportIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
    {...props}
  >
    <path
      d="M2.5 12.6673H14.5V14.0007H2.5V12.6673ZM9.16667 3.88627V11.334H7.83333V3.88627L3.78595 7.93365L2.84315 6.99085L8.5 1.33398L14.1569 6.99085L13.2141 7.93365L9.16667 3.88627Z"
      fill="currentColor"
    />
  </svg>
);

export const GenerateIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <g clipPath="url(#clip0_1127_2261)">
      <path
        d="M7.07627 11.8631L7.66133 10.523C8.18207 9.33042 9.11927 8.38108 10.2883 7.86215L11.8988 7.14728C12.4108 6.92002 12.4108 6.17514 11.8988 5.94786L10.3386 5.25531C9.13947 4.72303 8.18547 3.73856 7.67367 2.50531L7.081 1.07717C6.86107 0.547193 6.12879 0.547194 5.90887 1.07717L5.31618 2.5053C4.80438 3.73856 3.85035 4.72303 2.65123 5.25531L1.09105 5.94786C0.579024 6.17514 0.579024 6.92002 1.09105 7.14728L2.70153 7.86215C3.87059 8.38108 4.80781 9.33042 5.3285 10.523L5.9136 11.8631C6.13851 12.3781 6.85133 12.3781 7.07627 11.8631ZM12.9343 15.1259L13.0988 14.7488C13.3921 14.0764 13.9205 13.541 14.5797 13.2481L15.0866 13.0229C15.3608 12.9011 15.3608 12.5026 15.0866 12.3808L14.6081 12.1681C13.9319 11.8677 13.3941 11.3125 13.1057 10.6173L12.9368 10.2098C12.819 9.92575 12.4263 9.92575 12.3085 10.2098L12.1396 10.6173C11.8513 11.3125 11.3135 11.8677 10.6373 12.1681L10.1587 12.3808C9.8846 12.5026 9.8846 12.9011 10.1587 13.0229L10.6657 13.2481C11.3249 13.541 11.8532 14.0764 12.1465 14.7488L12.3111 15.1259C12.4315 15.402 12.8138 15.402 12.9343 15.1259Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_1127_2261">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const EmbedIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <path
      d="M13.3333 6V3.33333H2.66668V6H13.3333ZM13.3333 7.33333H2.66668V12.6667H13.3333V7.33333ZM2.00001 2H14C14.3682 2 14.6667 2.29848 14.6667 2.66667V13.3333C14.6667 13.7015 14.3682 14 14 14H2.00001C1.63182 14 1.33334 13.7015 1.33334 13.3333V2.66667C1.33334 2.29848 1.63182 2 2.00001 2ZM3.33334 8H5.33334V11.3333H3.33334V8ZM3.33334 4H4.66668V5.33333H3.33334V4ZM6.00001 4H7.33334V5.33333H6.00001V4Z"
      fill="currentColor"
    />
  </svg>
);

export const AccessApiIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <path
      d="M14 11.9987H4C3.63181 11.9987 3.33333 12.2972 3.33333 12.6654C3.33333 13.0336 3.63181 13.332 4 13.332H14V14.6654H4C2.89543 14.6654 2 13.77 2 12.6654V2.66536C2 1.92898 2.59695 1.33203 3.33333 1.33203H14V11.9987ZM3.33333 10.6987C3.44104 10.6768 3.55251 10.6654 3.66667 10.6654H12.6667V2.66536H3.33333V10.6987ZM10.6667 5.9987H5.33333V4.66536H10.6667V5.9987Z"
      fill="currentColor"
    />
  </svg>
);

export const ArrowToApiIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <path
      d="M1.33316 8.66706L1.33307 7.33379H12.1143L9.4812 4.70062L10.424 3.75781L14.6667 8.00046L10.424 12.2431L9.4812 11.3003L12.1144 8.66713L1.33316 8.66706Z"
      fill="currentColor"
    />
  </svg>
);

export const CopyIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      d="M6.9998 6V3C6.9998 2.44772 7.44752 2 7.9998 2H19.9998C20.5521 2 20.9998 2.44772 20.9998 3V17C20.9998 17.5523 20.5521 18 19.9998 18H16.9998V20.9991C16.9998 21.5519 16.5499 22 15.993 22H4.00666C3.45059 22 3 21.5554 3 20.9991L3.0026 7.00087C3.0027 6.44811 3.45264 6 4.00942 6H6.9998ZM5.00242 8L5.00019 20H14.9998V8H5.00242ZM8.9998 6H16.9998V16H18.9998V4H8.9998V6Z"
      fill="currentColor"
    />
  </svg>
);

export const ArrowToIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      d="M13.1714 11.9994L8.22168 7.04957L9.63589 5.63537L15.9999 11.9994L9.63589 18.3633L8.22168 16.9491L13.1714 11.9994Z"
      fill="currentColor"
    />
  </svg>
);

export const CheckedIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    {...props}
  >
    <path
      d="M6.66647 10.6126L12.7947 4.48438L13.7375 5.42718L6.66647 12.4982L2.42383 8.25563L3.36664 7.31283L6.66647 10.6126Z"
      fill="currentColor"
    />
  </svg>
);

export const SolidCheckedIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <path
      d="M8.00004 14.6673C11.6819 14.6673 14.6667 11.6825 14.6667 8.00065C14.6667 4.31875 11.6819 1.33398 8.00004 1.33398C4.31814 1.33398 1.33337 4.31875 1.33337 8.00065C1.33337 11.6825 4.31814 14.6673 8.00004 14.6673ZM11.6381 6.30539L7.33337 10.6101L4.52863 7.80538L5.47145 6.86258L7.33337 8.72452L10.6953 5.36258L11.6381 6.30539Z"
      fill="currentColor"
    />
  </svg>
);

export const BrowserIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <path
      d="M4.15674 4.30089C3.23402 5.25968 2.66668 6.56294 2.66668 7.9987C2.66668 10.9442 5.05449 13.332 8.00001 13.332C8.72054 13.332 9.40774 13.1892 10.0347 12.9302C10.1114 12.4298 9.94321 11.9498 9.87441 11.7818C9.72134 11.4087 9.21608 10.7708 8.37261 9.8859C8.14748 9.64923 8.16194 9.4677 8.24241 8.92823L8.25168 8.8673C8.30634 8.49776 8.39808 8.2793 9.64148 8.0819C10.2731 7.98176 10.4393 8.23423 10.6695 8.58383C10.695 8.62256 10.7205 8.66056 10.7465 8.69863C10.9653 9.0185 11.1273 9.09163 11.3721 9.20296C11.4818 9.2527 11.6187 9.31543 11.8021 9.41963C12.2367 9.66803 12.2367 9.9485 12.2367 10.5635V10.6332C12.2367 10.8943 12.2112 11.1235 12.1711 11.3226C12.8985 10.411 13.3333 9.25563 13.3333 7.9987C13.3333 5.79929 12.002 3.91083 10.1013 3.09524C9.73248 3.34412 9.22654 3.69687 9.05001 3.9387C8.95974 4.06228 8.83214 4.69314 8.41714 4.7452C8.30841 4.75885 8.16254 4.74929 8.00801 4.73934C7.59368 4.71242 7.02681 4.67607 6.84534 5.16866C6.73014 5.48083 6.70988 6.32833 7.08261 6.76823C7.14228 6.8385 7.15381 6.9685 7.11328 7.11436C7.06001 7.3059 6.95241 7.42243 6.91888 7.4465C6.85461 7.40956 6.72641 7.26076 6.6396 7.1595C6.43037 6.91636 6.16938 6.61358 5.83199 6.51987C5.70931 6.48592 5.57445 6.45781 5.44366 6.43027C5.07761 6.35354 4.66296 6.26626 4.56662 6.06071C4.49629 5.91016 4.4966 5.70284 4.49687 5.48379C4.49687 5.20616 4.49687 4.89222 4.36087 4.58707C4.30832 4.46897 4.23794 4.375 4.15674 4.30089ZM8.00001 14.6654C4.31811 14.6654 1.33334 11.6806 1.33334 7.9987C1.33334 4.3168 4.31811 1.33203 8.00001 1.33203C11.6819 1.33203 14.6667 4.3168 14.6667 7.9987C14.6667 11.6806 11.6819 14.6654 8.00001 14.6654Z"
      fill="currentColor"
    />
  </svg>
);

export const MoreIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="4"
    height="14"
    viewBox="0 0 4 14"
    fill="none"
    {...props}
  >
    <path
      d="M2 0.25C1.38125 0.25 0.875 0.75625 0.875 1.375C0.875 1.99375 1.38125 2.5 2 2.5C2.61875 2.5 3.125 1.99375 3.125 1.375C3.125 0.75625 2.61875 0.25 2 0.25ZM2 11.5C1.38125 11.5 0.875 12.0063 0.875 12.625C0.875 13.2437 1.38125 13.75 2 13.75C2.61875 13.75 3.125 13.2437 3.125 12.625C3.125 12.0063 2.61875 11.5 2 11.5ZM2 5.875C1.38125 5.875 0.875 6.38125 0.875 7C0.875 7.61875 1.38125 8.125 2 8.125C2.61875 8.125 3.125 7.61875 3.125 7C3.125 6.38125 2.61875 5.875 2 5.875Z"
      fill="currentColor"
    />
  </svg>
);

export const EmailIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <path
      d="M2.00004 2H14C14.3682 2 14.6667 2.29848 14.6667 2.66667V13.3333C14.6667 13.7015 14.3682 14 14 14H2.00004C1.63185 14 1.33337 13.7015 1.33337 13.3333V2.66667C1.33337 2.29848 1.63185 2 2.00004 2ZM13.3334 4.82528L8.04791 9.55867L2.66671 4.81063V12.6667H13.3334V4.82528ZM3.00768 3.33333L8.04131 7.77467L13.0007 3.33333H3.00768Z"
      fill="currentColor"
    />
  </svg>
);

export const PasswordIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <path
      d="M7.1718 7.88495L12.4044 2.65234L13.3472 3.59515L12.4044 4.53796L14.0543 6.18788L13.1115 7.13068L11.4616 5.48077L10.5188 6.42358L11.933 7.83782L10.9902 8.78062L9.576 7.36642L8.1146 8.82775C8.97207 10.122 8.83067 11.8829 7.69033 13.0232C6.38861 14.325 4.27806 14.325 2.97631 13.0232C1.67456 11.7215 1.67456 9.61095 2.97631 8.30922C4.11662 7.16888 5.87755 7.02748 7.1718 7.88495ZM6.74753 12.0804C7.5286 11.2993 7.5286 10.0331 6.74753 9.25202C5.9665 8.47095 4.70017 8.47095 3.91912 9.25202C3.13808 10.0331 3.13808 11.2993 3.91912 12.0804C4.70017 12.8615 5.9665 12.8615 6.74753 12.0804Z"
      fill="currentColor"
    />
  </svg>
);

export const EyeIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <path
      d="M6.22841 12.5206L4.94051 12.1755L5.46549 10.2163C4.67275 9.92428 3.94437 9.49922 3.3074 8.96828L1.87185 10.4038L0.92904 9.46102L2.36459 8.02548C1.5705 7.07288 1.01339 5.91579 0.783813 4.6448L2.09587 4.40625C2.60189 7.20775 5.05283 9.33275 8.00009 9.33275C10.9474 9.33275 13.3984 7.20775 13.9044 4.40625L15.2164 4.6448C14.9868 5.91579 14.4297 7.07288 13.6356 8.02548L15.0712 9.46102L14.1284 10.4038L12.6928 8.96828C12.0558 9.49922 11.3274 9.92428 10.5347 10.2163L11.0597 12.1755L9.77183 12.5206L9.24663 10.5605C8.84149 10.6299 8.42503 10.6661 8.00009 10.6661C7.57523 10.6661 7.15869 10.6299 6.75363 10.5605L6.22841 12.5206Z"
      fill="currentColor"
    />
  </svg>
);

export const EyeOpenIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="13"
    viewBox="0 0 16 13"
    fill="none"
    {...props}
  >
    <path
      d="M8.00053 0.5C11.5953 0.5 14.5859 3.08651 15.2129 6.5C14.5859 9.91347 11.5953 12.5 8.00053 12.5C4.40574 12.5 1.41509 9.91347 0.788086 6.5C1.41509 3.08651 4.40574 0.5 8.00053 0.5ZM8.00053 11.1667C10.8243 11.1667 13.2405 9.20133 13.8521 6.5C13.2405 3.79869 10.8243 1.83333 8.00053 1.83333C5.17673 1.83333 2.76047 3.79869 2.14885 6.5C2.76047 9.20133 5.17673 11.1667 8.00053 11.1667ZM8.00053 9.5C6.34365 9.5 5.0005 8.15687 5.0005 6.5C5.0005 4.84315 6.34365 3.5 8.00053 3.5C9.65733 3.5 11.0005 4.84315 11.0005 6.5C11.0005 8.15687 9.65733 9.5 8.00053 9.5ZM8.00053 8.16667C8.92099 8.16667 9.66719 7.42047 9.66719 6.5C9.66719 5.57953 8.92099 4.83333 8.00053 4.83333C7.08006 4.83333 6.33383 5.57953 6.33383 6.5C6.33383 7.42047 7.08006 8.16667 8.00053 8.16667Z"
      fill="currentColor"
    />
  </svg>
);

export const LoadingIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    {...props}
  >
    <path
      d="M12.5 2C13.0523 2 13.5 2.44772 13.5 3V6C13.5 6.55228 13.0523 7 12.5 7C11.9477 7 11.5 6.55228 11.5 6V3C11.5 2.44772 11.9477 2 12.5 2ZM12.5 17C13.0523 17 13.5 17.4477 13.5 18V21C13.5 21.5523 13.0523 22 12.5 22C11.9477 22 11.5 21.5523 11.5 21V18C11.5 17.4477 11.9477 17 12.5 17ZM22.5 12C22.5 12.5523 22.0523 13 21.5 13H18.5C17.9477 13 17.5 12.5523 17.5 12C17.5 11.4477 17.9477 11 18.5 11H21.5C22.0523 11 22.5 11.4477 22.5 12ZM7.5 12C7.5 12.5523 7.05228 13 6.5 13H3.5C2.94772 13 2.5 12.5523 2.5 12C2.5 11.4477 2.94772 11 3.5 11H6.5C7.05228 11 7.5 11.4477 7.5 12ZM19.5711 19.0711C19.1805 19.4616 18.5474 19.4616 18.1569 19.0711L16.0355 16.9497C15.645 16.5592 15.645 15.9261 16.0355 15.5355C16.4261 15.145 17.0592 15.145 17.4497 15.5355L19.5711 17.6569C19.9616 18.0474 19.9616 18.6805 19.5711 19.0711ZM8.96447 8.46447C8.57394 8.85499 7.94078 8.85499 7.55025 8.46447L5.42893 6.34315C5.03841 5.95262 5.03841 5.31946 5.42893 4.92893C5.81946 4.53841 6.45262 4.53841 6.84315 4.92893L8.96447 7.05025C9.35499 7.44078 9.35499 8.07394 8.96447 8.46447ZM5.42893 19.0711C5.03841 18.6805 5.03841 18.0474 5.42893 17.6569L7.55025 15.5355C7.94078 15.145 8.57394 15.145 8.96447 15.5355C9.35499 15.9261 9.35499 16.5592 8.96447 16.9497L6.84315 19.0711C6.45262 19.4616 5.81946 19.4616 5.42893 19.0711ZM16.0355 8.46447C15.645 8.07394 15.645 7.44078 16.0355 7.05025L18.1569 4.92893C18.5474 4.53841 19.1805 4.53841 19.5711 4.92893C19.9616 5.31946 19.9616 5.95262 19.5711 6.34315L17.4497 8.46447C17.0592 8.85499 16.4261 8.85499 16.0355 8.46447Z"
      fill="currentColor"
    >
      <animateTransform
        attributeName="transform"
        type="rotate"
        from="0 12.5 12"
        to="360 12.5 12"
        dur="5s"
        repeatCount="indefinite"
      />
    </path>
  </svg>
);

export const IntentionIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    {...props}
  >
    <path
      d="M7.47981 13.5H8.25V9.75H9.75V13.5H10.5202C10.6192 12.5988 11.0791 11.8549 11.8257 11.042C11.9098 10.9504 12.4491 10.3923 12.5131 10.3126C13.1488 9.51982 13.5 8.53875 13.5 7.5C13.5 5.01472 11.4853 3 9 3C6.51472 3 4.5 5.01472 4.5 7.5C4.5 8.53823 4.85081 9.51877 5.48597 10.3113C5.55003 10.3912 6.09061 10.9509 6.17365 11.0413C6.92074 11.8548 7.38077 12.5988 7.47981 13.5ZM7.5 15V15.75H10.5V15H7.5ZM4.31546 11.2494C3.49234 10.2223 3 8.91862 3 7.5C3 4.18629 5.68629 1.5 9 1.5C12.3137 1.5 15 4.18629 15 7.5C15 8.91937 14.5071 10.2236 13.6832 11.251C13.218 11.8311 12 12.75 12 13.875V15.75C12 16.5785 11.3285 17.25 10.5 17.25H7.5C6.67157 17.25 6 16.5785 6 15.75V13.875C6 12.75 4.78094 11.8302 4.31546 11.2494Z"
      fill="currentColor"
    />
  </svg>
);

export const ArrowBlockDownIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g id="Frame">
      <path
        id="Vector"
        d="M7 9.33301L3.5 5.83301L10.5 5.83301L7 9.33301Z"
        fill="currentColor"
      />
    </g>
  </svg>
);

export const TypingIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="34"
    height="24"
    viewBox="0 0 34 24"
    fill="currentColor"
    {...props}
  >
    <circle cx="4" cy="12" r="2" fill="currentColor" opacity={0.2}>
      <animate
        attributeName="cy"
        values="12;6;12;12;12;12;12;12;12"
        dur="1s"
        repeatCount="indefinite"
        begin="0s"
      />
    </circle>
    <circle cx="10" cy="12" r="2" fill="currentColor" opacity={0.4}>
      <animate
        attributeName="cy"
        values="12;5;12;12;12;12;12;12;12"
        dur="1s"
        repeatCount="indefinite"
        begin="0.2s"
      />
    </circle>
    <circle cx="16" cy="12" r="2" fill="currentColor" opacity={0.6}>
      <animate
        attributeName="cy"
        values="12;6;12;12;12;12;12;12;12"
        dur="1s"
        repeatCount="indefinite"
        begin="0.4s"
      />
    </circle>
    <circle cx="24" cy="12" r="2" fill="currentColor" opacity={0.8}>
      <animate
        attributeName="cy"
        values="12;5;12;12;12;12;12;12;12"
        dur="1s"
        repeatCount="indefinite"
        begin="0.6s"
      />
    </circle>
    <circle cx="30" cy="12" r="2" fill="currentColor" opacity={1}>
      <animate
        attributeName="cy"
        values="12;6;12;12;12;12;12;12;12"
        dur="1s"
        repeatCount="indefinite"
        begin="0.8s"
      />
    </circle>
  </svg>
);

export const DotsIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      d="M12 3C11.175 3 10.5 3.675 10.5 4.5C10.5 5.325 11.175 6 12 6C12.825 6 13.5 5.325 13.5 4.5C13.5 3.675 12.825 3 12 3ZM12 18C11.175 18 10.5 18.675 10.5 19.5C10.5 20.325 11.175 21 12 21C12.825 21 13.5 20.325 13.5 19.5C13.5 18.675 12.825 18 12 18ZM12 10.5C11.175 10.5 10.5 11.175 10.5 12C10.5 12.825 11.175 13.5 12 13.5C12.825 13.5 13.5 12.825 13.5 12C13.5 11.175 12.825 10.5 12 10.5Z"
      fill="currentColor"
    />
  </svg>
);

export const RowDotsIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <path
      d="M3 7C2.45 7 2 7.45 2 8C2 8.55 2.45 9 3 9C3.55 9 4 8.55 4 8C4 7.45 3.55 7 3 7ZM13 7C12.45 7 12 7.45 12 8C12 8.55 12.45 9 13 9C13.55 9 14 8.55 14 8C14 7.45 13.55 7 13 7ZM8 7C7.45 7 7 7.45 7 8C7 8.55 7.45 9 8 9C8.55 9 9 8.55 9 8C9 7.45 8.55 7 8 7Z"
      fill="currentColor"
    />
  </svg>
);

export const LinkIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    {...props}
  >
    <path
      d="M13.7732 11.6499L12.7126 10.5893L13.7732 9.5286C15.2377 8.06415 15.2377 5.68977 13.7732 4.22531C12.3088 2.76084 9.93434 2.76084 8.46989 4.22531L7.40923 5.28596L6.34858 4.22531L7.40923 3.16464C9.45952 1.11439 12.7836 1.11439 14.8339 3.16464C16.8841 5.2149 16.8841 8.53898 14.8339 10.5893L13.7732 11.6499ZM11.6518 13.7713L10.5912 14.8319C8.54099 16.8821 5.21685 16.8821 3.1666 14.8319C1.11634 12.7817 1.11634 9.4575 3.1666 7.40729L4.22725 6.34662L5.28792 7.40729L4.22725 8.46795C2.76279 9.9324 2.76279 12.3068 4.22725 13.7713C5.69172 15.2357 8.06609 15.2357 9.53054 13.7713L10.5912 12.7106L11.6518 13.7713ZM11.1215 5.8163L12.1822 6.87696L6.87891 12.1802L5.81824 11.1196L11.1215 5.8163Z"
      fill="currentColor"
    />
  </svg>
);

export const StartIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    {...props}
  >
    <g clipPath="url(#clip0_69_16087)">
      <path
        d="M6.19222 10.3792L6.70415 9.2066C7.1598 8.16314 7.97985 7.33247 9.00278 6.8784L10.4119 6.2529C10.8599 6.05404 10.8599 5.40227 10.4119 5.2034L9.04676 4.59742C7.99752 4.13167 7.16277 3.27026 6.71495 2.19117L6.19636 0.941547C6.00392 0.477817 5.36318 0.477818 5.17075 0.941547L4.65215 2.19116C4.20432 3.27026 3.36955 4.13167 2.32032 4.59742L0.95516 5.2034C0.507135 5.40227 0.507134 6.05404 0.95516 6.2529L2.36433 6.8784C3.38726 7.33247 4.20732 8.16314 4.66293 9.2066L5.17489 10.3792C5.37168 10.8299 5.9954 10.8299 6.19222 10.3792ZM11.318 13.2342L11.4619 12.9042C11.7186 12.3159 12.1809 11.8474 12.7577 11.5912L13.2013 11.394C13.4412 11.2875 13.4412 10.9388 13.2013 10.8322L12.7825 10.6462C12.1909 10.3833 11.7203 9.8975 11.468 9.28915L11.3202 8.93255C11.2171 8.68405 10.8735 8.68405 10.7705 8.93255L10.6226 9.28915C10.3704 9.8975 9.89983 10.3833 9.30815 10.6462L8.88938 10.8322C8.64951 10.9388 8.64951 11.2875 8.88938 11.394L9.33295 11.5912C9.9098 11.8474 10.372 12.3159 10.6287 12.9042L10.7727 13.2342C10.8781 13.4758 11.2126 13.4758 11.318 13.2342Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_69_16087">
        <rect width="14" height="14" fill="currentColor" />
      </clipPath>
    </defs>
  </svg>
);

export const ConversationsIcon = (props?: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    {...props}
  >
    <path
      d="M12.0827 4.74205L11.9388 5.07203C11.8336 5.31361 11.4994 5.31361 11.3941 5.07203L11.2504 4.74205C10.994 4.15368 10.5322 3.68522 9.95599 3.42895L9.51284 3.23186C9.27326 3.12529 9.27326 2.77662 9.51284 2.67005L9.9312 2.48398C10.5222 2.22112 10.9923 1.73533 11.2442 1.12697L11.3919 0.770377C11.4949 0.521853 11.8381 0.521853 11.941 0.770377L12.0887 1.12697C12.3407 1.73533 12.8108 2.22112 13.4018 2.48398L13.8201 2.67005C14.0597 2.77662 14.0597 3.12529 13.8201 3.23186L13.377 3.42895C12.8008 3.68522 12.339 4.15368 12.0827 4.74205ZM5.83317 1.75065H8.1665V2.91732H5.83317C3.90017 2.91732 2.33317 4.48432 2.33317 6.41732C2.33317 8.52315 3.76938 9.89725 6.99984 11.3639V9.91732H8.1665C10.0995 9.91732 11.6665 8.35031 11.6665 6.41732H12.8332C12.8332 8.99466 10.7438 11.084 8.1665 11.084V13.1257C5.24984 11.959 1.1665 10.209 1.1665 6.41732C1.1665 3.83999 3.25584 1.75065 5.83317 1.75065Z"
      fill="currentColor"
    />
  </svg>
);

export const MaterialsIcon = (props?: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    {...props}
  >
    <path
      d="M11.0832 12.8327H2.9165C1.95001 12.8327 1.1665 12.0492 1.1665 11.0827V1.74935C1.1665 1.42719 1.42767 1.16602 1.74984 1.16602H9.9165C10.2387 1.16602 10.4998 1.42719 10.4998 1.74935V8.74935H12.8332V11.0827C12.8332 12.0492 12.0497 12.8327 11.0832 12.8327ZM10.4998 9.91602V11.0827C10.4998 11.4049 10.761 11.666 11.0832 11.666C11.4053 11.666 11.6665 11.4049 11.6665 11.0827V9.91602H10.4998ZM9.33317 11.666V2.33268H2.33317V11.0827C2.33317 11.4049 2.59434 11.666 2.9165 11.666H9.33317ZM3.49984 4.08268H8.1665V5.24935H3.49984V4.08268ZM3.49984 6.41602H8.1665V7.58268H3.49984V6.41602ZM3.49984 8.74935H6.4165V9.91602H3.49984V8.74935Z"
      fill="currentColor"
    />
  </svg>
);

export const WebsiteIcon = (props?: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    {...props}
  >
    <path
      d="M2.33317 9.33333H11.6665V2.91667H2.33317V9.33333ZM7.58317 10.5V11.6667H9.9165V12.8333H4.08317V11.6667H6.4165V10.5H1.74505C1.42553 10.5 1.1665 10.2381 1.1665 9.91229V2.3377C1.1665 2.01312 1.4321 1.75 1.74505 1.75H12.2546C12.5742 1.75 12.8332 2.01187 12.8332 2.3377V9.91229C12.8332 10.2369 12.5676 10.5 12.2546 10.5H7.58317Z"
      fill="currentColor"
    />
  </svg>
);

export const CaptureIcon = (props?: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    {...props}
  >
    <path
      d="M9.91667 1.16602V2.33268H11.6705C11.9905 2.33268 12.25 2.59224 12.25 2.91217V12.2532C12.25 12.5732 11.9905 12.8327 11.6705 12.8327H2.32948C2.00944 12.8327 1.75 12.5732 1.75 12.2532V2.91217C1.75 2.59213 2.00955 2.33268 2.32948 2.33268H4.08333V1.16602H9.91667ZM4.08333 3.49935H2.91667V11.666H11.0833V3.49935H9.91667V4.66602H4.08333V3.49935ZM5.25 9.33268V10.4993H4.08333V9.33268H5.25ZM5.25 7.58268V8.74935H4.08333V7.58268H5.25ZM5.25 5.83268V6.99935H4.08333V5.83268H5.25ZM8.75 2.33268H5.25V3.49935H8.75V2.33268Z"
      fill="currentColor"
    />
  </svg>
);

export const QualifyIcon = (props?: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    {...props}
  >
    <path
      d="M11.4993 5.32408L11.3555 5.65406C11.2502 5.89562 10.9161 5.89562 10.8108 5.65406L10.667 5.32408C10.4106 4.73571 9.94888 4.26725 9.37266 4.01098L8.9295 3.81389C8.68993 3.70732 8.68993 3.35865 8.9295 3.25209L9.34787 3.06601C9.9389 2.80315 10.409 2.31736 10.6609 1.709L10.8086 1.35241C10.9116 1.10388 11.2548 1.10388 11.3577 1.35241L11.5054 1.709C11.7574 2.31736 12.2274 2.80315 12.8185 3.06601L13.2368 3.25209C13.4764 3.35865 13.4764 3.70732 13.2368 3.81389L12.7937 4.01098C12.2175 4.26725 11.7557 4.73571 11.4993 5.32408ZM3.49984 2.91602C2.8555 2.91602 2.33317 3.43835 2.33317 4.08268V9.91602C2.33317 10.5604 2.8555 11.0827 3.49984 11.0827H10.4998C11.1442 11.0827 11.6665 10.5604 11.6665 9.91602V6.99935H12.8332V9.91602C12.8332 11.2047 11.7885 12.2493 10.4998 12.2493H3.49984C2.21117 12.2493 1.1665 11.2047 1.1665 9.91602V4.08268C1.1665 2.79402 2.21117 1.74935 3.49984 1.74935H7.58317V2.91602H3.49984Z"
      fill="currentColor"
    />
  </svg>
);

export const NotificationIcon = (props?: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    {...props}
  >
    <path
      d="M2.5 9H9.5V5.5157C9.5 3.57403 7.933 2 6 2C4.06701 2 2.5 3.57403 2.5 5.5157V9ZM6 1C8.4853 1 10.5 3.02174 10.5 5.5157V10H1.5V5.5157C1.5 3.02174 3.51472 1 6 1ZM4.75 10.5H7.25C7.25 11.1903 6.69035 11.75 6 11.75C5.30965 11.75 4.75 11.1903 4.75 10.5Z"
      fill="currentColor"
    />
  </svg>
);

export const AnalyticsIcon = (props?: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    {...props}
  >
    <path
      d="M11.4996 4.74205L11.3558 5.07203C11.2506 5.3136 10.9164 5.3136 10.8111 5.07203L10.6673 4.74205C10.411 4.15368 9.9492 3.68522 9.37299 3.42895L8.92983 3.23186C8.69025 3.12529 8.69025 2.77662 8.92983 2.67005L9.3482 2.48398C9.93923 2.22112 10.4093 1.73533 10.6612 1.12697L10.8089 0.770377C10.9119 0.521853 11.2551 0.521853 11.358 0.770377L11.5057 1.12697C11.7577 1.73533 12.2278 2.22112 12.8188 2.48398L13.2371 2.67005C13.4767 2.77662 13.4767 3.12529 13.2371 3.23186L12.794 3.42895C12.2178 3.68522 11.756 4.15368 11.4996 4.74205ZM8.75016 12.5648L5.25016 4.39817L3.88481 7.58398H0.583496V6.41732H3.11551L5.25016 1.43649L8.75016 9.60313L10.1155 6.41732H13.4168V7.58398H10.8848L8.75016 12.5648Z"
      fill="currentColor"
    />
  </svg>
);

export const PinIcon = (props?: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    {...props}
  >
    <path
      d="M8.06609 0.986328L13.0158 5.93609L12.1909 6.76104L11.7784 6.34856L9.30351 8.82341L8.89104 10.8858L8.06609 11.7108L5.59122 9.23589L2.70387 12.1233L1.87891 11.2983L4.76626 8.41094L2.29139 5.93609L3.11634 5.11112L5.17874 4.69864L7.65361 2.22376L7.24114 1.81129L8.06609 0.986328ZM8.47856 3.04873L5.75392 5.77338L4.10782 6.10257L7.89955 9.89435L8.22878 8.24824L10.9535 5.5236L8.47856 3.04873Z"
      fill="currentColor"
    />
  </svg>
);

export const StartsIcon = (props?: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    {...props}
  >
    <path
      d="M8.16683 2.58789C8.95211 2.58789 9.5887 1.95129 9.5887 1.16602H10.245C10.245 1.95129 10.8815 2.58789 11.6668 2.58789V3.24414C10.8815 3.24414 10.245 3.88074 10.245 4.66602H9.5887C9.5887 3.88074 8.95211 3.24414 8.16683 3.24414V2.58789ZM0.583496 6.41602C2.51649 6.41602 4.0835 4.84901 4.0835 2.91602H5.25016C5.25016 4.84901 6.81717 6.41602 8.75016 6.41602V7.58268C6.81717 7.58268 5.25016 9.14969 5.25016 11.0827H4.0835C4.0835 9.14969 2.51649 7.58268 0.583496 7.58268V6.41602ZM2.8445 6.99935C3.60935 7.42378 4.24241 8.05682 4.66683 8.82168C5.09125 8.05682 5.72431 7.42378 6.48916 6.99935C5.72431 6.57492 5.09125 5.94188 4.66683 5.17702C4.24241 5.94188 3.60935 6.57492 2.8445 6.99935ZM10.0627 8.16602C10.0627 9.21304 9.21385 10.0618 8.16683 10.0618V10.9368C9.21385 10.9368 10.0627 11.7857 10.0627 12.8327H10.9377C10.9377 11.7857 11.7865 10.9368 12.8335 10.9368V10.0618C11.7865 10.0618 10.9377 9.21304 10.9377 8.16602H10.0627Z"
      fill="currentColor"
    />
  </svg>
);

export const ShareIcon = (props?: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    {...props}
  >
    <path
      d="M5.83333 3.5V4.66667H2.91667V11.0833H9.33333V8.16667H10.5V11.6667C10.5 11.9888 10.2388 12.25 9.91667 12.25H2.33333C2.01117 12.25 1.75 11.9888 1.75 11.6667V4.08333C1.75 3.76117 2.01117 3.5 2.33333 3.5H5.83333ZM12.25 1.75V6.41667H11.0833L11.0833 3.74092L6.53747 8.28747L5.71252 7.46252L10.2579 2.91667H7.58333V1.75H12.25Z"
      fill="currentColor"
    />
  </svg>
);

export const SupportIcon = (props?: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    {...props}
  >
    <path
      d="M6.91881 1.39352C7.49538 1.00914 8.24444 1.00117 8.82905 1.3732L11.2529 2.91566H12.2497C12.5719 2.91566 12.8331 3.17683 12.8331 3.49899V8.74897C12.8331 9.07114 12.5719 9.3323 12.2497 9.3323H11.3632C11.3979 9.88489 11.1376 10.4466 10.6139 10.7609L7.64273 12.5436C7.26765 12.7686 6.80203 12.7633 6.43482 12.5392C6.02631 12.9004 5.39748 12.9402 4.94128 12.5818L1.9425 10.2256C1.49543 9.87433 1.38237 9.2742 1.61321 8.79843C1.33128 8.57735 1.1665 8.23884 1.1665 7.88038V3.49902C1.1665 3.17686 1.42767 2.91569 1.74984 2.91569H4.63555L6.91881 1.39352ZM2.43388 7.95872L2.83756 7.60552C3.55518 6.97756 4.64342 7.03974 5.28484 7.74534L6.86112 9.47924C7.36833 10.0372 7.46085 10.8569 7.09195 11.5134L10.0136 9.76047C10.1778 9.662 10.2372 9.46512 10.176 9.29928L7.5935 5.68391C7.44842 5.48082 7.19024 5.39251 6.95119 5.46423L5.50146 5.89915C4.88482 6.08412 4.21639 5.9156 3.76116 5.4604L3.59038 5.28961C3.25904 4.95827 3.17336 4.48671 3.31279 4.08236H2.33317V7.88038L2.43388 7.95872ZM8.20273 2.35748C8.00784 2.23346 7.75817 2.23612 7.56596 2.36425L4.41534 4.46466L4.58612 4.63544C4.73786 4.78718 4.96067 4.84335 5.16622 4.78169L6.61595 4.34677C7.3331 4.13162 8.1077 4.39653 8.54287 5.00579L10.7999 8.16563H11.6664V4.08232H11.2529C11.031 4.08232 10.8137 4.01905 10.6265 3.89993L8.20273 2.35748ZM3.60582 8.48349L2.6633 9.30821L5.66207 11.6644L6.07269 10.9458C6.1981 10.7263 6.16789 10.4511 5.99785 10.264L4.42158 8.5301C4.20777 8.2949 3.84502 8.27419 3.60582 8.48349Z"
      fill="currentColor"
    />
  </svg>
);

export const PanelLeftIcon = (props?: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="10"
    viewBox="0 0 12 10"
    fill="none"
    {...props}
  >
    <path
      d="M7.81469 0L8.81295 1L5.5258 4.29288L12 4.29296V5.70717L5.5258 5.70709L8.81295 9.00001L7.81469 10L2.82338 4.99999L7.81469 0ZM0 9.94965V0.0502184H1.41176V9.94965H0Z"
      fill="currentColor"
    />
  </svg>
);

export const PanelRightIcon = (props?: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    {...props}
  >
    <path
      d="M14.2222 14.7222L7.11111 14.7222L7.11111 2.27778L14.2222 2.27778L14.2222 14.7222ZM1.77778 2.27778L5.33333 2.27778L5.33333 14.7222L1.77778 14.7222L1.77778 2.27778ZM15.1111 16.5C15.602 16.5 16 16.102 16 15.6111L16 1.38889C16 0.897956 15.602 0.5 15.1111 0.5L0.88889 0.499999C0.397957 0.499999 1.36397e-06 0.897954 1.32106e-06 1.38889L7.77091e-08 15.6111C3.47919e-08 16.102 0.397956 16.5 0.888888 16.5L15.1111 16.5ZM12.4444 8.5L8.88889 11.6111L8.88889 5.38889L12.4444 8.5Z"
      fill="currentColor"
    />
  </svg>
);

export const SuccessIcon = (props?: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    {...props}
  >
    <g clipPath="url(#clip0_6681_1160)">
      <path
        d="M5.25033 6.99996L6.41699 8.16663L8.75033 5.83329M12.8337 6.99996C12.8337 10.2216 10.222 12.8333 7.00033 12.8333C3.77866 12.8333 1.16699 10.2216 1.16699 6.99996C1.16699 3.7783 3.77866 1.16663 7.00033 1.16663C10.222 1.16663 12.8337 3.7783 12.8337 6.99996Z"
        stroke="#116932"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_6681_1160">
        <rect width="14" height="14" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const StopIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    {...props}
  >
    <path
      d="M10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20ZM7 7V13H13V7H7Z"
      fill="currentColor"
    />
  </svg>
);

export const MessageIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    {...props}
  >
    <path
      d="M6.45455 19.5L2 23V4.5C2 3.94772 2.44772 3.5 3 3.5H21C21.5523 3.5 22 3.94772 22 4.5V18.5C22 19.0523 21.5523 19.5 21 19.5H6.45455ZM5.76282 17.5H20V5.5H4V18.8851L5.76282 17.5ZM11 10.5H13V12.5H11V10.5ZM7 10.5H9V12.5H7V10.5ZM15 10.5H17V12.5H15V10.5Z"
      fill="currentColor"
    />
  </svg>
);

export const TipIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <path
      d="M7.99998 14.6668C4.31808 14.6668 1.33331 11.682 1.33331 8.00016C1.33331 4.31826 4.31808 1.3335 7.99998 1.3335C11.6818 1.3335 14.6666 4.31826 14.6666 8.00016C14.6666 11.682 11.6818 14.6668 7.99998 14.6668ZM7.99998 13.3335C10.9455 13.3335 13.3333 10.9457 13.3333 8.00016C13.3333 5.05464 10.9455 2.66683 7.99998 2.66683C5.05446 2.66683 2.66665 5.05464 2.66665 8.00016C2.66665 10.9457 5.05446 13.3335 7.99998 13.3335ZM7.33331 4.66683H8.66665V6.00016H7.33331V4.66683ZM7.33331 7.3335H8.66665V11.3335H7.33331V7.3335Z"
      fill="currentColor"
    />
  </svg>
);

export const Tip2Icon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    {...props}
  >
    <g clipPath="url(#clip0_5445_34839)">
      <path
        d="M7 4.66699V7.00033M7 9.33366H7.00583M12.8333 7.00033C12.8333 10.222 10.2217 12.8337 7 12.8337C3.77834 12.8337 1.16666 10.222 1.16666 7.00033C1.16666 3.77866 3.77834 1.16699 7 1.16699C10.2217 1.16699 12.8333 3.77866 12.8333 7.00033Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_5445_34839">
        <rect width="14" height="14" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const PhoneIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    {...props}
  >
    <path
      d="M18 13.42V16.9561C18 17.4811 17.5941 17.9167 17.0705 17.9537C16.6331 17.9846 16.2763 18 16 18C7.1634 18 0 10.8366 0 2C0 1.72371 0.01545 1.36687 0.04635 0.9295C0.08337 0.40588 0.51894 0 1.04386 0H4.5801C4.83678 0 5.05176 0.19442 5.07753 0.4498C5.10067 0.67907 5.12218 0.86314 5.14207 1.00202C5.34435 2.41472 5.75753 3.75936 6.3487 5.00303C6.44359 5.20265 6.38171 5.44159 6.20185 5.57006L4.04355 7.1118C5.35752 10.1811 7.8189 12.6425 10.8882 13.9565L12.4271 11.8019C12.5572 11.6199 12.799 11.5573 13.001 11.6532C14.2446 12.2439 15.5891 12.6566 17.0016 12.8584C17.1396 12.8782 17.3225 12.8995 17.5502 12.9225C17.8056 12.9483 18 13.1633 18 13.42Z"
      fill="currentColor"
    />
  </svg>
);

export const AvatarIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="54"
    height="54"
    viewBox="0 0 54 54"
    fill="none"
    {...props}
  >
    <path
      d="M27 4.5C39.42 4.5 49.5 14.58 49.5 27C49.5 39.42 39.42 49.5 27 49.5C14.58 49.5 4.5 39.42 4.5 27C4.5 14.58 14.58 4.5 27 4.5ZM13.5525 34.6867C16.8544 39.6155 21.814 42.75 27.3593 42.75C32.9047 42.75 37.8644 39.6155 41.1662 34.6867C37.5491 31.3137 32.6952 29.25 27.3593 29.25C22.0235 29.25 17.1696 31.3137 13.5525 34.6867ZM27 24.75C30.728 24.75 33.75 21.7279 33.75 18C33.75 14.2721 30.728 11.25 27 11.25C23.272 11.25 20.25 14.2721 20.25 18C20.25 21.7279 23.272 24.75 27 24.75Z"
      fill="currentColor"
    />
  </svg>
);

export const LeadInfoIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <path
      d="M1.33325 5.99583C1.33325 3.78899 3.11761 2 5.33369 2H10.6661C12.8755 2 14.6666 3.79652 14.6666 5.99583V14H5.33369C3.12431 14 1.33325 12.2035 1.33325 10.0042V5.99583ZM13.3333 12.6667V5.99583C13.3333 4.53026 12.1365 3.33333 10.6661 3.33333H5.33369C3.85631 3.33333 2.66659 4.52305 2.66659 5.99583V10.0042C2.66659 11.4697 3.86333 12.6667 5.33369 12.6667H13.3333ZM9.33325 7.33333H10.6666V8.66667H9.33325V7.33333ZM5.33325 7.33333H6.66658V8.66667H5.33325V7.33333Z"
      fill="currentColor"
    />
  </svg>
);

export const PointInfoIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <path
      d="M7.99992 14.6668C4.31802 14.6668 1.33325 11.682 1.33325 8.00016C1.33325 4.31826 4.31802 1.3335 7.99992 1.3335C11.6818 1.3335 14.6666 4.31826 14.6666 8.00016C14.6666 11.682 11.6818 14.6668 7.99992 14.6668ZM7.99992 13.3335C10.9455 13.3335 13.3333 10.9457 13.3333 8.00016C13.3333 5.05464 10.9455 2.66683 7.99992 2.66683C5.0544 2.66683 2.66659 5.05464 2.66659 8.00016C2.66659 10.9457 5.0544 13.3335 7.99992 13.3335ZM8.66658 7.00016V10.0002H9.33325V11.3335H6.66658V10.0002H7.33325V8.3335H6.66658V7.00016H8.66658ZM8.99992 5.3335C8.99992 5.88578 8.55219 6.3335 7.99992 6.3335C7.44765 6.3335 6.99992 5.88578 6.99992 5.3335C6.99992 4.78121 7.44765 4.3335 7.99992 4.3335C8.55219 4.3335 8.99992 4.78121 8.99992 5.3335Z"
      fill="currentColor"
    />
  </svg>
);

export const InsightsIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <path
      d="M12.0206 11.078L14.8757 13.9332L13.9329 14.876L11.0778 12.0208C10.0512 12.8422 8.74925 13.3335 7.33325 13.3335C4.02125 13.3335 1.33325 10.6455 1.33325 7.3335C1.33325 4.0215 4.02125 1.3335 7.33325 1.3335C10.6453 1.3335 13.3333 4.0215 13.3333 7.3335C13.3333 8.7495 12.8419 10.0514 12.0206 11.078ZM10.6831 10.5834C11.4983 9.74323 11.9999 8.59723 11.9999 7.3335C11.9999 4.75516 9.91158 2.66683 7.33325 2.66683C4.75492 2.66683 2.66659 4.75516 2.66659 7.3335C2.66659 9.91183 4.75492 12.0002 7.33325 12.0002C8.59698 12.0002 9.74298 11.4985 10.5831 10.6833L10.6831 10.5834ZM8.11852 4.78432C7.65552 4.99338 7.33325 5.45914 7.33325 6.00016C7.33325 6.73656 7.93018 7.3335 8.66658 7.3335C9.20758 7.3335 9.67338 7.01123 9.88245 6.54824C9.95879 6.7965 9.99992 7.06016 9.99992 7.3335C9.99992 8.80623 8.80598 10.0002 7.33325 10.0002C5.86049 10.0002 4.66658 8.80623 4.66658 7.3335C4.66658 5.86074 5.86049 4.66683 7.33325 4.66683C7.60659 4.66683 7.87025 4.70794 8.11852 4.78432Z"
      fill="currentColor"
    />
  </svg>
);

export const ActionsIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <path
      d="M4.66645 4.66683V2.00016C4.66645 1.63198 4.96492 1.3335 5.33311 1.3335H13.9998C14.368 1.3335 14.6665 1.63198 14.6665 2.00016V10.6668C14.6665 11.035 14.368 11.3335 13.9998 11.3335H11.3333V13.9952C11.3333 14.3661 11.0339 14.6668 10.6616 14.6668H2.00477C1.63383 14.6668 1.33325 14.3676 1.33325 13.9952L1.33509 5.33848C1.33517 4.96754 1.63445 4.66683 2.00675 4.66683H4.66645ZM5.99978 4.66683H10.6617C11.0326 4.66683 11.3333 4.96611 11.3333 5.33848V10.0002H13.3331V2.66683H5.99978V4.66683ZM9.99992 6.00016H2.66829L2.66673 13.3335H9.99992V6.00016ZM5.6682 12.0002L3.31118 9.64316L4.25399 8.70036L5.6682 10.1146L8.49665 7.2861L9.43945 8.2289L5.6682 12.0002Z"
      fill="currentColor"
    />
  </svg>
);

export const AlertIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <path
      d="M14.6666 13.3335H1.33325V12.0002H1.99992V7.35443C1.99992 4.02915 4.68621 1.3335 7.99992 1.3335C11.3137 1.3335 13.9999 4.02915 13.9999 7.35443V12.0002H14.6666V13.3335ZM3.33325 12.0002H12.6666V7.35443C12.6666 4.76554 10.5773 2.66683 7.99992 2.66683C5.42259 2.66683 3.33325 4.76554 3.33325 7.35443V12.0002ZM6.33325 14.0002H9.66658C9.66658 14.9206 8.92038 15.6668 7.99992 15.6668C7.07945 15.6668 6.33325 14.9206 6.33325 14.0002Z"
      fill="currentColor"
    />
  </svg>
);

export const ThemeIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <path
      d="M3.14227 4.75207L2.97788 5.12919C2.85758 5.40528 2.47571 5.40528 2.35541 5.12919L2.19104 4.75207C1.89804 4.07965 1.3703 3.54427 0.71178 3.25139L0.205365 3.02615C-0.0684548 2.90435 -0.0684548 2.50587 0.205365 2.38408L0.683467 2.17143C1.35892 1.87101 1.89611 1.31582 2.18408 0.620552L2.35288 0.213023C2.47052 -0.0710075 2.86278 -0.0710075 2.98042 0.213023L3.14921 0.620552C3.43718 1.31582 3.97439 1.87101 4.64987 2.17143L5.12792 2.38408C5.40181 2.50587 5.40181 2.90435 5.12792 3.02615L4.62152 3.25139C3.96301 3.54427 3.43525 4.07965 3.14227 4.75207ZM10.2096 6.35523L10.3043 6.44994C11.1675 7.34533 11.5537 8.65787 11.2084 9.94673C10.7763 11.5595 9.31347 12.6656 7.66773 12.6656C6.31048 12.6656 4.52565 12.2484 3.01907 11.6561C3.82299 10.7131 4.11615 9.78333 4.219 8.53667C4.24383 8.23573 4.25934 8.11607 4.2879 8.00947C4.81694 6.03507 6.67787 4.93677 8.61567 5.45599C9.2366 5.62238 9.7774 5.93855 10.2096 6.35523ZM12.1519 1.58087L8.85907 4.14193C6.22816 3.49282 3.70562 5.03097 3 7.6644C2.93217 7.91753 2.91098 8.17467 2.88878 8.444C2.81219 9.37327 2.72369 10.4471 0.666667 11.9977C2.33333 12.9977 5.33333 13.9989 7.66773 13.9989C9.87613 13.9989 11.8975 12.5264 12.4963 10.2918C12.7224 9.44793 12.7185 8.59667 12.5231 7.80447L15.0835 4.51253C15.2899 4.24713 15.2665 3.86957 15.0287 3.63183L13.0325 1.6357C12.7948 1.39796 12.4173 1.37445 12.1519 1.58087ZM11.2635 5.52347C11.2213 5.47968 11.1782 5.43663 11.1343 5.39433L10.3846 4.64457L12.5059 2.99465L13.6697 4.15849L12.0198 6.27981L11.2635 5.52347Z"
      fill="currentColor"
    />
  </svg>
);

export const ArrowUpDown = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <path
      d="M7.96656 5.29983L7.02376 6.24264L5.33388 4.552L5.33338 13.3333H4.00005L4.00055 4.552L2.3097 6.24264L1.36688 5.29983L4.66672 2L7.96656 5.29983ZM14.6332 10.7002L11.3334 14L8.03356 10.7002L8.97636 9.75733L10.6672 11.448L10.6667 2.66667H12L12.0006 11.448L13.6904 9.75733L14.6332 10.7002Z"
      fill="#5C5C5C"
    />
  </svg>
);

export const RunIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    {...props}
  >
    <path
      d="M12.2958 9.0005L7.5 5.80325V12.1977L12.2958 9.0005ZM14.532 9.3125L6.58301 14.6118C6.41069 14.7267 6.17786 14.6801 6.06298 14.5078C6.02192 14.4462 6 14.3738 6 14.2998V3.70117C6 3.49406 6.16789 3.32617 6.375 3.32617C6.44903 3.32617 6.52142 3.34809 6.58301 3.38915L14.532 8.68842C14.7043 8.80332 14.7509 9.0362 14.636 9.20847C14.6085 9.24965 14.5732 9.28505 14.532 9.3125Z"
      fill="currentColor"
    />
  </svg>
);

export const BrandIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      d="M20.7134 8.12811L20.4668 8.69379C20.2864 9.10792 19.7136 9.10792 19.5331 8.69379L19.2866 8.12811C18.8471 7.11947 18.0555 6.31641 17.0677 5.87708L16.308 5.53922C15.8973 5.35653 15.8973 4.75881 16.308 4.57612L17.0252 4.25714C18.0384 3.80651 18.8442 2.97373 19.2761 1.93083L19.5293 1.31953C19.7058 0.89349 20.2942 0.89349 20.4706 1.31953L20.7238 1.93083C21.1558 2.97373 21.9616 3.80651 22.9748 4.25714L23.6919 4.57612C24.1027 4.75881 24.1027 5.35653 23.6919 5.53922L22.9323 5.87708C21.9445 6.31641 21.1529 7.11947 20.7134 8.12811ZM12 2C6.47715 2 2 6.47715 2 12C2 13.7025 2.42544 15.3056 3.17581 16.7088L2 22L7.29117 20.8242C8.6944 21.5746 10.2975 22 12 22C17.5228 22 22 17.5228 22 12C22 11.5975 21.9762 11.2002 21.9298 10.8094L19.9437 11.0452C19.9809 11.3579 20 11.6765 20 12C20 16.4183 16.4183 20 12 20C10.6655 20 9.38248 19.6745 8.23428 19.0605L7.58075 18.711L4.63416 19.3658L5.28896 16.4192L4.93949 15.7657C4.32549 14.6175 4 13.3345 4 12C4 7.58172 7.58172 4 12 4C12.6919 4 13.3618 4.0876 14 4.25179L14.4983 2.31487C13.6987 2.10914 12.8614 2 12 2ZM9 12H7C7 14.7614 9.23858 17 12 17C14.7614 17 17 14.7614 17 12H15C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12Z"
      fill="currentColor"
    />
  </svg>
);

export const VoiceAgentIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <g clipPath="url(#clip0_5557_12229)">
      <path
        d="M13.8089 4.75207L13.6445 5.12919C13.5243 5.40528 13.1424 5.40528 13.0221 5.12919L12.8577 4.75207C12.5647 4.07965 12.037 3.54427 11.3785 3.25139L10.872 3.02615C10.5982 2.90435 10.5982 2.50587 10.872 2.38408L11.3501 2.17143C12.0256 1.87101 12.5628 1.31582 12.8507 0.620552L13.0195 0.213023C13.1372 -0.0710075 13.5295 -0.0710075 13.6471 0.213023L13.8159 0.620552C14.1039 1.31582 14.6411 1.87101 15.3165 2.17143L15.7946 2.38408C16.0685 2.50587 16.0685 2.90435 15.7946 3.02615L15.2882 3.25139C14.6297 3.54427 14.1019 4.07965 13.8089 4.75207ZM5.66667 4H4.33334V12H5.66667V4ZM2.66667 6.66667H1.33334V9.33333H2.66667V6.66667ZM8.66667 1.33333H7.33334V14.6667H8.66667V1.33333ZM11.6667 5.33333H10.3333V12H11.6667V5.33333ZM14.6667 6.66667H13.3333V9.33333H14.6667V6.66667Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_5557_12229">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const SwitchCheckIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <path
      d="M6.66647 10.1146L12.7947 3.98633L13.7375 4.92914L6.66647 12.0002L2.42383 7.75758L3.36664 6.81478L6.66647 10.1146Z"
      fill="currentColor"
    />
  </svg>
);

export const GirlIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <g clipPath="url(#clip0_5515_53603)">
      <path
        d="M9.99998 2.14843e-05C8.88448 -0.00296517 7.79029 0.305499 6.84059 0.890687C5.8909 1.47587 5.12341 2.31455 4.62454 3.31229C4.12567 4.31003 3.91522 5.42723 4.01689 6.53809C4.11855 7.64896 4.5283 8.7094 5.19999 9.60001L4.39999 10.4L2.168 8.17601L1.032 9.31201L3.29599 11.576L0 14.872L1.128 16L4.42399 12.704L6.68799 14.968L7.81599 13.84L5.55999 11.568L6.35999 10.768C7.11734 11.3465 8.00162 11.7364 8.9396 11.9052C9.87758 12.0739 10.8423 12.0169 11.7538 11.7387C12.6653 11.4604 13.4975 10.9691 14.1813 10.3053C14.8652 9.64145 15.3811 8.82429 15.6863 7.92143C15.9915 7.01857 16.0772 6.056 15.9364 5.11342C15.7956 4.17083 15.4322 3.27535 14.8764 2.50113C14.3207 1.72691 13.5885 1.09621 12.7405 0.661274C11.8925 0.226334 10.953 -0.000339982 9.99998 2.14843e-05ZM9.99998 10.4C9.12975 10.4 8.27905 10.142 7.55548 9.65847C6.8319 9.175 6.26795 8.48781 5.93492 7.68382C5.6019 6.87982 5.51476 5.99513 5.68454 5.14162C5.85431 4.2881 6.27337 3.5041 6.88872 2.88875C7.50407 2.2734 8.28807 1.85434 9.14159 1.68456C9.9951 1.51479 10.8798 1.60192 11.6838 1.93495C12.4878 2.26797 13.175 2.83193 13.6584 3.55551C14.1419 4.27908 14.4 5.12978 14.4 6.00001C14.3979 7.16631 13.9336 8.28424 13.1089 9.10894C12.2842 9.93364 11.1663 10.3979 9.99998 10.4Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_5515_53603">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const BoyIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    {...props}
  >
    <path
      d="M16.0875 1.125H9.9C9.45 1.125 9.1125 1.4625 9.1125 1.9125C9.1125 2.3625 9.45 2.7 9.9 2.7H14.0625L11.25 5.625C10.125 4.725 8.775 4.05 7.3125 4.05C3.9375 4.05 1.125 6.975 1.125 10.4625C1.125 13.95 3.9375 16.875 7.3125 16.875C10.6875 16.875 13.5 13.95 13.5 10.4625C13.5 9.1125 13.05 7.7625 12.375 6.75L15.4125 3.6V8.325C15.4125 8.775 15.75 9.1125 16.2 9.1125C16.65 9.1125 16.9875 8.775 16.9875 8.325V1.9125C16.875 1.4625 16.5375 1.125 16.0875 1.125ZM7.3125 15.3C4.725 15.3 2.7 13.1625 2.7 10.4625C2.7 7.7625 4.725 5.625 7.3125 5.625C9.9 5.625 11.925 7.7625 11.925 10.4625C11.925 13.1625 9.9 15.3 7.3125 15.3Z"
      fill="#0175EB"
    />
  </svg>
);

export const Voice2Icon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M11 4.702a.705.705 0 0 0-1.203-.498L6.413 7.587A1.4 1.4 0 0 1 5.416 8H3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h2.416a1.4 1.4 0 0 1 .997.413l3.383 3.384A.705.705 0 0 0 11 19.298z" />
    <path d="M16 9a5 5 0 0 1 0 6" />
    <path d="M19.364 18.364a9 9 0 0 0 0-12.728" />
  </svg>
);

export const Voice3Icon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <style>
      {`
        @keyframes normalPulse {
          0%, 100% { opacity: 1; }
          50% { opacity: 0.3; }
        }
        @keyframes slowPulse {
          0%, 100% { opacity: 1; }
          50% { opacity: 0.2; }
        }
        .voice-wave-normal {
          animation: normalPulse 1s ease-in-out infinite;
        }
        .voice-wave-slow {
          animation: slowPulse 2s ease-in-out infinite;
        }
      `}
    </style>
    <path d="M11 4.702a.705.705 0 0 0-1.203-.498L6.413 7.587A1.4 1.4 0 0 1 5.416 8H3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h2.416a1.4 1.4 0 0 1 .997.413l3.383 3.384A.705.705 0 0 0 11 19.298z" />
    <path className="voice-wave-normal" d="M16 9a5 5 0 0 1 0 6" />
    <path className="voice-wave-slow" d="M19.364 18.364a9 9 0 0 0 0-12.728" />
  </svg>
);

export const FilesIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    {...props}
  >
    <path
      d="M17.5 6.66675V17.4944C17.5 17.9585 17.1293 18.3334 16.6722 18.3334H3.32783C2.87079 18.3334 2.5 17.9634 2.5 17.5069V2.49325C2.5 2.04617 2.87392 1.66675 3.33518 1.66675H12.4973L17.5 6.66675ZM15.8333 7.50008H11.6667V3.33341H4.16667V16.6667H15.8333V7.50008ZM6.66667 5.83341H9.16667V7.50008H6.66667V5.83341ZM6.66667 9.16675H13.3333V10.8334H6.66667V9.16675ZM6.66667 12.5001H13.3333V14.1667H6.66667V12.5001Z"
      fill="#5C5C5C"
    />
  </svg>
);

export const TextIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    {...props}
  >
    <path
      d="M1.66663 3.33333C1.66663 2.8731 2.03973 2.5 2.49996 2.5H17.5C17.9602 2.5 18.3333 2.8731 18.3333 3.33333V16.6667C18.3333 17.1269 17.9602 17.5 17.5 17.5H2.49996C2.03973 17.5 1.66663 17.1269 1.66663 16.6667V3.33333ZM3.33329 4.16667V15.8333H16.6666V4.16667H3.33329ZM5.83329 6.66667H14.1666V9.16667H12.5V8.33333H10.8333V11.6667H12.0833V13.3333H7.91663V11.6667H9.16663V8.33333H7.49996V9.16667H5.83329V6.66667Z"
      fill="#5C5C5C"
    />
  </svg>
);

export const UploadIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    {...props}
  >
    <path
      d="M16.75 16.5836V16.7496H3.25V16.5836H16.75ZM16.0107 8.73792L15.8926 8.85608L10.083 3.04651V13.4166H9.91699V3.04651L4.10742 8.85608L3.98926 8.73792L10 2.72717L16.0107 8.73792Z"
      fill="black"
      stroke="currentColor"
      strokeWidth="1.5"
    />
  </svg>
);

export const RemoveIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    {...props}
  >
    <path
      d="M9 16.5C4.85786 16.5 1.5 13.1421 1.5 9C1.5 4.85786 4.85786 1.5 9 1.5C13.1421 1.5 16.5 4.85786 16.5 9C16.5 13.1421 13.1421 16.5 9 16.5ZM9 15C12.3137 15 15 12.3137 15 9C15 5.68629 12.3137 3 9 3C5.68629 3 3 5.68629 3 9C3 12.3137 5.68629 15 9 15ZM5.25 8.25H12.75V9.75H5.25V8.25Z"
      fill="#E53E3E"
    />
  </svg>
);

export const QaQuestionIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <path
      d="M3.84204 11.3333H13.3335V3.33333H2.66683V12.2567L3.84204 11.3333ZM4.3032 12.6667L1.3335 15V2.66667C1.3335 2.29848 1.63198 2 2.00016 2H14.0002C14.3684 2 14.6668 2.29848 14.6668 2.66667V12C14.6668 12.3682 14.3684 12.6667 14.0002 12.6667H4.3032ZM7.3335 9.33333H8.66683V10.6667H7.3335V9.33333ZM5.7117 5.87564C5.92441 4.80613 6.86816 4 8.00016 4C9.28883 4 10.3335 5.04467 10.3335 6.33333C10.3335 7.622 9.28883 8.66667 8.00016 8.66667H7.3335V7.33333H8.00016C8.55243 7.33333 9.00016 6.8856 9.00016 6.33333C9.00016 5.78105 8.55243 5.33333 8.00016 5.33333C7.51503 5.33333 7.11056 5.67882 7.01936 6.13718L5.7117 5.87564Z"
      fill="#A0AEC0"
    />
  </svg>
);

export const QaAnswerIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <path
      d="M4.3032 12.6667L1.3335 15V2.66667C1.3335 2.29848 1.63198 2 2.00016 2H14.0002C14.3684 2 14.6668 2.29848 14.6668 2.66667V12C14.6668 12.3682 14.3684 12.6667 14.0002 12.6667H4.3032ZM3.84204 11.3333H13.3335V3.33333H2.66683V12.2567L3.84204 11.3333ZM7.52876 8.08087L10.3572 5.25245L11.3 6.19526L7.52876 9.96647L4.93604 7.3738L5.87884 6.43097L7.52876 8.08087Z"
      fill="#A0AEC0"
    />
  </svg>
);

export const ShrinkIcon = (props?: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      d="M9.00008 4.00008H11.0001V11.0001H4.00008V9.00008H7.58586L3.29297 4.70718L4.70718 3.29297L9.00008 7.58586V4.00008ZM20 15H16.4142L20.7071 19.2929L19.2929 20.7071L15 16.4142V20H13V13H20V15Z"
      fill="currentColor"
    />
  </svg>
);

// Build Agent Step Icons
export const StepAlarmIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
      x="0.666672"
      y="0.666748"
      width="26.6667"
      height="26.6667"
      fill="white"
      fillOpacity="0.01"
    />
    <rect
      x="23.3644"
      y="12.0039"
      width="2.71899"
      height="5.37386"
      rx="1.35949"
      fill="#EEF4FF"
      stroke="#302F2F"
      strokeWidth="0.833333"
    />
    <rect
      x="1.91667"
      y="12.0039"
      width="2.71899"
      height="5.37386"
      rx="1.35949"
      fill="#EEF4FF"
      stroke="#302F2F"
      strokeWidth="0.833333"
    />
    <path
      d="M13.8787 3.44861C19.5784 3.44876 24.1991 8.06924 24.1991 13.7689V20.2611C24.1989 20.4911 24.0121 20.6771 23.7821 20.6771H3.97445C3.74459 20.6769 3.55862 20.491 3.55843 20.2611V13.7689C3.55843 8.06915 8.17897 3.44861 13.8787 3.44861Z"
      fill="white"
      stroke="#302F2F"
      strokeWidth="0.833333"
    />
    <rect
      x="7.05948"
      y="9.01994"
      width="13.6371"
      height="4.85146"
      rx="2.42573"
      fill="#EEF4FF"
      stroke="#302F2F"
      strokeWidth="0.833333"
    />
    <path
      d="M21.6725 6.621L24.2229 4.07043"
      stroke="#302F2F"
      strokeWidth="0.833333"
      strokeLinecap="round"
    />
    <path
      d="M6.32787 6.621L3.77748 4.07043"
      stroke="#302F2F"
      strokeWidth="0.833333"
      strokeLinecap="round"
    />
    <path
      d="M5.40023 19.5619H22.3553C23.966 19.5619 25.2721 20.8672 25.2723 22.4779V24.1351C25.2723 24.3652 25.0854 24.5521 24.8553 24.5521H2.90023C2.67027 24.5519 2.48424 24.3651 2.48421 24.1351V22.4779C2.48439 20.8673 3.78966 19.5621 5.40023 19.5619Z"
      fill="#EEF4FF"
      stroke="#302F2F"
      strokeWidth="0.833333"
    />
  </svg>
);

export const StepUserIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
      opacity="0.01"
      x="0.666656"
      y="0.666748"
      width="26.6667"
      height="26.6667"
      fill="white"
      fillOpacity="0.2"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14 25.6667C20.4433 25.6667 25.6666 20.4434 25.6666 14C25.6666 7.55672 20.4433 2.33337 14 2.33337C7.55666 2.33337 2.33331 7.55672 2.33331 14C2.33331 20.4434 7.55666 25.6667 14 25.6667Z"
      fill="#EEF4FF"
      stroke="#A1A1A1"
      strokeWidth="0.833333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14 22.3333C18.6024 22.3333 22.3333 18.6023 22.3333 14C22.3333 9.39759 18.6024 5.66663 14 5.66663C9.39762 5.66663 5.66666 9.39759 5.66666 14C5.66666 18.6023 9.39762 22.3333 14 22.3333Z"
      fill="white"
      stroke="#A1A1A1"
      strokeWidth="0.833333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.1371 18.1666V17.1323C18.1371 15.9899 17.211 15.0637 16.0686 15.0637H11.9314C10.789 15.0637 9.86282 15.9899 9.86282 17.1323V18.1666H18.1371Z"
      fill="white"
      stroke="#A1A1A1"
      strokeWidth="0.833333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.0003 13.9705C15.1428 13.9705 16.0689 13.0444 16.0689 11.9019C16.0689 10.7595 15.1428 9.83337 14.0003 9.83337C12.8579 9.83337 11.9317 10.7595 11.9317 11.9019C11.9317 13.0444 12.8579 13.9705 14.0003 13.9705Z"
      fill="#EEF4FF"
      stroke="#A1A1A1"
      strokeWidth="0.833333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const StepLightningIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
      opacity="0.01"
      x="0.666687"
      y="0.666748"
      width="26.6667"
      height="26.6667"
      fill="white"
      fillOpacity="0.2"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.45656 26.9167L11.8261 14.5616H7.33337L10.7029 1.08337H19.6884L14.0725 10.0689H19.6884L8.45656 26.9167Z"
      fill="white"
      stroke="#C3C3C3"
      strokeWidth="0.833333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.0127 10.0689L20.8116 1.08337H15.9001L12.3572 10.0689H15.0127Z"
      fill="#EEF4FF"
      stroke="#C3C3C3"
      strokeWidth="0.833333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const StepSendIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
      opacity="0.01"
      x="0.666687"
      y="0.666748"
      width="26.6667"
      height="26.6667"
      fill="white"
      fillOpacity="0.2"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.29169 11.1931L26.7276 5.66663L20.3761 22.602L11.7873 17.0054L10.089 23.0153L8.56097 15.2581L1.29169 11.1931Z"
      fill="white"
      stroke="#C3C3C3"
      strokeWidth="0.833333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.0512 19.1662L10.0891 23.0154L11.7873 17.0054L15.0512 19.1662Z"
      fill="white"
      stroke="#C3C3C3"
      strokeWidth="0.833333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.56097 15.2581L10.089 23.0153L11.7873 17.0054L26.7276 5.66663L8.56097 15.2581Z"
      fill="#EEF4FF"
      stroke="#C3C3C3"
      strokeWidth="0.833333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const BranchBlueIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_5673_35134)">
      <path
        d="M7.07627 11.8637L7.66133 10.5236C8.18207 9.33103 9.11927 8.38169 10.2883 7.86276L11.8988 7.14789C12.4108 6.92063 12.4108 6.17575 11.8988 5.94847L10.3386 5.25592C9.13947 4.72364 8.18547 3.73917 7.67367 2.50592L7.081 1.07778C6.86107 0.547803 6.12879 0.547805 5.90887 1.07778L5.31618 2.50591C4.80438 3.73917 3.85035 4.72364 2.65123 5.25592L1.09105 5.94847C0.579024 6.17575 0.579024 6.92063 1.09105 7.14789L2.70153 7.86276C3.87059 8.38169 4.80781 9.33103 5.3285 10.5236L5.9136 11.8637C6.13851 12.3788 6.85133 12.3788 7.07627 11.8637ZM12.9343 15.1266L13.0988 14.7494C13.3921 14.077 13.9205 13.5416 14.5797 13.2488L15.0866 13.0235C15.3608 12.9017 15.3608 12.5032 15.0866 12.3814L14.6081 12.1688C13.9319 11.8684 13.3941 11.3132 13.1057 10.6179L12.9368 10.2104C12.819 9.92636 12.4263 9.92636 12.3085 10.2104L12.1396 10.6179C11.8513 11.3132 11.3135 11.8684 10.6373 12.1688L10.1587 12.3814C9.8846 12.5032 9.8846 12.9017 10.1587 13.0235L10.6657 13.2488C11.3249 13.5416 11.8532 14.077 12.1465 14.7494L12.3111 15.1266C12.4315 15.4026 12.8138 15.4026 12.9343 15.1266Z"
        fill="#007AF5"
      />
    </g>
    <defs>
      <clipPath id="clip0_5673_35134">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const FilterIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M3.75 5.25C3.75 4.62868 4.25368 4.125 4.875 4.125C5.49632 4.125 6 4.62868 6 5.25C6 5.87132 5.49632 6.375 4.875 6.375C4.25368 6.375 3.75 5.87132 3.75 5.25ZM4.875 2.625C3.42525 2.625 2.25 3.80025 2.25 5.25C2.25 6.69975 3.42525 7.875 4.875 7.875C6.32475 7.875 7.5 6.69975 7.5 5.25C7.5 3.80025 6.32475 2.625 4.875 2.625ZM9 6H15V4.5H9V6ZM12 12.75C12 12.1287 12.5037 11.625 13.125 11.625C13.7463 11.625 14.25 12.1287 14.25 12.75C14.25 13.3713 13.7463 13.875 13.125 13.875C12.5037 13.875 12 13.3713 12 12.75ZM13.125 10.125C11.6753 10.125 10.5 11.3003 10.5 12.75C10.5 14.1997 11.6753 15.375 13.125 15.375C14.5747 15.375 15.75 14.1997 15.75 12.75C15.75 11.3003 14.5747 10.125 13.125 10.125ZM3 12V13.5H9V12H3Z"
      fill="#007AF5"
    />
  </svg>
);

export const StarIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_5500_46794)">
      <path
        d="M7.07627 11.8637L7.66133 10.5236C8.18207 9.33103 9.11927 8.38169 10.2883 7.86276L11.8988 7.14789C12.4108 6.92063 12.4108 6.17575 11.8988 5.94847L10.3386 5.25592C9.13947 4.72364 8.18547 3.73917 7.67367 2.50592L7.081 1.07778C6.86107 0.547803 6.12879 0.547805 5.90887 1.07778L5.31618 2.50591C4.80438 3.73917 3.85035 4.72364 2.65123 5.25592L1.09105 5.94847C0.579024 6.17575 0.579024 6.92063 1.09105 7.14789L2.70153 7.86276C3.87059 8.38169 4.80781 9.33103 5.3285 10.5236L5.9136 11.8637C6.13851 12.3788 6.85133 12.3788 7.07627 11.8637ZM12.9343 15.1266L13.0988 14.7494C13.3921 14.077 13.9205 13.5416 14.5797 13.2488L15.0866 13.0235C15.3608 12.9017 15.3608 12.5032 15.0866 12.3814L14.6081 12.1688C13.9319 11.8684 13.3941 11.3132 13.1057 10.6179L12.9368 10.2104C12.819 9.92636 12.4263 9.92636 12.3085 10.2104L12.1396 10.6179C11.8513 11.3132 11.3135 11.8684 10.6373 12.1688L10.1587 12.3814C9.8846 12.5032 9.8846 12.9017 10.1587 13.0235L10.6657 13.2488C11.3249 13.5416 11.8532 14.077 12.1465 14.7494L12.3111 15.1266C12.4315 15.4026 12.8138 15.4026 12.9343 15.1266Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_5500_46794">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const ArrowUpThinIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7.99993 7.21897L4.70013 10.5188L3.75732 9.57604L7.99993 5.33337L12.2426 9.57604L11.2998 10.5188L7.99993 7.21897Z"
      fill="currentColor"
    />
  </svg>
);

export const ArrowDownThinIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8.00007 8.78103L11.2999 5.48116L12.2427 6.42396L8.00007 10.6666L3.7574 6.42396L4.7002 5.48116L8.00007 8.78103Z"
      fill="currentColor"
    />
  </svg>
);

export const HotFireIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...props}
  >
    <rect width="18" height="18" fill="url(#pattern0_5483_29719)" />
    <defs>
      <pattern
        id="pattern0_5483_29719"
        patternContentUnits="objectBoundingBox"
        width="1"
        height="1"
      >
        <use xlinkHref="#image0_5483_29719" transform="scale(0.00195312)" />
      </pattern>
      <image
        id="image0_5483_29719"
        width="512"
        height="512"
        preserveAspectRatio="none"
        xlinkHref="data:image/png;base64,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"
      />
    </defs>
  </svg>
);

export const WarmFireIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...props}
  >
    <rect width="18" height="18" fill="url(#pattern0_5483_29729)" />
    <defs>
      <pattern
        id="pattern0_5483_29729"
        patternContentUnits="objectBoundingBox"
        width="1"
        height="1"
      >
        <use xlinkHref="#image0_5483_29729" transform="scale(0.00195312)" />
      </pattern>
      <image
        id="image0_5483_29729"
        width="512"
        height="512"
        preserveAspectRatio="none"
        xlinkHref="data:image/png;base64,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"
      />
    </defs>
  </svg>
);

export const SnowIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...props}
  >
    <rect width="18" height="18" fill="url(#pattern0_5483_29738)" />
    <defs>
      <pattern
        id="pattern0_5483_29738"
        patternContentUnits="objectBoundingBox"
        width="1"
        height="1"
      >
        <use xlinkHref="#image0_5483_29738" transform="scale(0.00195312)" />
      </pattern>
      <image
        id="image0_5483_29738"
        width="512"
        height="512"
        preserveAspectRatio="none"
        xlinkHref="data:image/png;base64,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"
      />
    </defs>
  </svg>
);

export const NotAllowedIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9 16.5C4.85786 16.5 1.5 13.1421 1.5 9C1.5 4.85786 4.85786 1.5 9 1.5C13.1421 1.5 16.5 4.85786 16.5 9C16.5 13.1421 13.1421 16.5 9 16.5ZM9 15C12.3137 15 15 12.3137 15 9C15 5.68629 12.3137 3 9 3C5.68629 3 3 5.68629 3 9C3 12.3137 5.68629 15 9 15ZM6.39235 5.33168L12.6683 11.6077C12.5248 11.809 12.3627 12.0013 12.1819 12.1819C12.0013 12.3627 11.809 12.5248 11.6077 12.6683L5.33168 6.39235C5.47522 6.19094 5.63733 5.99871 5.81802 5.81802C5.99871 5.63733 6.19094 5.47522 6.39235 5.33168Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const HubSpotIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="58"
      height="58"
      viewBox="0 0 58 58"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M54 0H4C1.79086 0 0 1.79086 0 4V54C0 56.2091 1.79086 58 4 58H54C56.2091 58 58 56.2091 58 54V4C58 1.79086 56.2091 0 54 0Z"
        fill="#FF5C35"
      />
      <path
        d="M40.1467 21.4878V16.2536C41.497 15.6079 42.4441 14.2249 42.4441 12.6221V12.5031C42.4441 10.2912 40.6497 8.47779 38.4611 8.47779H38.3433C36.1547 8.47779 34.3603 10.2866 34.3603 12.5031V12.6221C34.3603 14.2249 35.3073 15.6079 36.6577 16.2536V21.4878C34.6458 21.8038 32.8061 22.6418 31.2881 23.8737L17.0691 12.6954C17.1642 12.3336 17.2277 11.9581 17.2277 11.5643C17.2277 9.05937 15.2203 7.02155 12.7417 7.01697C10.2586 7.01697 8.24672 9.04564 8.24219 11.5506C8.24219 14.0555 10.2495 16.0933 12.7281 16.0979C13.5347 16.0979 14.2869 15.8689 14.9394 15.4888L28.9273 26.4839C27.7356 28.2974 27.0423 30.4726 27.0423 32.8126C27.0423 35.1527 27.8081 37.5294 29.1041 39.3932L24.8492 43.6933C24.5139 43.5925 24.165 43.5192 23.7934 43.5192C21.7544 43.5192 20.1005 45.1907 20.1005 47.2514C20.1005 49.3122 21.7544 50.9836 23.7934 50.9836C25.8325 50.9836 27.4864 49.3122 27.4864 47.2514C27.4864 46.8805 27.4139 46.5233 27.3142 46.1844L31.5238 41.9302C33.4314 43.4048 35.8103 44.2886 38.4022 44.2886C44.6734 44.2886 49.7575 39.1505 49.7575 32.8126C49.7575 27.0747 45.5888 22.335 40.1467 21.4878ZM38.4022 38.6972C35.185 38.6972 32.5795 36.064 32.5795 32.8126C32.5795 29.5613 35.185 26.9281 38.4022 26.9281C41.6194 26.9281 44.2248 29.5613 44.2248 32.8126C44.2248 36.064 41.6194 38.6972 38.4022 38.6972Z"
        fill="white"
      />
    </svg>
  );
};

export const SalesforceIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="64"
    height="64"
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_5834_38249)">
      <mask
        id="mask0_5834_38249"
        maskUnits="userSpaceOnUse"
        x="1"
        y="10"
        width="62"
        height="44"
      >
        <path
          d="M1.01367 10.1135H62.7866V53.2637H1.01367V10.1135Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_5834_38249)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M26.6628 14.8374C28.6568 12.7616 31.4321 11.4762 34.498 11.4762C38.5859 11.4762 42.1288 13.7473 44.0364 17.1311C45.7298 16.3741 47.564 15.9833 49.4189 15.9843C56.7771 15.9843 62.75 22.0026 62.75 29.4289C62.75 36.8553 56.7771 42.8736 49.4189 42.8736C48.5195 42.8736 47.6429 42.7832 46.7844 42.6125C45.1152 45.5876 41.9244 47.6088 38.2907 47.6088C36.8113 47.6117 35.3508 47.2761 34.0211 46.6277C32.3291 50.6021 28.3888 53.3955 23.8013 53.3955C19.0093 53.3955 14.9441 50.375 13.3771 46.1281C12.6797 46.2753 11.9687 46.3492 11.2559 46.3488C5.55557 46.3488 0.945312 41.6704 0.945312 35.9246C0.945312 32.0638 3.02106 28.7027 6.10062 26.8858C5.44729 25.3808 5.111 23.7573 5.11271 22.1166C5.11271 15.4851 10.4951 10.1254 17.1266 10.1254C21.0101 10.1254 24.4849 11.9763 26.6651 14.8492"
          fill="#00A1E0"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.94764 32.5517C9.9088 32.653 9.96149 32.6741 9.97398 32.692C10.09 32.7761 10.2079 32.8369 10.326 32.9053C10.9574 33.2391 11.5524 33.3368 12.1746 33.3368C13.4419 33.3368 14.23 32.6623 14.23 31.5767V31.5554C14.23 30.5516 13.3397 30.1859 12.5085 29.9247L12.3997 29.8895C11.7706 29.6856 11.2278 29.508 11.2278 29.0947V29.0735C11.2278 28.7193 11.5458 28.4581 12.0363 28.4581C12.5814 28.4581 13.2309 28.6395 13.6465 28.8691C13.6465 28.8691 13.7696 28.9486 13.8143 28.8299C13.8387 28.7656 14.0505 28.1985 14.0733 28.1349C14.0973 28.0684 14.0551 28.0182 14.0117 27.9923C13.5348 27.7016 12.8762 27.504 12.1949 27.504L12.0684 27.5045C10.9078 27.5045 10.0971 28.2062 10.0971 29.21V29.2316C10.0971 30.2899 10.9919 30.6351 11.8276 30.8736L11.9621 30.9154C12.5707 31.1025 13.0976 31.2651 13.0976 31.6921V31.7134C13.0976 32.1063 12.7547 32.3993 12.2051 32.3993C11.9914 32.3993 11.3103 32.3957 10.5722 31.9292C10.4829 31.8772 10.4321 31.8397 10.3632 31.7977C10.3269 31.7757 10.2361 31.7359 10.1965 31.8549L9.94673 32.5499L9.94764 32.5517ZM28.5013 32.5499C28.4625 32.6511 28.5152 32.6723 28.5281 32.6902C28.6437 32.7742 28.762 32.8351 28.8801 32.9035C29.5115 33.2373 30.1065 33.335 30.7288 33.335C31.996 33.335 32.7841 32.6605 32.7841 31.5749V31.5535C32.7841 30.5497 31.8961 30.1841 31.0626 29.9229L30.9538 29.8877C30.3247 29.6838 29.782 29.5062 29.782 29.0928V29.0717C29.782 28.7174 30.0999 28.4563 30.5905 28.4563C31.1355 28.4563 31.7828 28.6377 32.2006 28.8673C32.2006 28.8673 32.3237 28.9468 32.3687 28.828C32.3928 28.7638 32.6049 28.1967 32.6253 28.1331C32.6496 28.0666 32.6072 28.0164 32.564 27.9905C32.0871 27.6998 31.4285 27.5022 30.7472 27.5022L30.6204 27.5027C29.4599 27.5027 28.6492 28.2044 28.6492 29.2082V29.2298C28.6492 30.2881 29.544 30.6333 30.3797 30.8718L30.5139 30.9136C31.1248 31.1007 31.6495 31.2633 31.6495 31.6903V31.7116C31.6495 32.1045 31.3065 32.3975 30.7569 32.3975C30.5428 32.3975 29.8599 32.3938 29.124 31.9274C29.0348 31.8754 28.9825 31.8395 28.9149 31.7959C28.8919 31.7813 28.785 31.7395 28.7484 31.8531L28.4986 32.548L28.5013 32.5499ZM41.1711 30.4223C41.1711 31.0355 41.0567 31.5193 40.8327 31.8622C40.6093 32.2006 40.2718 32.3664 39.8017 32.3664C39.3316 32.3664 38.9954 32.2019 38.7751 31.8645C38.5533 31.5238 38.4413 31.0378 38.4413 30.4246C38.4413 29.8114 38.5539 29.3299 38.7751 28.9916C38.995 28.6554 39.3293 28.4942 39.8017 28.4942C40.274 28.4942 40.6102 28.657 40.8327 28.9916C41.058 29.3299 41.1711 29.8114 41.1711 30.4246V30.4223ZM42.2294 29.2868C42.1252 28.9348 41.9637 28.6259 41.748 28.367C41.532 28.1081 41.2597 27.8992 40.9349 27.7493C40.6124 27.5983 40.2309 27.5222 39.7994 27.5222C39.3679 27.5222 38.9886 27.5987 38.6639 27.7493C38.3414 27.9001 38.0666 28.1081 37.8508 28.367C37.6355 28.6259 37.4738 28.9348 37.3694 29.2868C37.266 29.6365 37.2136 30.0181 37.2136 30.4246C37.2136 30.8311 37.266 31.2127 37.3694 31.5624C37.4731 31.9144 37.6351 32.2233 37.8508 32.4822C38.0668 32.7411 38.3414 32.9477 38.6639 33.0954C38.9886 33.2425 39.3702 33.3175 39.7994 33.3175C40.2286 33.3175 40.6102 33.2425 40.9327 33.0954C41.2551 32.9482 41.5299 32.7411 41.7457 32.4822C41.9612 32.2233 42.1227 31.9144 42.2272 31.5624C42.3303 31.2127 42.3827 30.8311 42.3827 30.4246C42.3827 30.0204 42.3303 29.6365 42.2272 29.2868H42.2294ZM50.9253 32.1938C50.8906 32.0909 50.7902 32.1297 50.7902 32.1297C50.6364 32.1885 50.4723 32.243 50.2974 32.2703C50.1211 32.298 49.9249 32.3119 49.7183 32.3119C49.2073 32.3119 48.7985 32.1595 48.5078 31.8576C48.2148 31.5556 48.0513 31.0696 48.0536 30.411C48.0552 29.8114 48.2001 29.3617 48.4601 29.0165C48.7167 28.6759 49.1119 28.4987 49.6342 28.4987C50.0703 28.4987 50.4041 28.5494 50.7539 28.6588C50.7539 28.6588 50.8368 28.695 50.8765 28.5857C50.9694 28.3291 51.038 28.1451 51.1377 27.8635C51.1658 27.7829 51.0968 27.7488 51.0716 27.7391C50.9344 27.6855 50.6106 27.5976 50.3653 27.5606C50.1359 27.5256 49.8702 27.5074 49.5704 27.5074C49.1253 27.5074 48.7301 27.5835 48.3917 27.7343C48.0533 27.8849 47.7672 28.0931 47.5401 28.352C47.313 28.6109 47.1404 28.9198 47.0246 29.2718C46.9099 29.6216 46.8519 30.0054 46.8519 30.4119C46.8519 31.2885 47.0881 31.9994 47.556 32.5194C48.0238 33.0418 48.7278 33.3052 49.6454 33.3052C50.1881 33.3052 50.7446 33.1955 51.1443 33.0372C51.1443 33.0372 51.2206 33.0004 51.1874 32.9114L50.9262 32.1938H50.9253ZM52.7772 29.8319C52.8278 29.4912 52.9211 29.2073 53.0678 28.987C53.2875 28.6509 53.622 28.4669 54.0921 28.4669C54.5622 28.4669 54.8733 28.6518 55.0959 28.987C55.2435 29.2084 55.308 29.5025 55.3321 29.8319L52.7658 29.8314L52.7772 29.8319ZM56.3427 29.0824C56.2526 28.744 56.0293 28.4011 55.884 28.2444C55.6523 27.9968 55.4275 27.822 55.2026 27.7266C54.878 27.5886 54.5289 27.5177 54.1761 27.5183C53.7287 27.5183 53.3222 27.5939 52.9929 27.7477C52.6636 27.9026 52.3865 28.1133 52.1685 28.3768C51.9507 28.6402 51.787 28.9514 51.6825 29.3079C51.578 29.6599 51.5253 30.046 51.5253 30.4503C51.5253 30.8636 51.5801 31.2474 51.6877 31.5949C51.7965 31.9446 51.9716 32.2512 52.2078 32.5056C52.444 32.7622 52.746 32.9621 53.1094 33.1029C53.4705 33.2425 53.9088 33.315 54.4107 33.3134C55.4463 33.31 55.9914 33.0795 56.214 32.9546C56.2537 32.9323 56.2912 32.8939 56.2444 32.7833L56.0105 32.127C55.9746 32.0291 55.8756 32.0645 55.8756 32.0645C55.6189 32.1604 55.2556 32.3325 54.4039 32.3302C53.8475 32.3293 53.4364 32.1651 53.1775 31.9078C52.9141 31.6444 52.7824 31.2606 52.7619 30.7155L56.3502 30.7182C56.3502 30.7182 56.4447 30.7173 56.4545 30.6251C56.4583 30.587 56.5773 29.8893 56.3475 29.0831L56.3427 29.0824ZM24.0936 29.8319C24.1443 29.4912 24.2378 29.2073 24.3843 28.987C24.6042 28.6509 24.9385 28.4669 25.4086 28.4669C25.8787 28.4669 26.1898 28.6518 26.4124 28.987C26.5598 29.2084 26.6243 29.5025 26.6486 29.8319L24.0823 29.8314L24.0936 29.8319ZM27.6592 29.0824C27.5693 28.744 27.3458 28.4011 27.2004 28.2444C26.9688 27.9968 26.744 27.822 26.5191 27.7266C26.1945 27.5886 25.8453 27.5177 25.4926 27.5183C25.0452 27.5183 24.6387 27.5939 24.3094 27.7477C23.9801 27.9026 23.703 28.1133 23.485 28.3768C23.2676 28.6402 23.1034 28.9514 22.999 29.3079C22.8947 29.6599 22.8423 30.046 22.8423 30.4503C22.8423 30.8636 22.8966 31.2474 23.0049 31.5949C23.1134 31.9446 23.2888 32.2512 23.5227 32.5056C23.7589 32.7622 24.0609 32.9621 24.4243 33.1029C24.7854 33.2425 25.2214 33.315 25.7256 33.3134C26.7612 33.31 27.3063 33.0795 27.5288 32.9546C27.5684 32.9323 27.6061 32.8939 27.559 32.7833L27.3251 32.127C27.289 32.0291 27.19 32.0645 27.19 32.0645C26.9334 32.1604 26.57 32.3325 25.7184 32.3302C25.1642 32.3293 24.7509 32.1651 24.492 31.9078C24.2285 31.6444 24.0968 31.2606 24.0764 30.7155L27.6647 30.7182C27.6647 30.7182 27.7591 30.7173 27.7689 30.6251C27.7728 30.587 27.8918 29.8893 27.6617 29.0831L27.6592 29.0824ZM16.3493 32.171C16.2087 32.0589 16.1892 32.0314 16.1426 31.9585C16.0716 31.8488 16.0352 31.6928 16.0352 31.4929C16.0352 31.1795 16.1397 30.9524 16.3554 30.8002C16.3532 30.8007 16.6643 30.5322 17.3956 30.5413C17.7211 30.5472 18.0458 30.5749 18.3676 30.6242V32.2526H18.3681C18.3681 32.2526 17.9138 32.3505 17.4006 32.3813C16.6716 32.4252 16.3491 32.1715 16.3514 32.1722L16.3493 32.171ZM17.7755 29.6502C17.6302 29.6395 17.4417 29.6343 17.2169 29.6343C16.9103 29.6343 16.6128 29.6724 16.3357 29.7474C16.0563 29.8228 15.8043 29.9395 15.5885 30.0948C15.3722 30.2492 15.1942 30.4512 15.0684 30.6853C14.9415 30.9215 14.8768 31.1986 14.8768 31.512C14.8768 31.8299 14.9319 32.1047 15.041 32.3296C15.1478 32.5526 15.3086 32.7454 15.5088 32.8905C15.708 33.0354 15.9539 33.1426 16.2378 33.2062C16.5194 33.2705 16.8374 33.3029 17.1871 33.3029C17.555 33.3029 17.9207 33.2721 18.2749 33.2123C18.5767 33.1603 18.8773 33.1018 19.1766 33.037C19.296 33.0095 19.4286 32.9734 19.4286 32.9734C19.5172 32.9509 19.5104 32.8562 19.5104 32.8562L19.5084 29.5859C19.5084 28.8682 19.3167 28.3345 18.9383 28.0052C18.5613 27.6759 18.0095 27.5101 17.2941 27.5101C17.0261 27.5101 16.5923 27.5465 16.3334 27.5985C16.3334 27.5985 15.5522 27.7502 15.2297 28.0027C15.2297 28.0027 15.1588 28.0463 15.1974 28.1451L15.4518 28.8265C15.4834 28.9148 15.5694 28.8846 15.5694 28.8846C15.5694 28.8846 15.5965 28.8739 15.6282 28.8551C16.3164 28.4803 17.1885 28.4917 17.1885 28.4917C17.5745 28.4917 17.8743 28.5701 18.0742 28.7233C18.2697 28.8735 18.3694 29.1003 18.3694 29.5773V29.7287C18.0628 29.6842 17.7789 29.6586 17.7789 29.6586L17.7755 29.6502ZM46.618 27.8038C46.6232 27.7918 46.6259 27.7789 46.626 27.7659C46.626 27.7528 46.6235 27.7399 46.6185 27.7279C46.6135 27.7158 46.6061 27.7049 46.5967 27.6958C46.5874 27.6867 46.5764 27.6796 46.5642 27.6748C46.5031 27.6516 46.1986 27.5874 45.9646 27.5728C45.515 27.5447 45.2652 27.6205 45.0403 27.7214C44.8182 27.8215 44.5725 27.9825 44.4362 28.1688L44.4358 27.7327C44.4358 27.6728 44.3933 27.6244 44.3329 27.6244H43.4154C43.3559 27.6244 43.3127 27.6728 43.3127 27.7327V33.0697C43.3128 33.0985 43.3243 33.1262 43.3447 33.1466C43.365 33.1669 43.3927 33.1784 43.4215 33.1785H44.3617C44.3905 33.1784 44.4182 33.1669 44.4385 33.1465C44.4589 33.1262 44.4703 33.0985 44.4703 33.0697V30.3899C44.4703 30.031 44.5098 29.6745 44.5886 29.4496C44.6663 29.2273 44.7719 29.0499 44.902 28.9227C45.0262 28.7999 45.1781 28.7088 45.3449 28.657C45.5014 28.6121 45.6635 28.5893 45.8263 28.5894C46.0137 28.5894 46.2192 28.6375 46.2192 28.6375C46.2883 28.6452 46.3267 28.603 46.35 28.5408C46.4116 28.377 46.5862 27.8867 46.6203 27.789"
          fill="#FFFFFE"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M37.8374 25.3405C37.7211 25.3054 37.6029 25.2773 37.4833 25.2565C37.3224 25.2296 37.1595 25.217 36.9964 25.2188C36.3485 25.2188 35.8377 25.4018 35.4791 25.7634C35.123 26.1222 34.8807 26.6689 34.7592 27.3881L34.7153 27.6309H33.9021C33.9021 27.6309 33.8028 27.6268 33.7819 27.7351L33.6484 28.48C33.6391 28.5513 33.6697 28.5959 33.7651 28.5954H34.5568L33.7535 33.0792C33.6906 33.4403 33.6186 33.7373 33.5389 33.9624C33.4603 34.1845 33.3836 34.351 33.2891 34.4718C33.1976 34.5887 33.1108 34.6748 32.9612 34.725C32.8376 34.7666 32.6954 34.7856 32.5397 34.7856C32.4529 34.7856 32.3375 34.7711 32.2524 34.7541C32.1672 34.7373 32.1229 34.7182 32.0591 34.6914C32.0591 34.6914 31.9662 34.656 31.9296 34.7491C31.8999 34.8252 31.6889 35.4054 31.6639 35.4772C31.6385 35.548 31.6742 35.6039 31.7191 35.62C31.8245 35.6577 31.9028 35.6818 32.0464 35.7156C32.2458 35.7627 32.4138 35.7656 32.5712 35.7656C32.901 35.7656 33.2014 35.7193 33.4506 35.6293C33.7013 35.5387 33.9196 35.3809 34.1126 35.1672C34.3213 34.9367 34.4526 34.6953 34.5782 34.3659C34.7024 34.0396 34.8082 33.6344 34.8929 33.1623L35.7001 28.5954H36.8801C36.8801 28.5954 36.9796 28.599 37.0002 28.4912L37.1338 27.7463C37.1431 27.6749 37.1127 27.6304 37.0168 27.6309H35.8715C35.8772 27.605 35.9292 27.2021 36.0607 26.8228C36.1168 26.6609 36.2224 26.5303 36.3119 26.4406C36.3954 26.3552 36.4983 26.2911 36.6119 26.2539C36.7364 26.2155 36.8661 26.1968 36.9964 26.1985C37.1043 26.1985 37.2101 26.2115 37.2907 26.2283C37.4018 26.2519 37.4449 26.2644 37.474 26.273C37.5907 26.3087 37.6064 26.2742 37.6293 26.2176L37.9032 25.4654C37.9314 25.3846 37.8628 25.3505 37.8374 25.3405ZM21.8323 33.0887C21.8323 33.1487 21.7896 33.1975 21.7296 33.1975H20.7796C20.7195 33.1975 20.6768 33.1487 20.6768 33.0887V25.4425C20.6768 25.3828 20.7195 25.3344 20.7796 25.3344H21.7296C21.7896 25.3344 21.8323 25.3828 21.8323 25.4425V33.0887Z"
          fill="#FFFFFE"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_5834_38249">
        <rect
          width="62"
          height="43.3773"
          fill="white"
          transform="translate(1 10)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const OnMondayIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="64"
    height="64"
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_5834_38257)">
      <path
        d="M7.79429 51.14C6.40182 51.1378 5.03529 50.7632 3.83641 50.0549C2.63752 49.3466 1.64992 48.3306 0.976009 47.112C0.302103 45.8935 -0.033574 44.5169 0.00378737 43.1249C0.0411487 41.7329 0.45019 40.3763 1.18849 39.1957L15.231 16.77C16.3295 15.0159 18.0798 13.77 20.0969 13.3064C21.0957 13.0769 22.1298 13.0463 23.1404 13.2165C24.151 13.3866 25.1182 13.7541 25.9867 14.298C26.8552 14.8419 27.6081 15.5516 28.2024 16.3865C28.7967 17.2214 29.2207 18.1651 29.4503 19.1639C29.6798 20.1627 29.7104 21.1968 29.5402 22.2074C29.3701 23.218 29.0026 24.1852 28.4587 25.0537L14.4129 47.4794C13.711 48.6011 12.7352 49.5257 11.5773 50.1661C10.4194 50.8065 9.11749 51.1417 7.79429 51.14Z"
        fill="#FF3D57"
      />
      <path
        d="M31.9946 51.14C30.6011 51.1401 29.2329 50.7671 28.0322 50.0598C26.8315 49.3524 25.8421 48.3366 25.1666 47.1176C24.4912 45.8987 24.1544 44.5212 24.1912 43.1281C24.228 41.735 24.6371 40.3772 25.376 39.1957L39.4281 16.77C39.9492 15.8557 40.6498 15.0562 41.4878 14.4197C42.3258 13.7832 43.2839 13.3227 44.3045 13.0661C45.325 12.8095 46.387 12.762 47.4264 12.9264C48.4658 13.0908 49.4612 13.4639 50.3527 14.023C51.2442 14.5821 52.0134 15.3158 52.614 16.1799C53.2147 17.044 53.6343 18.0207 53.8476 19.0512C54.061 20.0816 54.0637 21.1446 53.8555 22.1762C53.6474 23.2078 53.2327 24.1865 52.6365 25.0537L38.61 47.4794C37.9081 48.6011 36.9323 49.5257 35.7744 50.1661C34.6165 50.8065 33.3178 51.1417 31.9946 51.14Z"
        fill="#FFCB00"
      />
      <path
        d="M56.1874 51.1368C60.5037 51.1368 64.0027 47.7254 64.0027 43.5172C64.0027 39.309 60.5037 35.8976 56.1874 35.8976C51.8711 35.8976 48.3721 39.309 48.3721 43.5172C48.3721 47.7254 51.8711 51.1368 56.1874 51.1368Z"
        fill="#00D647"
      />
    </g>
    <defs>
      <clipPath id="clip0_5834_38257">
        <rect width="64" height="64" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const ZohoIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="64"
    height="64"
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_5834_38241)">
      <path
        d="M60.9658 27.8685V42.2544L63.0002 40.2685V25.5629L60.9658 27.8685Z"
        fill="#E79225"
      />
      <path
        d="M62.9996 25.5629L61.0039 27.8685L60.8877 27.9654L47.6739 28.0138L47.5674 27.8685L49.6696 25.5822H62.9996V25.5629Z"
        fill="#FFF16D"
      />
      <path
        d="M47.5586 42.264H61.0048V27.8684H47.5586V42.264Z"
        fill="url(#paint0_linear_5834_38241)"
      />
      <path
        d="M58.9603 33.0513C59.2218 33.7197 59.3575 34.4463 59.3575 35.2504C59.3575 36.0544 59.2218 36.7616 58.9603 37.43C58.6987 38.0985 58.2918 38.6991 57.7784 39.2319C57.2843 39.726 56.7128 40.1038 56.0928 40.3557C55.4728 40.6075 54.8043 40.7432 54.0972 40.7432C53.3997 40.7432 52.7022 40.6172 52.0531 40.3557C51.4331 40.0941 50.8615 39.7163 50.3965 39.2319C49.8831 38.7088 49.4859 38.0985 49.2243 37.4107C48.9628 36.7325 48.8271 36.006 48.8271 35.231C48.8271 34.456 48.9434 33.71 49.2146 33.0416C49.4762 32.3732 49.8831 31.7629 50.3868 31.2494C50.8615 30.7554 51.4331 30.3582 52.0725 30.0966C52.6925 29.8447 53.3706 29.7091 54.0972 29.7091C54.8237 29.7091 55.4921 29.8447 56.1121 30.0966C56.7515 30.3582 57.3231 30.7457 57.7978 31.2494C58.3209 31.7725 58.7181 32.3732 58.9796 33.0416L58.9603 33.0513ZM56.1897 37.7982C56.7128 37.1782 56.9647 36.3257 56.9647 35.231C56.9647 34.1363 56.7031 33.2547 56.1897 32.625C55.6665 32.005 54.9787 31.695 54.0875 31.695C53.1962 31.695 52.489 31.9954 51.9659 32.625C51.4622 33.2547 51.1909 34.1169 51.1909 35.231C51.1909 36.345 51.4428 37.1782 51.9659 37.7982C52.489 38.4182 53.1865 38.7282 54.0875 38.7282C54.9884 38.7282 55.6762 38.4182 56.1897 37.7982Z"
        fill="white"
      />
      <path
        d="M46.192 24.4391L45.0876 27.5004L45.0488 27.6747L46.8216 40.3363L46.9573 40.4332L47.9648 37.6432L46.2404 24.4294V24.3519L46.192 24.4294V24.4391Z"
        fill="#009ADA"
      />
      <path
        d="M32.6489 27.2582L32.5908 29.5251L44.9618 27.7038L45.1168 27.5294L46.2308 24.3519L32.9977 26.1926L32.6489 27.2485V27.2582Z"
        fill="#91C9ED"
      />
      <path
        d="M32.9206 29.2054L32.1553 29.7963L33.9087 42.2544L46.9481 40.4235L45.1171 27.5294L32.9109 29.1957L32.9206 29.2054Z"
        fill="url(#paint1_linear_5834_38241)"
      />
      <path
        d="M44.2258 38.7669C44.2355 38.8735 44.2549 38.9897 44.2549 39.0866C44.2549 39.3482 44.1968 39.571 44.0902 39.755C43.9352 40.0069 43.6736 40.1716 43.3346 40.22C43.2571 40.2297 43.1893 40.2297 43.1311 40.2297C42.8889 40.2297 42.6564 40.1425 42.4821 39.9875C42.2496 39.7938 42.1139 39.4935 42.0558 39.0963L41.5327 35.6475L37.7739 36.1997L38.2971 39.6485C38.3068 39.755 38.3261 39.8713 38.3261 39.9682C38.3261 40.22 38.2777 40.4429 38.1711 40.6172C38.0161 40.8691 37.7739 41.0338 37.4446 41.0822C37.3768 41.0919 37.2993 41.0919 37.2314 41.0919C36.9602 41.0919 36.7471 41.0144 36.563 40.8594C36.3208 40.656 36.1852 40.3557 36.1271 39.9488L34.8386 31.2204C34.8289 31.1041 34.8096 30.9879 34.8096 30.891C34.8096 30.6294 34.858 30.3969 34.9743 30.2129C35.1389 29.961 35.4102 29.7963 35.7589 29.7479C35.8171 29.7382 35.8752 29.7382 35.943 29.7382C36.1852 29.7382 36.408 29.8254 36.5824 29.99C36.7955 30.1935 36.9311 30.5035 36.9893 30.891L37.4639 34.2429L41.2227 33.6907L40.748 30.3388C40.7383 30.2322 40.7189 30.1257 40.7189 30.0288C40.7189 29.7672 40.7674 29.5347 40.8836 29.3507C41.0386 29.0988 41.3002 28.9341 41.6393 28.8857C41.7168 28.876 41.7846 28.876 41.8427 28.876C42.0849 28.876 42.3174 28.9632 42.4918 29.1182C42.7049 29.3216 42.8405 29.6316 42.8986 30.0288L44.2064 38.7863L44.2258 38.7669Z"
        fill="white"
      />
      <path
        d="M20.7141 21.155L21.8475 24.9331L21.8669 25.185L16.5775 37.0909H16.5388L15.8994 32.1891L20.6172 21L20.7141 21.155Z"
        fill="#66BF6B"
      />
      <path
        d="M32.562 26.4638L33.5598 30.3872L33.521 30.4066L21.8766 25.185L20.627 21L32.5716 26.4638H32.562Z"
        fill="#98D0A0"
      />
      <path
        d="M16.5488 37.1006L28.261 42.3803L33.5504 30.3775L21.8382 25.0978L16.5488 37.1006Z"
        fill="url(#paint2_linear_5834_38241)"
      />
      <path
        d="M30.0039 31.3559C30.2461 31.9953 30.3527 32.654 30.343 33.3128V33.5356C30.3043 34.2718 30.1396 35.0081 29.8199 35.7637C29.5002 36.5193 29.0836 37.1587 28.5702 37.6915C28.0664 38.234 27.4464 38.6699 26.7683 38.9606C26.1193 39.2415 25.4508 39.3868 24.7824 39.3868H24.7727C24.1043 39.3868 23.4552 39.2512 22.8158 38.9799C22.1668 38.7184 21.5855 38.3309 21.1108 37.8271C20.6458 37.3428 20.2971 36.7712 20.0549 36.1124C19.8224 35.4828 19.7158 34.8434 19.7158 34.1846V33.9328C19.7546 33.1965 19.9193 32.4409 20.2389 31.7046C20.5489 30.9587 20.9655 30.2999 21.4693 29.7671C21.973 29.2246 22.5736 28.8081 23.2614 28.5078C23.9202 28.2171 24.5789 28.0621 25.2571 28.0621H25.2958C25.9643 28.0621 26.6133 28.1978 27.2721 28.4787C27.9018 28.7403 28.4733 29.1374 28.9383 29.6315C29.4033 30.1159 29.7521 30.6971 30.0039 31.3753V31.3559ZM27.6693 34.8434C27.9696 34.1265 28.1149 33.4774 28.1149 32.8671C28.1149 32.5765 28.0761 32.2956 28.0083 32.0437C27.7952 31.2493 27.2818 30.6874 26.468 30.3387C26.0805 30.1837 25.7221 30.0965 25.3539 30.0965C24.9568 30.0965 24.5499 30.1934 24.1624 30.4065C23.4455 30.8037 22.8546 31.5303 22.4089 32.5959C22.1183 33.2837 21.973 33.9328 21.973 34.514C21.973 34.8046 22.0118 35.0856 22.0796 35.3471C22.3024 36.1512 22.8061 36.7034 23.6296 37.0521C24.0074 37.2071 24.3755 37.2943 24.7339 37.2943C25.1311 37.2943 25.538 37.1878 25.9255 36.9746C26.6424 36.5871 27.2333 35.8703 27.6693 34.8337V34.8434Z"
        fill="white"
      />
      <path
        d="M14.8527 23.1216L14.0293 27.4422V27.6844L15.899 40.0554L16.0152 40.2104L16.8871 35.7057L14.9787 22.8988L14.8624 23.1216H14.8527Z"
        fill="#760D16"
      />
      <path
        d="M1.155 29.6509L14.0878 27.82V27.5197L14.9694 22.9084L1.91063 25.0009L1 29.5347L1.155 29.6509Z"
        fill="#EF463E"
      />
      <path
        d="M1 29.525L3.08281 42.235L16.0156 40.2103L14.0878 27.51L1 29.525Z"
        fill="url(#paint3_linear_5834_38241)"
      />
      <path
        d="M12.8963 38.6215C12.906 38.699 12.9157 38.7668 12.9157 38.8443C12.9157 39.1059 12.8091 39.3384 12.6057 39.5128C12.3538 39.7162 11.8985 39.8809 11.2688 39.9875L7.68445 40.6075C7.11289 40.7043 6.66727 40.7528 6.33789 40.7528C6.06664 40.7528 5.89227 40.7334 5.75664 40.6559C5.61133 40.5687 5.49508 40.4331 5.41758 40.2781C5.33039 40.1134 5.27227 39.8906 5.22383 39.629C5.18508 39.445 5.17539 39.2512 5.17539 39.0575C5.17539 38.7668 5.21414 38.4762 5.27227 38.1953C5.37883 37.6721 5.56289 37.1684 5.84383 36.6356C6.23133 35.8703 6.86102 34.95 7.76195 33.8746L8.27539 33.245C8.67258 32.7509 8.91477 32.3634 9.01164 32.0825C9.07945 31.8887 9.1182 31.6853 9.1182 31.4818C9.1182 31.4334 9.10852 31.3753 9.10852 31.3075L5.81477 31.8887C5.64039 31.9178 5.45633 31.9371 5.28195 31.9371C5.03977 31.9371 4.84602 31.8984 4.68133 31.8306C4.40039 31.7143 4.2357 31.4625 4.16789 31.1234C4.1582 31.0459 4.1582 30.9781 4.1582 30.92C4.1582 30.6778 4.24539 30.455 4.42945 30.2903C4.64258 30.0771 5.0107 29.9415 5.48539 29.8543L9.4282 29.1762C9.72852 29.1278 9.98039 29.1084 10.1935 29.1084C10.4454 29.1084 10.6585 29.1471 10.7845 29.2246C10.9007 29.2925 11.0073 29.4184 11.0848 29.5734C11.1623 29.7284 11.2301 29.9221 11.2688 30.1643C11.3173 30.4259 11.3366 30.6971 11.3366 30.9587C11.3366 31.0556 11.3366 31.1525 11.327 31.259C11.3076 31.6368 11.2398 32.0146 11.1332 32.3828C10.9395 33.0415 10.4648 33.8746 9.68008 34.9015C9.56383 35.0565 9.46695 35.1631 9.39914 35.2503L9.00195 35.7734C8.50789 36.4321 8.12039 36.994 7.86852 37.4687C7.63602 37.895 7.50039 38.234 7.47133 38.4956L10.891 37.9143C11.1816 37.8659 11.4432 37.8368 11.6757 37.8368C11.9276 37.8368 12.131 37.8562 12.3054 37.924C12.4798 37.9918 12.6154 38.0693 12.722 38.1856C12.8285 38.3018 12.8963 38.4472 12.9157 38.6118L12.8963 38.6215Z"
        fill="white"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_5834_38241"
        x1="47.2811"
        y1="27.9577"
        x2="47.2811"
        y2="41.7775"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFE513" />
        <stop offset="1" stopColor="#FDB924" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_5834_38241"
        x1="38.3281"
        y1="29.4921"
        x2="51.7402"
        y2="40.4489"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#008CD2" />
        <stop offset="1" stopColor="#00649D" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_5834_38241"
        x1="25.098"
        y1="29.8555"
        x2="25.098"
        y2="41.7804"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#26A146" />
        <stop offset="1" stopColor="#008A52" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_5834_38241"
        x1="7.53422"
        y1="28.7268"
        x2="9.55787"
        y2="41.2557"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#D92231" />
        <stop offset="1" stopColor="#BA2234" />
      </linearGradient>
      <clipPath id="clip0_5834_38241">
        <rect
          width="62"
          height="21.39"
          fill="white"
          transform="translate(1 21)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const SlackIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="64"
    height="64"
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width="64" height="64" fill="white" fillOpacity="0.01" />
    <path
      d="M13.4463 40.4429C13.4463 44.1432 10.4235 47.166 6.72313 47.166C3.0228 47.166 0 44.1432 0 40.4429C0 36.7425 3.0228 33.7197 6.72313 33.7197H13.4463V40.4429Z"
      fill="#E01E5A"
    />
    <path
      d="M16.834 40.4429C16.834 36.7425 19.8568 33.7197 23.5571 33.7197C27.2574 33.7197 30.2802 36.7425 30.2802 40.4429V57.2767C30.2802 60.9771 27.2574 63.9999 23.5571 63.9999C19.8568 63.9999 16.834 60.9771 16.834 57.2767V40.4429Z"
      fill="#E01E5A"
    />
    <path
      d="M23.5571 13.4463C19.8568 13.4463 16.834 10.4235 16.834 6.72313C16.834 3.0228 19.8568 0 23.5571 0C27.2574 0 30.2802 3.0228 30.2802 6.72313V13.4463H23.5571Z"
      fill="#36C5F0"
    />
    <path
      d="M23.557 16.834C27.2573 16.834 30.2801 19.8568 30.2801 23.5571C30.2801 27.2574 27.2573 30.2802 23.557 30.2802H6.72313C3.0228 30.2802 0 27.2574 0 23.5571C0 19.8568 3.0228 16.834 6.72313 16.834H23.557Z"
      fill="#36C5F0"
    />
    <path
      d="M50.5537 23.5571C50.5537 19.8568 53.5765 16.834 57.2768 16.834C60.9772 16.834 64 19.8568 64 23.5571C64 27.2574 60.9772 30.2802 57.2768 30.2802H50.5537V23.5571Z"
      fill="#2EB67D"
    />
    <path
      d="M47.166 23.557C47.166 27.2573 44.1432 30.2801 40.4429 30.2801C36.7425 30.2801 33.7197 27.2573 33.7197 23.557V6.72313C33.7197 3.0228 36.7425 0 40.4429 0C44.1432 0 47.166 3.0228 47.166 6.72313V23.557Z"
      fill="#2EB67D"
    />
    <path
      d="M40.4438 50.5537C44.1442 50.5537 47.167 53.5765 47.167 57.2768C47.167 60.9772 44.1442 64 40.4438 64C36.7435 64 33.7207 60.9772 33.7207 57.2768V50.5537H40.4438Z"
      fill="#ECB22E"
    />
    <path
      d="M40.4429 47.166C36.7425 47.166 33.7197 44.1432 33.7197 40.4429C33.7197 36.7425 36.7425 33.7197 40.4429 33.7197H57.2767C60.9771 33.7197 63.9999 36.7425 63.9999 40.4429C63.9999 44.1432 60.9771 47.166 57.2767 47.166H40.4429Z"
      fill="#ECB22E"
    />
  </svg>
);

export const BookADemoIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="64"
    height="65"
    viewBox="0 0 64 65"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_5834_38452)">
      <path
        d="M43.8415 42.0588C41.7719 43.8863 39.1873 46.1604 34.5009 46.1604H31.6986C28.3073 46.1604 25.2228 44.9338 23.015 42.7106C20.8583 40.5383 19.6711 37.5653 19.6711 34.3379V30.5227C19.6711 27.2953 20.8583 24.3222 23.015 22.1499C25.2228 19.9267 28.3073 18.7022 31.6986 18.7022H34.5009C39.193 18.7022 41.7719 20.9743 43.8415 22.8018C45.9906 24.6859 47.8444 26.3325 52.7883 26.3325C53.5423 26.3323 54.2951 26.2726 55.0396 26.1535L55.0226 26.1102C54.7265 25.3786 54.3792 24.6683 53.9831 23.985L50.6789 18.2896C49.1889 15.722 47.0459 13.59 44.4654 12.1077C41.8848 10.6254 38.9577 9.8451 35.9779 9.84521H29.3677C26.3881 9.8451 23.4607 10.6254 20.8803 12.1077C18.2997 13.59 16.1567 15.722 14.6667 18.2896L11.3625 23.985C9.873 26.553 9.08887 29.4655 9.08887 32.4303C9.08887 35.3952 9.873 38.3078 11.3625 40.8756L14.6667 46.5711C16.1567 49.1387 18.2997 51.2707 20.8803 52.7531C23.4607 54.2352 26.3881 55.0156 29.3677 55.0154H35.9779C38.9577 55.0156 41.8848 54.2352 44.4654 52.7531C47.0459 51.2707 49.1889 49.1387 50.6789 46.5711L53.9831 40.885C54.3792 40.2016 54.7265 39.4915 55.0226 38.7598L55.0396 38.7183C54.2955 38.5955 53.5426 38.5324 52.7883 38.5299C47.8444 38.5299 45.9906 40.1672 43.8415 42.0606"
        fill="#006BFF"
      />
      <path
        d="M34.5008 22.1593H31.6984C26.5368 22.1593 23.1455 25.8276 23.1455 30.5226V34.3379C23.1455 39.0329 26.5368 42.7012 31.6984 42.7012H34.5008C42.0217 42.7012 41.431 35.0708 52.7881 35.0708C53.8642 35.0696 54.938 35.168 55.9957 35.3647C56.3403 33.4235 56.3403 31.4372 55.9957 29.4958C54.9378 29.6918 53.8642 29.7901 52.7881 29.7897C41.4272 29.7897 42.0217 22.1593 34.5008 22.1593Z"
        fill="#006BFF"
      />
      <path
        d="M62.521 38.1531C60.587 36.7437 58.3566 35.7896 55.9979 35.3628C55.9979 35.3836 55.9979 35.4005 55.9979 35.4193C55.7949 36.5443 55.4778 37.6459 55.0512 38.707C56.9996 39.0073 58.8482 39.7649 60.4438 40.917C60.4438 40.9321 60.4344 40.9509 60.4287 40.9679C58.375 47.5851 54.0039 53.2499 48.1096 56.9328C42.2152 60.616 35.1886 62.0733 28.3064 61.0399C21.4241 60.0067 15.1426 56.5511 10.603 51.3014C6.06338 46.0517 3.56681 39.3559 3.56681 32.4303C3.56681 25.5049 6.06338 18.809 10.603 13.5593C15.1426 8.30952 21.4241 4.85412 28.3064 3.82078C35.1886 2.78743 42.2152 4.24467 48.1096 7.9278C54.0039 11.6109 58.375 17.2756 60.4287 23.8927C60.4287 23.9096 60.4382 23.9285 60.4438 23.9436C58.8484 25.096 56.9998 25.853 55.0512 26.1517C55.4772 27.2145 55.7944 28.3172 55.9979 29.4431C55.997 29.4608 55.997 29.4783 55.9979 29.4959C58.3565 29.0699 60.587 28.1164 62.521 26.7075C64.3804 25.3378 64.0206 23.7909 63.7385 22.8753C61.4396 15.4562 56.5421 9.10377 49.9357 4.97252C43.3293 0.841275 35.4528 -0.794662 27.737 0.361984C20.0214 1.51863 12.9788 5.3911 7.88902 11.2757C2.79922 17.1603 0 24.6665 0 32.4303C0 40.1941 2.79922 47.7004 7.88902 53.5851C12.9788 59.4697 20.0214 63.342 27.737 64.4988C35.4528 65.6555 43.3293 64.0195 49.9357 59.8882C56.5421 55.757 61.4396 49.4045 63.7385 41.9853C64.0206 41.0696 64.3804 39.5228 62.521 38.1531Z"
        fill="#006BFF"
      />
      <path
        d="M55.0394 26.1517C54.2953 26.2748 53.5424 26.3379 52.7881 26.3401C47.8442 26.3401 45.9904 24.7029 43.8432 22.8094C41.7717 20.9819 39.1928 18.7079 34.5007 18.7079H31.6984C28.3052 18.7079 25.2226 19.9343 23.0148 22.1575C20.8581 24.3298 19.6709 27.3029 19.6709 30.5303V34.3455C19.6709 37.5729 20.8581 40.5459 23.0148 42.7182C25.2226 44.9414 28.3052 46.1661 31.6984 46.1661H34.5007C39.1928 46.1661 41.7717 43.8939 43.8432 42.0664C45.9904 40.1823 47.8442 38.5356 52.7881 38.5356C53.542 38.5358 54.2949 38.5957 55.0394 38.7146C55.4668 37.6537 55.7841 36.5521 55.9862 35.4269C55.9873 35.4081 55.9873 35.3893 55.9862 35.3704C54.9283 35.1754 53.8545 35.0776 52.7786 35.0784C41.4176 35.0784 42.0122 42.7107 34.4913 42.7107H31.6889C26.5272 42.7107 23.136 39.0406 23.136 34.3455V30.5227C23.136 25.8277 26.5272 22.1594 31.6889 22.1594H34.4913C42.0122 22.1594 41.4214 29.788 52.7786 29.788C53.8547 29.7898 54.9285 29.6921 55.9862 29.4959C55.9862 29.479 55.9862 29.462 55.9862 29.4432C55.7826 28.3173 55.4655 27.2145 55.0394 26.1517Z"
        fill="#0AE8F0"
      />
      <path
        d="M55.0394 26.1517C54.2953 26.2748 53.5424 26.3379 52.7881 26.3401C47.8442 26.3401 45.9904 24.7029 43.8432 22.8094C41.7717 20.9819 39.1928 18.7079 34.5007 18.7079H31.6984C28.3052 18.7079 25.2226 19.9343 23.0148 22.1575C20.8581 24.3298 19.6709 27.3029 19.6709 30.5303V34.3455C19.6709 37.5729 20.8581 40.5459 23.0148 42.7182C25.2226 44.9414 28.3052 46.1661 31.6984 46.1661H34.5007C39.1928 46.1661 41.7717 43.8939 43.8432 42.0664C45.9904 40.1823 47.8442 38.5356 52.7881 38.5356C53.542 38.5358 54.2949 38.5957 55.0394 38.7146C55.4668 37.6537 55.7841 36.5521 55.9862 35.4269C55.9873 35.4081 55.9873 35.3893 55.9862 35.3704C54.9283 35.1754 53.8545 35.0776 52.7786 35.0784C41.4176 35.0784 42.0122 42.7107 34.4913 42.7107H31.6889C26.5272 42.7107 23.136 39.0406 23.136 34.3455V30.5227C23.136 25.8277 26.5272 22.1594 31.6889 22.1594H34.4913C42.0122 22.1594 41.4214 29.788 52.7786 29.788C53.8547 29.7898 54.9285 29.6921 55.9862 29.4959C55.9862 29.479 55.9862 29.462 55.9862 29.4432C55.7826 28.3173 55.4655 27.2145 55.0394 26.1517Z"
        fill="#0AE8F0"
      />
    </g>
    <defs>
      <clipPath id="clip0_5834_38452">
        <rect width="64" height="65" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const CircleCheckIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_6012_31294)">
      <path
        d="M5.25033 6.99996L6.41699 8.16663L8.75033 5.83329M12.8337 6.99996C12.8337 10.2216 10.222 12.8333 7.00033 12.8333C3.77866 12.8333 1.16699 10.2216 1.16699 6.99996C1.16699 3.7783 3.77866 1.16663 7.00033 1.16663C10.222 1.16663 12.8337 3.7783 12.8337 6.99996Z"
        stroke="#116932"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_6012_31294">
        <rect width="14" height="14" fill="currentColor" />
      </clipPath>
    </defs>
  </svg>
);

export const BoldCloseIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12 4L4 12M4 4L12 12"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CreditsIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    {...props}
  >
    <path
      d="M7.0029 12.8346C3.78123 12.8346 1.16956 10.223 1.16956 7.00127C1.16956 3.77964 3.78123 1.16797 7.0029 1.16797C10.2245 1.16797 12.8362 3.77964 12.8362 7.00127C12.8362 10.223 10.2245 12.8346 7.0029 12.8346ZM7.0029 11.6679C9.58024 11.6679 11.6696 9.57862 11.6696 7.00127C11.6696 4.42397 9.58024 2.33464 7.0029 2.33464C4.42556 2.33464 2.33622 4.42397 2.33622 7.00127C2.33622 9.57862 4.42556 11.6679 7.0029 11.6679ZM7.0029 4.11395L9.89023 7.00127L7.0029 9.88866L4.11554 7.00127L7.0029 4.11395ZM7.0029 5.76387L5.76545 7.00127L7.0029 8.23876L8.24033 7.00127L7.0029 5.76387Z"
      fill="currentColor"
    />
  </svg>
);

export const SnowflakeIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    {...props}
  >
    <path
      d="M2.66675 15.9993H29.3334M16.0001 2.66602V29.3327M26.6667 21.3327L21.3334 15.9993L26.6667 10.666M5.33341 10.666L10.6667 15.9993L5.33341 21.3327M21.3334 5.33268L16.0001 10.666L10.6667 5.33268M10.6667 26.666L16.0001 21.3327L21.3334 26.666"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const FolkLogoIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="36"
    height="36"
    viewBox="0 0 36 36"
    fill="none"
    {...props}
  >
    <path
      d="M4.4877 31.5C3.66608 31.5 3 30.8326 3 30.0099V5.9901C3 5.16714 3.68297 4.5 4.4877 4.5H31.5123C32.334 4.5 33 5.16743 33 5.9901V30.0099C33 30.8328 32.317 31.5 31.5123 31.5H4.4877ZM30 22.5V7.5H6V28.5L21 13.5L30 22.5ZM30 26.7426L21 17.7426L10.2426 28.5H30V26.7426ZM12 16.5C10.3431 16.5 9 15.1569 9 13.5C9 11.8431 10.3431 10.5 12 10.5C13.6569 10.5 15 11.8431 15 13.5C15 15.1569 13.6569 16.5 12 16.5Z"
      fill="#A0AEC0"
    />
  </svg>
);

export const AITextIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <g clipPath="url(#clip0_5472_61651)">
      <path
        d="M13.6447 5.79619L13.8091 5.41907C14.1021 4.74664 14.6298 4.21127 15.2884 3.91838L15.7948 3.69314C16.0686 3.57135 16.0686 3.17287 15.7948 3.05107L15.3167 2.83842C14.6412 2.538 14.104 1.98281 13.816 1.28755L13.6472 0.880013C13.5296 0.595985 13.1374 0.595985 13.0197 0.880013L12.8509 1.28755C12.563 1.98281 12.0258 2.538 11.3503 2.83842L10.8722 3.05107C10.5984 3.17287 10.5984 3.57135 10.8722 3.69314L11.3786 3.91838C12.0372 4.21127 12.5649 4.74664 12.8579 5.41907L13.0222 5.79619C13.1426 6.07227 13.5244 6.07227 13.6447 5.79619ZM1.3335 2.66699C1.3335 2.29881 1.63198 2.00033 2.00016 2.00033H9.3335V3.33366H2.66683V12.667H13.3335V7.33366H14.6668V13.3337C14.6668 13.7019 14.3684 14.0003 14.0002 14.0003H2.00016C1.63198 14.0003 1.3335 13.7019 1.3335 13.3337V2.66699ZM4.66683 5.33366H11.3335V7.33366H10.0002V6.66699H8.66683V9.33366H9.66683V10.667H6.3335V9.33366H7.3335V6.66699H6.00016V7.33366H4.66683V5.33366Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_5472_61651">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const HelpIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      d="M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM11 15H13V17H11V15ZM13 13.3551V14H11V12.5C11 11.9477 11.4477 11.5 12 11.5C12.8284 11.5 13.5 10.8284 13.5 10C13.5 9.17157 12.8284 8.5 12 8.5C11.2723 8.5 10.6656 9.01823 10.5288 9.70577L8.56731 9.31346C8.88637 7.70919 10.302 6.5 12 6.5C13.933 6.5 15.5 8.067 15.5 10C15.5 11.5855 14.4457 12.9248 13 13.3551Z"
      fill="currentColor"
    />
  </svg>
);

export const Star2Icon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    {...props}
  >
    <g clipPath="url(#clip0_6746_26068)">
      <path
        d="M13.9998 7.01371C10.2448 7.24016 7.23998 10.2451 7.01353 14H6.98612C6.75967 10.2451 3.75486 7.24016 0 7.01371V6.98629C3.75486 6.75984 6.75967 3.75503 6.98612 0H7.01353C7.23998 3.75503 10.2448 6.75984 13.9998 6.98629V7.01371Z"
        fill="url(#paint0_linear_6746_26068)"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_6746_26068"
        x1="1.8796"
        y1="-2.40625"
        x2="14.8153"
        y2="-0.191223"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#2C4FD7" />
        <stop offset="0.553232" stopColor="#1C6AFB" />
        <stop offset="1" stopColor="#2C50D9" />
      </linearGradient>
      <clipPath id="clip0_6746_26068">
        <rect width="14" height="14" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const CloseQuestionIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    {...props}
  >
    <path
      d="M9 16.5C4.85786 16.5 1.5 13.1421 1.5 9C1.5 4.85786 4.85786 1.5 9 1.5C13.1421 1.5 16.5 4.85786 16.5 9C16.5 13.1421 13.1421 16.5 9 16.5ZM9 7.93935L6.87868 5.81802L5.81802 6.87868L7.93935 9L5.81802 11.1213L6.87868 12.1819L9 10.0606L11.1213 12.1819L12.1819 11.1213L10.0606 9L12.1819 6.87868L11.1213 5.81802L9 7.93935Z"
      fill="currentColor"
      fillOpacity="0.5"
    />
  </svg>
);

export const ArrowBackIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="19"
    height="18"
    viewBox="0 0 19 18"
    fill="none"
    {...props}
  >
    <path
      d="M17.0002 9.74995L17.0003 8.25003H4.87134L7.83363 5.28771L6.77297 4.22705L2 9.00003L6.77297 13.773L7.83363 12.7123L4.8713 9.75003L17.0002 9.74995Z"
      fill="currentColor"
    />
  </svg>
);

export const ChatSpotlightIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="44"
    height="44"
    viewBox="0 0 44 44"
    fill="none"
    {...props}
  >
    <path
      d="M3.6665 14.667H40.3332"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M36.6665 7.33301H7.33317C5.30813 7.33301 3.6665 8.97463 3.6665 10.9997V32.9997C3.6665 35.0247 5.30813 36.6663 7.33317 36.6663H36.6665C38.6915 36.6663 40.3332 35.0247 40.3332 32.9997V10.9997C40.3332 8.97463 38.6915 7.33301 36.6665 7.33301Z"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11 29.333H33"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ChatWidgetIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="44"
    height="44"
    viewBox="0 0 44 44"
    fill="none"
    {...props}
  >
    <path
      d="M40.3332 31.1667C40.3332 32.1391 39.9469 33.0718 39.2592 33.7594C38.5716 34.447 37.639 34.8333 36.6665 34.8333H12.5178C11.5455 34.8335 10.613 35.22 9.9255 35.9077L5.8885 39.9447C5.70646 40.1267 5.47454 40.2506 5.22207 40.3008C4.96959 40.351 4.70789 40.3253 4.47007 40.2268C4.23224 40.1283 4.02896 39.9614 3.88593 39.7474C3.7429 39.5334 3.66654 39.2818 3.6665 39.0243V9.16667C3.6665 8.19421 4.05281 7.26158 4.74045 6.57394C5.42808 5.88631 6.36071 5.5 7.33317 5.5H36.6665C37.639 5.5 38.5716 5.88631 39.2592 6.57394C39.9469 7.26158 40.3332 8.19421 40.3332 9.16667V31.1667Z"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const OpenLinkIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <path
      d="M14 8.66667V12.6667C14 13.0203 13.8595 13.3594 13.6095 13.6095C13.3594 13.8595 13.0203 14 12.6667 14H3.33333C2.97971 14 2.64057 13.8595 2.39052 13.6095C2.14048 13.3594 2 13.0203 2 12.6667V3.33333C2 2.97971 2.14048 2.64057 2.39052 2.39052C2.64057 2.14048 2.97971 2 3.33333 2H7.33333M14 2L8 8M14 2H10M14 2V6"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CopyLinkIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <g clipPath="url(#clip0_8626_9773)">
      <path
        d="M6.6668 8.66697C6.9531 9.04972 7.31837 9.36642 7.73783 9.5956C8.1573 9.82477 8.62114 9.96105 9.0979 9.99519C9.57466 10.0293 10.0532 9.96055 10.501 9.79349C10.9489 9.62643 11.3555 9.36502 11.6935 9.02697L13.6935 7.02697C14.3007 6.3983 14.6366 5.55629 14.629 4.6823C14.6215 3.80831 14.2709 2.97227 13.6529 2.35424C13.0348 1.73621 12.1988 1.38565 11.3248 1.37806C10.4508 1.37046 9.60881 1.70644 8.98013 2.31364L7.83347 3.45364M9.33347 7.33364C9.04716 6.95088 8.68189 6.63418 8.26243 6.40501C7.84297 6.17584 7.37913 6.03956 6.90237 6.00541C6.4256 5.97127 5.94708 6.04006 5.49924 6.20712C5.0514 6.37417 4.64472 6.63559 4.3068 6.97364L2.3068 8.97364C1.69961 9.60231 1.36363 10.4443 1.37122 11.3183C1.37881 12.1923 1.72938 13.0283 2.3474 13.6464C2.96543 14.2644 3.80147 14.615 4.67546 14.6226C5.54945 14.6301 6.39146 14.2942 7.02013 13.687L8.16013 12.547"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_8626_9773">
        <rect width="16" height="16" fill="curr" />
      </clipPath>
    </defs>
  </svg>
);
export const TopCircleIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="184"
    height="130"
    viewBox="0 0 184 130"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <ellipse
      cx="92.1755"
      cy="64.8774"
      rx="32.5287"
      ry="106.869"
      transform="rotate(-56.6909 92.1755 64.8774)"
      stroke="url(#paint0_linear_588_48354)"
      strokeWidth="0.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <defs>
      <linearGradient
        id="paint0_linear_588_48354"
        x1="59.6468"
        y1="64.8774"
        x2="124.704"
        y2="64.8774"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F9B4FF" />
        <stop offset="1" stopColor="#4FC3FF" />
      </linearGradient>
    </defs>
  </svg>
);

export const CopyCopyIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <g clipPath="url(#clip0_8626_9907)">
      <path
        d="M2.66683 10.6663C1.9335 10.6663 1.3335 10.0663 1.3335 9.33301V2.66634C1.3335 1.93301 1.9335 1.33301 2.66683 1.33301H9.3335C10.0668 1.33301 10.6668 1.93301 10.6668 2.66634M6.66683 5.33301H13.3335C14.0699 5.33301 14.6668 5.92996 14.6668 6.66634V13.333C14.6668 14.0694 14.0699 14.6663 13.3335 14.6663H6.66683C5.93045 14.6663 5.3335 14.0694 5.3335 13.333V6.66634C5.3335 5.92996 5.93045 5.33301 6.66683 5.33301Z"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_8626_9907">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const TopStarIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="10"
    height="10"
    viewBox="0 0 10 10"
    fill="none"
    {...props}
  >
    <path
      d="M5.01762 0.000411341C5.24098 0.0112834 5.24367 0.212415 5.25457 0.389086C5.28726 0.913664 5.30363 1.44095 5.35811 1.96281C5.52972 3.62624 6.415 4.49059 8.08476 4.64551C8.5669 4.689 9.05177 4.71074 9.53391 4.73792C9.73276 4.74879 9.99152 4.71346 9.99969 4.98255C10.0106 5.28696 9.73274 5.25977 9.523 5.25977C8.92374 5.26249 8.32718 5.30599 7.73609 5.40384C6.41499 5.624 5.71224 6.2899 5.44257 7.5864C5.30365 8.24416 5.26547 8.91008 5.25729 9.57871C5.25729 9.76625 5.2573 9.96195 4.99036 10C4.7561 9.95923 4.73704 9.77713 4.7316 9.58415C4.71525 8.9726 4.69619 8.36377 4.60085 7.75493C4.39928 6.4829 3.76191 5.76804 2.51435 5.46362C1.84699 5.30054 1.16329 5.26793 0.476861 5.25977C0.272567 5.25977 -0.00799727 5.29784 0.000174506 4.98527C0.00562235 4.70259 0.267103 4.75151 0.460502 4.73792C0.95898 4.70802 1.45745 4.689 1.95321 4.64279C3.56305 4.48787 4.37479 3.6942 4.62267 2.09329C4.70983 1.52794 4.70708 0.959873 4.73432 0.391807C4.74249 0.196109 4.76974 -0.0104607 5.01762 0.000411341Z"
      fill="url(#paint0_linear_1985_1757)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_1985_1757"
        x1="0"
        y1="5"
        x2="10"
        y2="5"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F9B4FF" />
        <stop offset="1" stopColor="#4FC3FF" />
      </linearGradient>
    </defs>
  </svg>
);

export const WebLinkIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11 20.5C16.2467 20.5 20.5 16.2467 20.5 11C20.5 5.75329 16.2467 1.5 11 1.5C5.75329 1.5 1.5 5.75329 1.5 11C1.5 16.2467 5.75329 20.5 11 20.5Z"
      stroke="#202020"
      strokeWidth="1.14"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11 20.5C16.2467 20.5 20.5 16.2467 20.5 11C20.5 5.75329 16.2467 1.5 11 1.5C5.75329 1.5 1.5 5.75329 1.5 11C1.5 16.2467 5.75329 20.5 11 20.5Z"
      stroke="currentColor"
      strokeOpacity="1"
      strokeWidth="1.14"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11 20.5C16.2467 20.5 20.5 16.2467 20.5 11C20.5 5.75329 16.2467 1.5 11 1.5C5.75329 1.5 1.5 5.75329 1.5 11C1.5 16.2467 5.75329 20.5 11 20.5Z"
      stroke="currentColor"
      strokeOpacity="1"
      strokeWidth="1.14"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11 20.5C16.2467 20.5 20.5 16.2467 20.5 11C20.5 5.75329 16.2467 1.5 11 1.5C5.75329 1.5 1.5 5.75329 1.5 11C1.5 16.2467 5.75329 20.5 11 20.5Z"
      stroke="currentColor"
      strokeOpacity="1"
      strokeWidth="1.14"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11 20.5C16.2467 20.5 20.5 16.2467 20.5 11C20.5 5.75329 16.2467 1.5 11 1.5C5.75329 1.5 1.5 5.75329 1.5 11C1.5 16.2467 5.75329 20.5 11 20.5Z"
      stroke="currentColor"
      strokeOpacity="1"
      strokeWidth="1.14"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11 20.5C16.2467 20.5 20.5 16.2467 20.5 11C20.5 5.75329 16.2467 1.5 11 1.5C5.75329 1.5 1.5 5.75329 1.5 11C1.5 16.2467 5.75329 20.5 11 20.5Z"
      stroke="currentColor"
      strokeOpacity="1"
      strokeWidth="1.14"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11 20.5C16.2467 20.5 20.5 16.2467 20.5 11C20.5 5.75329 16.2467 1.5 11 1.5C5.75329 1.5 1.5 5.75329 1.5 11C1.5 16.2467 5.75329 20.5 11 20.5Z"
      stroke="currentColor"
      strokeOpacity="1"
      strokeWidth="1.14"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.999 20.5C13.8645 20.5 16.1875 16.2467 16.1875 11C16.1875 5.75329 13.8645 1.5 10.999 1.5C8.1335 1.5 5.81055 5.75329 5.81055 11C5.81055 16.2467 8.1335 20.5 10.999 20.5Z"
      stroke="#202020"
      strokeWidth="1.14"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.999 20.5C13.8645 20.5 16.1875 16.2467 16.1875 11C16.1875 5.75329 13.8645 1.5 10.999 1.5C8.1335 1.5 5.81055 5.75329 5.81055 11C5.81055 16.2467 8.1335 20.5 10.999 20.5Z"
      stroke="currentColor"
      strokeOpacity="1"
      strokeWidth="1.14"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.999 20.5C13.8645 20.5 16.1875 16.2467 16.1875 11C16.1875 5.75329 13.8645 1.5 10.999 1.5C8.1335 1.5 5.81055 5.75329 5.81055 11C5.81055 16.2467 8.1335 20.5 10.999 20.5Z"
      stroke="currentColor"
      strokeOpacity="1"
      strokeWidth="1.14"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.999 20.5C13.8645 20.5 16.1875 16.2467 16.1875 11C16.1875 5.75329 13.8645 1.5 10.999 1.5C8.1335 1.5 5.81055 5.75329 5.81055 11C5.81055 16.2467 8.1335 20.5 10.999 20.5Z"
      stroke="currentColor"
      strokeOpacity="1"
      strokeWidth="1.14"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.999 20.5C13.8645 20.5 16.1875 16.2467 16.1875 11C16.1875 5.75329 13.8645 1.5 10.999 1.5C8.1335 1.5 5.81055 5.75329 5.81055 11C5.81055 16.2467 8.1335 20.5 10.999 20.5Z"
      stroke="currentColor"
      strokeOpacity="1"
      strokeWidth="1.14"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.999 20.5C13.8645 20.5 16.1875 16.2467 16.1875 11C16.1875 5.75329 13.8645 1.5 10.999 1.5C8.1335 1.5 5.81055 5.75329 5.81055 11C5.81055 16.2467 8.1335 20.5 10.999 20.5Z"
      stroke="currentColor"
      strokeOpacity="1"
      strokeWidth="1.14"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.999 20.5C13.8645 20.5 16.1875 16.2467 16.1875 11C16.1875 5.75329 13.8645 1.5 10.999 1.5C8.1335 1.5 5.81055 5.75329 5.81055 11C5.81055 16.2467 8.1335 20.5 10.999 20.5Z"
      stroke="currentColor"
      strokeOpacity="1"
      strokeWidth="1.14"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.0003 1.5V20.5"
      stroke="#202020"
      strokeWidth="1.14"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.0003 1.5V20.5"
      stroke="currentColor"
      strokeOpacity="1"
      strokeWidth="1.14"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.0003 1.5V20.5"
      stroke="currentColor"
      strokeOpacity="1"
      strokeWidth="1.14"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.0003 1.5V20.5"
      stroke="currentColor"
      strokeOpacity="1"
      strokeWidth="1.14"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.0003 1.5V20.5"
      stroke="currentColor"
      strokeOpacity="1"
      strokeWidth="1.14"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.0003 1.5V20.5"
      stroke="currentColor"
      strokeOpacity="1"
      strokeWidth="1.14"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.0003 1.5V20.5"
      stroke="currentColor"
      strokeOpacity="1"
      strokeWidth="1.14"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20.5 11.0003H1.5"
      stroke="#202020"
      strokeWidth="1.14"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20.5 11.0003H1.5"
      stroke="currentColor"
      strokeOpacity="1"
      strokeWidth="1.14"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20.5 11.0003H1.5"
      stroke="currentColor"
      strokeOpacity="1"
      strokeWidth="1.14"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20.5 11.0003H1.5"
      stroke="currentColor"
      strokeOpacity="1"
      strokeWidth="1.14"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20.5 11.0003H1.5"
      stroke="currentColor"
      strokeOpacity="1"
      strokeWidth="1.14"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20.5 11.0003H1.5"
      stroke="currentColor"
      strokeOpacity="1"
      strokeWidth="1.14"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20.5 11.0003H1.5"
      stroke="currentColor"
      strokeOpacity="1"
      strokeWidth="1.14"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.22461 5.81182H18.7754"
      stroke="#202020"
      strokeWidth="1.14"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.22461 5.81182H18.7754"
      stroke="currentColor"
      strokeOpacity="1"
      strokeWidth="1.14"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.22461 5.81182H18.7754"
      stroke="currentColor"
      strokeOpacity="1"
      strokeWidth="1.14"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.22461 5.81182H18.7754"
      stroke="currentColor"
      strokeOpacity="1"
      strokeWidth="1.14"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.22461 5.81182H18.7754"
      stroke="currentColor"
      strokeOpacity="1"
      strokeWidth="1.14"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.22461 5.81182H18.7754"
      stroke="currentColor"
      strokeOpacity="1"
      strokeWidth="1.14"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.22461 5.81182H18.7754"
      stroke="currentColor"
      strokeOpacity="1"
      strokeWidth="1.14"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.22461 16.1888H18.7754"
      stroke="#202020"
      strokeWidth="1.14"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.22461 16.1888H18.7754"
      stroke="currentColor"
      strokeOpacity="1"
      strokeWidth="1.14"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.22461 16.1888H18.7754"
      stroke="currentColor"
      strokeOpacity="1"
      strokeWidth="1.14"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.22461 16.1888H18.7754"
      stroke="currentColor"
      strokeOpacity="1"
      strokeWidth="1.14"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.22461 16.1888H18.7754"
      stroke="currentColor"
      strokeOpacity="1"
      strokeWidth="1.14"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.22461 16.1888H18.7754"
      stroke="currentColor"
      strokeOpacity="1"
      strokeWidth="1.14"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.22461 16.1888H18.7754"
      stroke="currentColor"
      strokeOpacity="1"
      strokeWidth="1.14"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const GoogleIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    {...props}
  >
    <mask
      id="mask0_9375_1370"
      style={{
        maskType: "luminance"
      }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="20"
      height="20"
    >
      <path
        d="M19.8079 8.14476H10.213V11.9894H15.7263C15.6377 12.5336 15.4387 13.0688 15.1472 13.5569C14.8133 14.1161 14.4006 14.5418 13.9775 14.866C12.7101 15.8372 11.2325 16.0358 10.2063 16.0358C7.61409 16.0358 5.39919 14.3604 4.54176 12.0838C4.50716 12.0012 4.48418 11.9159 4.4562 11.8315C4.26673 11.2521 4.1632 10.6384 4.1632 10.0006C4.1632 9.33685 4.27531 8.70145 4.47972 8.10134C5.28599 5.73451 7.55082 3.96672 10.2082 3.96672C10.7427 3.96672 11.2574 4.03034 11.7455 4.15724C12.861 4.44725 13.6501 5.01843 14.1336 5.47023L17.0511 2.61313C15.2764 0.985972 12.9629 2.46015e-09 10.2033 2.46015e-09C7.99721 -4.74827e-05 5.96042 0.687318 4.29133 1.84899C2.93776 2.79107 1.82764 4.0524 1.07844 5.5173C0.381576 6.87555 0 8.38075 0 9.99913C0 11.6176 0.382159 13.1384 1.07902 14.4841V14.4932C1.81508 15.9218 2.89146 17.1519 4.19967 18.0897C5.34254 18.9089 7.39181 20 10.2033 20C11.8202 20 13.2531 19.7085 14.5169 19.1622C15.4285 18.7681 16.2363 18.2541 16.9676 17.5935C17.9339 16.7206 18.6906 15.6409 19.2072 14.3987C19.7237 13.1565 20 11.7518 20 10.2289C20 9.51963 19.9288 8.79934 19.8079 8.14469V8.14476Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_9375_1370)">
      <g filter="url(#filter0_f_9375_1370)">
        <path
          d="M-0.147461 10.0664C-0.136855 11.6593 0.317039 13.3028 1.00408 14.6295V14.6387C1.50051 15.6022 2.17897 16.3633 2.95174 17.1174L7.61903 15.4144C6.736 14.9658 6.60126 14.691 5.96828 14.1895C5.32142 13.5372 4.83932 12.7884 4.53908 11.9104H4.52699L4.53908 11.9013C4.34156 11.3215 4.32208 10.706 4.31479 10.0664H-0.147461Z"
          fill="url(#paint0_radial_9375_1370)"
        />
      </g>
      <g filter="url(#filter1_f_9375_1370)">
        <path
          d="M10.2133 -0.0732422C9.75202 1.54742 9.92841 3.12275 10.2133 4.03935C10.746 4.03975 11.2592 4.10325 11.7458 4.22975C12.8613 4.51977 13.6503 5.09096 14.1338 5.54276L17.126 2.61267C15.3534 0.98745 13.2203 -0.0706816 10.2133 -0.0732422Z"
          fill="url(#paint1_radial_9375_1370)"
        />
      </g>
      <g filter="url(#filter2_f_9375_1370)">
        <path
          d="M10.2026 -0.0859375C7.93979 -0.0859864 5.85072 0.619025 4.13879 1.81052C3.50315 2.25292 2.91984 2.76397 2.40043 3.33227C2.26436 4.60882 3.41903 6.17783 5.70564 6.16485C6.81508 4.87431 8.45593 4.03933 10.2822 4.03933C10.2839 4.03933 10.2855 4.03947 10.2871 4.03947L10.2126 -0.0856455C10.2092 -0.0856476 10.2059 -0.0859375 10.2026 -0.0859375Z"
          fill="url(#paint2_radial_9375_1370)"
        />
      </g>
      <g filter="url(#filter3_f_9375_1370)">
        <path
          d="M17.6713 10.5286L15.6517 11.9161C15.563 12.4602 15.3639 12.9954 15.0725 13.4835C14.7386 14.0427 14.3258 14.4684 13.9027 14.7927C12.638 15.7618 11.1643 15.9614 10.1384 15.9622C9.07801 17.7682 8.89211 18.6728 10.213 20.1304C11.8474 20.1292 13.2964 19.8341 14.5745 19.2817C15.4983 18.8823 16.3169 18.3614 17.058 17.6919C18.0372 16.8073 18.8043 15.7131 19.3277 14.4542C19.8512 13.1954 20.1311 11.7719 20.1311 10.2285L17.6713 10.5286Z"
          fill="url(#paint3_radial_9375_1370)"
        />
      </g>
      <g filter="url(#filter4_f_9375_1370)">
        <path
          d="M10.0635 7.99805V12.1349H19.7806C19.8661 11.5683 20.1487 10.8352 20.1487 10.2283C20.1487 9.51901 20.0775 8.65269 19.9567 7.99805H10.0635Z"
          fill="#3086FF"
        />
      </g>
      <g filter="url(#filter5_f_9375_1370)">
        <path
          d="M2.4471 3.18652C1.84746 3.84262 1.33517 4.57698 0.928995 5.37117C0.232145 6.72943 -0.149414 8.38069 -0.149414 9.99907C-0.149414 10.0219 -0.147527 10.0442 -0.147374 10.067C0.161239 10.6587 4.11556 10.5454 4.31488 10.067C4.31463 10.0446 4.31211 10.0229 4.31211 10.0005C4.31211 9.33671 4.42426 8.84745 4.62866 8.24734C4.88082 7.50711 5.27566 6.82546 5.78054 6.23817C5.89499 6.09205 6.20027 5.77793 6.28934 5.58951C6.32327 5.51774 6.22774 5.47746 6.2224 5.4522C6.21642 5.42395 6.08835 5.44667 6.05966 5.42562C5.96856 5.3588 5.78815 5.3239 5.67861 5.29289C5.44446 5.22659 5.05642 5.08038 4.84089 4.92883C4.1596 4.44976 3.09639 3.87752 2.4471 3.18652Z"
          fill="url(#paint4_radial_9375_1370)"
        />
      </g>
      <g filter="url(#filter6_f_9375_1370)">
        <path
          d="M4.85582 5.45512C6.43566 6.41212 6.88999 4.97208 7.94036 4.52146L6.11321 0.732422C5.44108 1.01492 4.80605 1.36589 4.21684 1.77597C3.33691 2.3884 2.55986 3.13574 1.91797 3.98622L4.85582 5.45512Z"
          fill="url(#paint5_radial_9375_1370)"
        />
      </g>
      <g filter="url(#filter7_f_9375_1370)">
        <path
          d="M5.49854 15.1215C3.37781 15.8872 3.0458 15.9146 2.85059 17.2289C3.22363 17.5929 3.62443 17.9297 4.05035 18.235C5.19322 19.0542 7.3916 20.1453 10.2031 20.1453C10.2064 20.1453 10.2096 20.145 10.2129 20.145V15.8888C10.2108 15.8888 10.2083 15.8889 10.2062 15.8889C9.15337 15.8889 8.31206 15.6124 7.44946 15.1315C7.23678 15.013 6.85092 15.3313 6.65477 15.189C6.38424 14.9927 5.73318 15.3581 5.49854 15.1215Z"
          fill="url(#paint6_radial_9375_1370)"
        />
      </g>
      <g opacity="0.5" filter="url(#filter8_f_9375_1370)">
        <path
          d="M8.9707 15.7549V20.0714C9.36409 20.1175 9.77348 20.1454 10.2029 20.1454C10.6335 20.1454 11.05 20.1233 11.4547 20.0827V15.784C11.0012 15.8615 10.574 15.8891 10.206 15.8891C9.7822 15.8891 9.37005 15.8398 8.9707 15.7549Z"
          fill="url(#paint7_linear_9375_1370)"
        />
      </g>
    </g>
    <defs>
      <filter
        id="filter0_f_9375_1370"
        x="-0.221169"
        y="9.9927"
        width="7.91402"
        height="7.1982"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="0.0368542"
          result="effect1_foregroundBlur_9375_1370"
        />
      </filter>
      <filter
        id="filter1_f_9375_1370"
        x="9.85598"
        y="-0.146951"
        width="7.34371"
        height="5.76363"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="0.0368542"
          result="effect1_foregroundBlur_9375_1370"
        />
      </filter>
      <filter
        id="filter2_f_9375_1370"
        x="2.31594"
        y="-0.159646"
        width="8.04488"
        height="6.39839"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="0.0368542"
          result="effect1_foregroundBlur_9375_1370"
        />
      </filter>
      <filter
        id="filter3_f_9375_1370"
        x="9.20852"
        y="10.1548"
        width="10.996"
        height="10.0498"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="0.0368542"
          result="effect1_foregroundBlur_9375_1370"
        />
      </filter>
      <filter
        id="filter4_f_9375_1370"
        x="9.98977"
        y="7.92434"
        width="10.2324"
        height="4.28414"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="0.0368542"
          result="effect1_foregroundBlur_9375_1370"
        />
      </filter>
      <filter
        id="filter5_f_9375_1370"
        x="-0.223122"
        y="3.11282"
        width="6.59371"
        height="7.43062"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="0.0368542"
          result="effect1_foregroundBlur_9375_1370"
        />
      </filter>
      <filter
        id="filter6_f_9375_1370"
        x="1.39977"
        y="0.214221"
        width="7.05886"
        height="6.08035"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="0.2591"
          result="effect1_foregroundBlur_9375_1370"
        />
      </filter>
      <filter
        id="filter7_f_9375_1370"
        x="2.77688"
        y="15.0308"
        width="7.50972"
        height="5.18843"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="0.0368542"
          result="effect1_foregroundBlur_9375_1370"
        />
      </filter>
      <filter
        id="filter8_f_9375_1370"
        x="8.89699"
        y="15.6812"
        width="2.63179"
        height="4.53804"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="0.0368542"
          result="effect1_foregroundBlur_9375_1370"
        />
      </filter>
      <radialGradient
        id="paint0_radial_9375_1370"
        cx="0"
        cy="0"
        r="1"
        gradientTransform="matrix(-0.415601 -9.95993 14.9426 -0.597686 7.52559 16.9673)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.141612" stopColor="#1ABD4D" />
        <stop offset="0.247515" stopColor="#6EC30D" />
        <stop offset="0.311547" stopColor="#8AC502" />
        <stop offset="0.366013" stopColor="#A2C600" />
        <stop offset="0.445673" stopColor="#C8C903" />
        <stop offset="0.540305" stopColor="#EBCB03" />
        <stop offset="0.615636" stopColor="#F7CD07" />
        <stop offset="0.699345" stopColor="#FDCD04" />
        <stop offset="0.771242" stopColor="#FDCE05" />
        <stop offset="0.860566" stopColor="#FFCE0A" />
      </radialGradient>
      <radialGradient
        id="paint1_radial_9375_1370"
        cx="0"
        cy="0"
        r="1"
        gradientTransform="matrix(7.05806 -1.69631e-05 -9.92038e-06 8.92438 16.846 5.33076)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.408458" stopColor="#FB4E5A" />
        <stop offset="1" stopColor="#FF4540" />
      </radialGradient>
      <radialGradient
        id="paint2_radial_9375_1370"
        cx="0"
        cy="0"
        r="1"
        gradientTransform="matrix(-9.88885 5.36243 7.4323 13.1383 12.9908 -1.37777)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.231273" stopColor="#FF4541" />
        <stop offset="0.311547" stopColor="#FF4540" />
        <stop offset="0.457516" stopColor="#FF4640" />
        <stop offset="0.540305" stopColor="#FF473F" />
        <stop offset="0.699346" stopColor="#FF5138" />
        <stop offset="0.771242" stopColor="#FF5B33" />
        <stop offset="0.860566" stopColor="#FF6C29" />
        <stop offset="1" stopColor="#FF8C18" />
      </radialGradient>
      <radialGradient
        id="paint3_radial_9375_1370"
        cx="0"
        cy="0"
        r="1"
        gradientTransform="matrix(-17.9337 -22.9206 -8.64137 6.48127 10.36 18.836)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.131546" stopColor="#0CBA65" />
        <stop offset="0.209784" stopColor="#0BB86D" />
        <stop offset="0.297297" stopColor="#09B479" />
        <stop offset="0.396257" stopColor="#08AD93" />
        <stop offset="0.477124" stopColor="#0AA6A9" />
        <stop offset="0.568425" stopColor="#0D9CC6" />
        <stop offset="0.667385" stopColor="#1893DD" />
        <stop offset="0.768727" stopColor="#258BF1" />
        <stop offset="0.858506" stopColor="#3086FF" />
      </radialGradient>
      <radialGradient
        id="paint4_radial_9375_1370"
        cx="0"
        cy="0"
        r="1"
        gradientTransform="matrix(-1.26913 10.7101 15.1251 1.71807 9.3365 1.8033)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.366013" stopColor="#FF4E3A" />
        <stop offset="0.457516" stopColor="#FF8A1B" />
        <stop offset="0.540305" stopColor="#FFA312" />
        <stop offset="0.615636" stopColor="#FFB60C" />
        <stop offset="0.771242" stopColor="#FFCD0A" />
        <stop offset="0.860566" stopColor="#FECF0A" />
        <stop offset="0.915033" stopColor="#FECF08" />
        <stop offset="1" stopColor="#FDCD01" />
      </radialGradient>
      <radialGradient
        id="paint5_radial_9375_1370"
        cx="0"
        cy="0"
        r="1"
        gradientTransform="matrix(-3.66844 3.97231 -11.4435 -10.1305 7.55207 1.6923)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.315904" stopColor="#FF4C3C" />
        <stop offset="0.603818" stopColor="#FF692C" />
        <stop offset="0.726837" stopColor="#FF7825" />
        <stop offset="0.884534" stopColor="#FF8D1B" />
        <stop offset="1" stopColor="#FF9F13" />
      </radialGradient>
      <radialGradient
        id="paint6_radial_9375_1370"
        cx="0"
        cy="0"
        r="1"
        gradientTransform="matrix(-9.88885 -5.36243 7.4323 -13.1383 12.9911 21.3764)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.231273" stopColor="#0FBC5F" />
        <stop offset="0.311547" stopColor="#0FBC5F" />
        <stop offset="0.366013" stopColor="#0FBC5E" />
        <stop offset="0.457516" stopColor="#0FBC5D" />
        <stop offset="0.540305" stopColor="#12BC58" />
        <stop offset="0.699346" stopColor="#28BF3C" />
        <stop offset="0.771242" stopColor="#38C02B" />
        <stop offset="0.860566" stopColor="#52C218" />
        <stop offset="0.915033" stopColor="#67C30F" />
        <stop offset="1" stopColor="#86C504" />
      </radialGradient>
      <linearGradient
        id="paint7_linear_9375_1370"
        x1="8.9707"
        y1="17.9502"
        x2="11.4547"
        y2="17.9502"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#0FBC5C" />
        <stop offset="1" stopColor="#0CBA65" />
      </linearGradient>
    </defs>
  </svg>
);

export const TeamIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    {...props}
  >
    <path
      d="M13.9998 12.667C17.6817 12.667 20.6665 15.6518 20.6665 19.3337V27.3337H17.9998V19.3337C17.9998 17.2034 16.3346 15.4621 14.2349 15.3405L13.9998 15.3337C11.8696 15.3337 10.1283 16.9989 10.0066 19.0986L9.99984 19.3337V27.3337H7.33317V19.3337C7.33317 15.6518 10.3179 12.667 13.9998 12.667ZM5.33317 16.667C5.70497 16.667 6.06662 16.7105 6.4133 16.7926C6.1892 17.459 6.05148 18.163 6.01178 18.8927L5.99984 19.3337L6.00077 19.4478C5.84993 19.3945 5.69078 19.3586 5.52578 19.3429L5.33317 19.3337C4.29357 19.3337 3.43924 20.1269 3.34233 21.141L3.33317 21.3337V27.3337H0.666504V21.3337C0.666504 18.7563 2.75584 16.667 5.33317 16.667ZM22.6665 16.667C25.2438 16.667 27.3332 18.7563 27.3332 21.3337V27.3337H24.6665V21.3337C24.6665 20.2941 23.8733 19.4398 22.8592 19.3429L22.6665 19.3337C22.4329 19.3337 22.2086 19.3737 22.0002 19.4473L21.9998 19.3337C21.9998 18.4461 21.8553 17.5923 21.5885 16.7945C21.933 16.7105 22.2946 16.667 22.6665 16.667ZM5.33317 8.66699C7.17412 8.66699 8.6665 10.1594 8.6665 12.0003C8.6665 13.8413 7.17412 15.3337 5.33317 15.3337C3.49222 15.3337 1.99984 13.8413 1.99984 12.0003C1.99984 10.1594 3.49222 8.66699 5.33317 8.66699ZM22.6665 8.66699C24.5074 8.66699 25.9998 10.1594 25.9998 12.0003C25.9998 13.8413 24.5074 15.3337 22.6665 15.3337C20.8256 15.3337 19.3332 13.8413 19.3332 12.0003C19.3332 10.1594 20.8256 8.66699 22.6665 8.66699ZM5.33317 11.3337C4.96498 11.3337 4.6665 11.6322 4.6665 12.0003C4.6665 12.3685 4.96498 12.667 5.33317 12.667C5.70136 12.667 5.99984 12.3685 5.99984 12.0003C5.99984 11.6322 5.70136 11.3337 5.33317 11.3337ZM22.6665 11.3337C22.2984 11.3337 21.9998 11.6322 21.9998 12.0003C21.9998 12.3685 22.2984 12.667 22.6665 12.667C23.0346 12.667 23.3332 12.3685 23.3332 12.0003C23.3332 11.6322 23.0346 11.3337 22.6665 11.3337ZM13.9998 0.666992C16.9453 0.666992 19.3332 3.05481 19.3332 6.00033C19.3332 8.94584 16.9453 11.3337 13.9998 11.3337C11.0543 11.3337 8.6665 8.94584 8.6665 6.00033C8.6665 3.05481 11.0543 0.666992 13.9998 0.666992ZM13.9998 3.33366C12.527 3.33366 11.3332 4.52757 11.3332 6.00033C11.3332 7.47308 12.527 8.66699 13.9998 8.66699C15.4726 8.66699 16.6665 7.47308 16.6665 6.00033C16.6665 4.52757 15.4726 3.33366 13.9998 3.33366Z"
      fill="currentColor"
    />
  </svg>
);

export const ArrowOpen = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <path
      d="M14 3.33268L14 12.666M7.33333 11.9993L11.3333 7.99935M11.3333 7.99935L7.33333 3.99935M11.3333 7.99935L2 7.99935"
      stroke="#3F3F46"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const WebflowIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="13"
    viewBox="0 0 20 13"
    fill="none"
    {...props}
  >
    <g clipPath="url(#clip0_10073_15131)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20 0L13.6105 12.4481H7.62125L10.2848 7.28446H10.1617C7.97537 10.1429 4.68052 12.0178 0 12.4481V7.3613C0 7.3613 3.00231 7.19225 4.75751 5.33272H0V0H5.34257V4.39527H5.46574L7.65204 0H11.7013V4.36453H11.8245L14.0724 0H20Z"
        fill="#202020"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20 0L13.6105 12.4481H7.62125L10.2848 7.28446H10.1617C7.97537 10.1429 4.68052 12.0178 0 12.4481V7.3613C0 7.3613 3.00231 7.19225 4.75751 5.33272H0V0H5.34257V4.39527H5.46574L7.65204 0H11.7013V4.36453H11.8245L14.0724 0H20Z"
        fill="black"
        fillOpacity="0.2"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20 0L13.6105 12.4481H7.62125L10.2848 7.28446H10.1617C7.97537 10.1429 4.68052 12.0178 0 12.4481V7.3613C0 7.3613 3.00231 7.19225 4.75751 5.33272H0V0H5.34257V4.39527H5.46574L7.65204 0H11.7013V4.36453H11.8245L14.0724 0H20Z"
        fill="black"
        fillOpacity="0.2"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20 0L13.6105 12.4481H7.62125L10.2848 7.28446H10.1617C7.97537 10.1429 4.68052 12.0178 0 12.4481V7.3613C0 7.3613 3.00231 7.19225 4.75751 5.33272H0V0H5.34257V4.39527H5.46574L7.65204 0H11.7013V4.36453H11.8245L14.0724 0H20Z"
        fill="black"
        fillOpacity="0.2"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20 0L13.6105 12.4481H7.62125L10.2848 7.28446H10.1617C7.97537 10.1429 4.68052 12.0178 0 12.4481V7.3613C0 7.3613 3.00231 7.19225 4.75751 5.33272H0V0H5.34257V4.39527H5.46574L7.65204 0H11.7013V4.36453H11.8245L14.0724 0H20Z"
        fill="black"
        fillOpacity="0.2"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20 0L13.6105 12.4481H7.62125L10.2848 7.28446H10.1617C7.97537 10.1429 4.68052 12.0178 0 12.4481V7.3613C0 7.3613 3.00231 7.19225 4.75751 5.33272H0V0H5.34257V4.39527H5.46574L7.65204 0H11.7013V4.36453H11.8245L14.0724 0H20Z"
        fill="black"
        fillOpacity="0.2"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20 0L13.6105 12.4481H7.62125L10.2848 7.28446H10.1617C7.97537 10.1429 4.68052 12.0178 0 12.4481V7.3613C0 7.3613 3.00231 7.19225 4.75751 5.33272H0V0H5.34257V4.39527H5.46574L7.65204 0H11.7013V4.36453H11.8245L14.0724 0H20Z"
        fill="black"
        fillOpacity="0.2"
      />
    </g>
    <defs>
      <clipPath id="clip0_10073_15131">
        <rect width="20" height="12.4481" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const ShopifyIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="21"
    viewBox="0 0 18 21"
    fill="none"
    {...props}
  >
    <g clipPath="url(#clip0_10073_33342)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.6121 20.2332L12.5674 3.09606C12.4519 2.98063 12.2265 3.01549 12.1384 3.0412L11.5515 3.22292C11.479 2.98478 11.385 2.75373 11.2706 2.53263C10.8542 1.73834 10.2455 1.31834 9.50872 1.3172H9.50643C9.45724 1.3172 9.40861 1.32177 9.35942 1.32577L9.35369 1.32634C9.33239 1.30013 9.31026 1.27459 9.28734 1.24977C8.96699 0.906915 8.55512 0.739487 8.06202 0.753772C7.11129 0.781201 6.16455 1.46806 5.3963 2.68806C4.85572 3.54692 4.44557 4.6252 4.3283 5.46006L2.456 6.04006C1.90512 6.2132 1.88796 6.23035 1.81531 6.74977C1.76097 7.14292 0.318848 18.2966 0.318848 18.2966L12.405 20.3869L12.6121 20.2332ZM8.65237 1.5372C8.49163 1.43149 8.30342 1.38234 8.08033 1.38692C6.61246 1.4292 5.33223 3.72234 5.0056 5.25034L6.41168 4.81492L6.6628 4.7372C6.847 3.76692 7.30921 2.76006 7.91386 2.11206C8.12528 1.87986 8.37484 1.68545 8.6518 1.5372H8.65237ZM7.35784 4.52177L9.376 3.89663C9.3823 3.37092 9.32509 2.59377 9.06195 2.0452C8.78165 2.16063 8.54597 2.36292 8.37665 2.54406C7.92301 3.03149 7.5529 3.77492 7.35841 4.52177H7.35784ZM10.0081 3.7012L10.9463 3.41034C10.7964 2.92349 10.4406 2.10749 9.71923 1.97034C9.94347 2.5492 10.0012 3.21949 10.0081 3.7012Z"
        fill="#95BF47"
      />
      <path
        d="M15.3199 4.37113C15.2478 4.36541 13.8509 4.3437 13.8509 4.3437C13.8509 4.3437 12.6822 3.20884 12.5667 3.09284C12.5219 3.05159 12.4653 3.02559 12.4048 3.01855V20.3843L17.6418 19.082C17.6418 19.082 15.5047 4.62998 15.491 4.53113C15.4843 4.48914 15.4639 4.45058 15.4328 4.42158C15.4017 4.39258 15.3623 4.37482 15.3199 4.37113Z"
        fill="#5E8E3E"
      />
      <path
        d="M9.50212 7.06781L8.89347 9.34438C8.89347 9.34438 8.21503 9.03524 7.41016 9.08609C6.23061 9.16038 6.21802 9.90495 6.23004 10.0918C6.29411 11.109 8.97184 11.3318 9.12229 13.7164C9.2407 15.5924 8.1275 16.8764 6.52349 16.977C4.59857 17.0987 3.53857 15.9627 3.53857 15.9627L3.94644 14.2267C3.94644 14.2267 5.0133 15.0318 5.86679 14.9775C6.4251 14.9427 6.62417 14.489 6.60415 14.1678C6.52006 12.8404 4.33943 12.9181 4.20157 10.7364C4.08602 8.89924 5.29131 7.03924 7.95189 6.87124C8.97699 6.80609 9.50212 7.06838 9.50212 7.06838"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_10073_33342">
        <rect
          width="17.7333"
          height="20"
          fill="white"
          transform="translate(0.133301 0.586426)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const WordPressIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    {...props}
  >
    <path
      d="M1.42139 9.99956C1.42139 13.3952 3.39478 16.3296 6.25635 17.7202L2.16412 6.5083C1.68812 7.5752 1.42139 8.75588 1.42139 9.99956Z"
      fill="#464342"
    />
    <path
      d="M15.7917 9.5668C15.7917 8.50659 15.4109 7.77236 15.0842 7.20087C14.6494 6.49423 14.2418 5.89581 14.2418 5.18917C14.2418 4.40058 14.8399 3.66652 15.6823 3.66652C15.7204 3.66652 15.7565 3.67125 15.7935 3.67337C14.2672 2.2751 12.2338 1.42139 10.0003 1.42139C7.00327 1.42139 4.36647 2.95906 2.83252 5.28809C3.03379 5.29413 3.22348 5.29837 3.38459 5.29837C4.28192 5.29837 5.67091 5.1895 5.67091 5.1895C6.13337 5.16223 6.18789 5.84145 5.72592 5.89614C5.72592 5.89614 5.26118 5.95082 4.74404 5.97792L7.86811 15.27L9.74551 9.6396L8.40892 5.97759C7.94695 5.95049 7.50931 5.89581 7.50931 5.89581C7.04702 5.86871 7.10121 5.16191 7.5635 5.18917C7.5635 5.18917 8.98025 5.29805 9.82321 5.29805C10.7204 5.29805 12.1095 5.18917 12.1095 5.18917C12.5723 5.16191 12.6267 5.84113 12.1645 5.89581C12.1645 5.89581 11.6988 5.95049 11.1827 5.97759L14.2829 15.1994L15.1386 12.34C15.5095 11.1534 15.7917 10.3012 15.7917 9.5668Z"
      fill="#464342"
    />
    <path
      d="M10.1506 10.75L7.57666 18.2292C8.34519 18.4552 9.15795 18.5787 10.0001 18.5787C10.9991 18.5787 11.9572 18.406 12.8489 18.0925C12.8259 18.0557 12.805 18.0167 12.7879 17.9743L10.1506 10.75Z"
      fill="#464342"
    />
    <path
      d="M17.528 5.88379C17.5649 6.15704 17.5858 6.45038 17.5858 6.76591C17.5858 7.63644 17.4232 8.61503 16.9335 9.83864L14.313 17.4148C16.8634 15.9276 18.5789 13.1645 18.5789 9.99975C18.5791 8.50828 18.1981 7.10576 17.528 5.88379Z"
      fill="#464342"
    />
    <path
      d="M10.0003 0C4.48629 0 0 4.48585 0 9.99975C0 15.5143 4.48629 20 10.0003 20C15.5142 20 20.0011 15.5143 20.0011 9.99975C20.001 4.48585 15.5142 0 10.0003 0ZM10.0003 19.5416C4.73915 19.5416 0.458537 15.2611 0.458537 9.99975C0.458537 4.7387 4.73898 0.458526 10.0003 0.458526C15.2613 0.458526 19.5416 4.7387 19.5416 9.99975C19.5416 15.2611 15.2613 19.5416 10.0003 19.5416Z"
      fill="#464342"
    />
  </svg>
);
